/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * @vestwell-unified-api/hooks
 * hooks for interacting with vestwell-unified-api
 * OpenAPI spec version: 1.45.0
 */ import { faker } from "@faker-js/faker";
import { useMutation, useQuery } from "@tanstack/react-query";
import { http, HttpResponse } from "msw";
import { client } from "./client";
export const WentworthTransactionsGetAllTransactionsTransactionReportingCategoryItem = {
    Conversions: 'Conversions',
    Corrective_Withdrawals: 'Corrective Withdrawals',
    Employer_Contributions: 'Employer Contributions',
    Fees: 'Fees',
    'Forfeitures/Suspense': 'Forfeitures/Suspense',
    'Gain/Losses': 'Gain/Losses',
    Income: 'Income',
    Contribution: 'Contribution',
    Investment_Updates: 'Investment Updates',
    Interest: 'Interest',
    Loan_Disbursements: 'Loan Disbursements',
    Loan_Repayments: 'Loan Repayments',
    Loans: 'Loans',
    Miscellaneous: 'Miscellaneous',
    Operational: 'Operational',
    'Other/Misc': 'Other/Misc',
    Other_Contributions: 'Other Contributions',
    Other_Repayments: 'Other Repayments',
    Rollover: 'Rollover',
    Rollover_Contributions: 'Rollover Contributions',
    Saver_Contributions: 'Saver Contributions',
    Withdrawals: 'Withdrawals'
};
export const WentworthContributionsGetYearlyContributionsFlowReportingCategory = {
    Employer_Contributions: 'Employer Contributions',
    Other_Contributions: 'Other Contributions',
    Rollover_Contributions: 'Rollover Contributions',
    Saver_Contributions: 'Saver Contributions'
};
export const WentworthContributionsGetPendingContributionsFlowReportingCategory = {
    Employer_Contributions: 'Employer Contributions',
    Other_Contributions: 'Other Contributions',
    Saver_Contributions: 'Saver Contributions'
};
export const WentworthContributionsGetContributionDetailsInvestmentReportingCategory = {
    Employer_Contributions: 'Employer Contributions',
    Other_Contributions: 'Other Contributions',
    Rollover_Contributions: 'Rollover Contributions',
    Saver_Contributions: 'Saver Contributions'
};
export const WentworthContributionsGetCompletedContributionsFlowReportingCategory = {
    Employer_Contributions: 'Employer Contributions',
    Other_Contributions: 'Other Contributions',
    Rollover_Contributions: 'Rollover Contributions',
    Saver_Contributions: 'Saver Contributions'
};
export const PortalMiddlewarePostOnboardingSchemaType = {
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    state_conversion: 'state_conversion',
    state_onboarding: 'state_onboarding',
    voya_onboarding: 'voya_onboarding'
};
export const PortalMiddlewareGetOnboardingSchemaType = {
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    state_conversion: 'state_conversion',
    state_onboarding: 'state_onboarding',
    voya_onboarding: 'voya_onboarding'
};
export const PortalMiddlewareGetPlanParticipantsSort = {
    balance: 'balance',
    investment: 'investment',
    lastName: 'lastName',
    name: 'name'
};
export const PortalMiddlewareGetAgeBasedModelType = {
    nli: 'nli',
    target: 'target'
};
export const PortalMiddlewareGetEmployeePendingTransactionsExcludeDistributionMethods = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const PortalMiddlewareGetEmployeePerformanceExcludeDistributionMethods = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const PortalMiddlewareGetEmployeeLoansExcludeDistributionMethods = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const PortalMiddlewareGetEmployeeHoldingsExcludeDistributionMethods = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const OnboardingDocumentGetSigningMappingsStatus = {
    pending: 'pending',
    signed: 'signed',
    void: 'void'
};
export const VssStatusStatus = {
    none: 'none',
    normal: 'normal',
    readOnly: 'readOnly',
    unknown: 'unknown'
};
export const VssPlanType = {
    able: 'able',
    collegeSavings: 'collegeSavings',
    secureChoice: 'secureChoice'
};
export const RolloverDeliveryDtoMailType = {
    Express_Mail: 'Express Mail',
    Normal_Mail: 'Normal Mail'
};
export const RecurringGiftParametersOccasion = {
    birthday: 'birthday',
    congratulations: 'congratulations',
    'get-well': 'get-well',
    graduation: 'graduation',
    holiday: 'holiday',
    'just-because': 'just-because'
};
export const RecurringGiftFrequency = {
    biMonthly: 'biMonthly',
    monthly: 'monthly',
    yearly: 'yearly'
};
export const PostWithdrawalBodyDtoReason = {
    ACP_CORRECTIVE: 'ACP_CORRECTIVE',
    ADP_CORRECTIVE: 'ADP_CORRECTIVE',
    CASH_OUT: 'CASH_OUT',
    CHILD: 'CHILD',
    DEATH: 'DEATH',
    '402G': '402G',
    DISABILITY: 'DISABILITY',
    EACA: 'EACA',
    FEE_OUT: 'FEE_OUT',
    FORCE_OUT: 'FORCE_OUT',
    ESA: 'ESA',
    HARDSHIP: 'HARDSHIP',
    IN_SERVICE: 'IN_SERVICE',
    NUMBER_415: '415',
    PARTICIPANT_TERMINATION: 'PARTICIPANT_TERMINATION',
    PLAN_TERMINATION: 'PLAN_TERMINATION',
    QACA: 'QACA',
    QDRO: 'QDRO',
    REQUIRED_MINIMUM: 'REQUIRED_MINIMUM',
    RETIREMENT_AGE: 'RETIREMENT_AGE',
    ROLLOVER: 'ROLLOVER'
};
export const PostWithdrawalBodyDtoDistributionMethod = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
export const PostSubaInitiateExternalTransferBodyDtoExternalTransferType = {
    transferFromExternal: 'transferFromExternal',
    transferToExternal: 'transferToExternal'
};
export const PostParticipantPlaidLinksBalanceResDtoPlaidAccountType = {
    brokerage: 'brokerage',
    credit: 'credit',
    depository: 'depository',
    investment: 'investment',
    loan: 'loan',
    other: 'other'
};
export const PostParticipantPlaidLinksBalanceResDtoPlaidAccountSubtype = {
    '401a': '401a',
    '401k': '401k',
    '403B': '403B',
    '457b': '457b',
    NUMBER_529: '529',
    brokerage: 'brokerage',
    cash_isa: 'cash isa',
    crypto_exchange: 'crypto exchange',
    ebt: 'ebt',
    education_savings_account: 'education savings account',
    fixed_annuity: 'fixed annuity',
    gic: 'gic',
    health_reimbursement_arrangement: 'health reimbursement arrangement',
    hsa: 'hsa',
    ira: 'ira',
    isa: 'isa',
    lif: 'lif',
    life_insurance: 'life insurance',
    lira: 'lira',
    lrif: 'lrif',
    lrsp: 'lrsp',
    'non-custodial_wallet': 'non-custodial wallet',
    'non-taxable_brokerage_account': 'non-taxable brokerage account',
    other: 'other',
    other_annuity: 'other annuity',
    other_insurance: 'other insurance',
    pension: 'pension',
    prif: 'prif',
    profit_sharing_plan: 'profit sharing plan',
    rdsp: 'rdsp',
    resp: 'resp',
    retirement: 'retirement',
    rlif: 'rlif',
    roth: 'roth',
    roth_401k: 'roth 401k',
    rrif: 'rrif',
    credit_card: 'credit card',
    rrsp: 'rrsp',
    cd: 'cd',
    sep_ira: 'sep ira',
    checking: 'checking',
    simple_ira: 'simple ira',
    money_market: 'money market',
    sipp: 'sipp',
    auto: 'auto',
    stock_plan: 'stock plan',
    business: 'business',
    tfsa: 'tfsa',
    commercial: 'commercial',
    thrift_savings_plan: 'thrift savings plan',
    construction: 'construction',
    trust: 'trust',
    consumer: 'consumer',
    ugma: 'ugma',
    home_equity: 'home equity',
    variable_annuity: 'variable annuity',
    cash_management: 'cash management',
    paypal: 'paypal',
    keogh: 'keogh',
    line_of_credit: 'line of credit',
    savings: 'savings',
    loan: 'loan',
    prepaid: 'prepaid',
    mortgage: 'mortgage',
    mutual_fund: 'mutual fund',
    null: 'null',
    overdraft: 'overdraft',
    payroll: 'payroll',
    recurring: 'recurring',
    rewards: 'rewards',
    safe_deposit: 'safe deposit',
    sarsep: 'sarsep',
    student: 'student'
};
export const PostMsManagedAccountsPreviewAllocationBodyDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const PostMsManagedAccountsActivateBodyDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const PostMsManagedAccounts401KManagerQuestionnaireResDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const PostCensusCacheBodyDtoSchemaType = {
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    state_conversion: 'state_conversion',
    state_onboarding: 'state_onboarding',
    voya_onboarding: 'voya_onboarding'
};
export const PlanParticipantEligibilityStatus = {
    '': '',
    Awaiting_Entry_Date: 'Awaiting Entry Date',
    Awaiting_entry_date: 'Awaiting entry date',
    Eligible: 'Eligible',
    Ineligible: 'Ineligible',
    Terminated: 'Terminated',
    Terminated_With_Balance: 'Terminated With Balance',
    Terminated_with_balance: 'Terminated with balance'
};
export const PdfConfigDtoFormat = {
    a0: 'a0',
    a1: 'a1',
    a2: 'a2',
    a3: 'a3',
    a4: 'a4',
    a5: 'a5',
    ledger: 'ledger',
    a6: 'a6',
    legal: 'legal',
    letter: 'letter',
    tabloid: 'tabloid'
};
export const PatchStatefulSchemaTrackingStatusBodyDtoStatus = {
    completed_successfully: 'completed_successfully',
    completed_unsuccessfully: 'completed_unsuccessfully',
    in_progress: 'in_progress',
    needs_attention: 'needs_attention',
    new: 'new',
    ongoing: 'ongoing'
};
export const PatchSponsorQuestionnaireDtoOnboardingPlanDesignCallStatus = {
    Plan_Design_Call_Delayed: 'Plan Design Call Delayed',
    Plan_Design_Call_Scheduled: 'Plan Design Call Scheduled'
};
export const PatchPlanDesignConsultStateResDtoPlanDesignConsultType = {
    Full_Consultation: 'Full Consultation',
    Partner_Consultation: 'Partner Consultation',
    Sales_Consultation: 'Sales Consultation',
    Self_Service_Tiles: 'Self Service Tiles',
    'Solo(K)': 'Solo(K)',
    Website_Direct: 'Website Direct'
};
export const PatchPlanDesignConsultStateDtoPlanDesignConsultType = {
    Full_Consultation: 'Full Consultation',
    Partner_Consultation: 'Partner Consultation',
    Sales_Consultation: 'Sales Consultation',
    Self_Service_Tiles: 'Self Service Tiles',
    'Solo(K)': 'Solo(K)',
    Website_Direct: 'Website Direct'
};
export const PatchEsaWithdrawalBodyDtoEsaReason = {
    AUTOMOBILE: 'AUTOMOBILE',
    FUNERAL: 'FUNERAL',
    MEDICAL: 'MEDICAL',
    NOT_SAY: 'NOT_SAY',
    OTHER: 'OTHER',
    REPAIR_RESIDENCE: 'REPAIR_RESIDENCE',
    TUITION_EDUCATION: 'TUITION_EDUCATION'
};
export const ParticipantInvestmentsModelDtoModelType = {
    goal: 'goal',
    menu: 'menu',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli',
    pmenu: 'pmenu',
    risk: 'risk',
    target: 'target'
};
export const ParticipantInvestmentElectionRiskProfile = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const ParticipantCostBasisAttributesCostType = {
    aftertax: 'aftertax',
    roth: 'roth'
};
export const ParticipantMaritalStatus = {
    '': '',
    Divorced: 'Divorced',
    Single: 'Single',
    Widowed: 'Widowed',
    head_of_household: 'head_of_household',
    married: 'married',
    qualified_widower: 'qualified_widower',
    single: 'single'
};
export const ModelWithPerformanceModelType = {
    goal: 'goal',
    menu: 'menu',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli',
    pmenu: 'pmenu',
    risk: 'risk',
    target: 'target'
};
export const ModelModelType = {
    goal: 'goal',
    menu: 'menu',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli',
    pmenu: 'pmenu',
    risk: 'risk',
    target: 'target'
};
export const GiftSubmissionBodyDtoOccasion = {
    birthday: 'birthday',
    congratulations: 'congratulations',
    'get-well': 'get-well',
    graduation: 'graduation',
    holiday: 'holiday',
    'just-because': 'just-because'
};
export const GiftSubmissionBodyDtoFrequency = {
    biMonthly: 'biMonthly',
    monthly: 'monthly',
    yearly: 'yearly'
};
export const GiftPaymentMethod = {
    ach: 'ach',
    debit: 'debit'
};
export const GiftPaymentAccountType = {
    checking: 'checking',
    prepaid: 'prepaid',
    savings: 'savings'
};
export const GiftContributorBankBankAccountType = {
    checking: 'checking',
    prepaid: 'prepaid',
    savings: 'savings'
};
export const GetTransactionResDtoTransactionBaseType = {
    BUY: 'BUY',
    DEPOSIT: 'DEPOSIT',
    FEE: 'FEE',
    FEEREVERSAL: 'FEEREVERSAL',
    INCOMEIN: 'INCOMEIN',
    INCOMEOUT: 'INCOMEOUT',
    SELL: 'SELL',
    TRANSFERIN: 'TRANSFERIN',
    TRANSFEROUT: 'TRANSFEROUT',
    WITHDRAWAL: 'WITHDRAWAL'
};
export const GetTransactionResDtoStatus = {
    CONFIRMED: 'CONFIRMED',
    REVERSED: 'REVERSED'
};
export const GetTransactionResDtoSecurityOrderType = {
    DOLLAR_ALL: 'DOLLAR_ALL',
    DOLLAR_ORDER: 'DOLLAR_ORDER',
    UNIT_ALL: 'UNIT_ALL',
    UNIT_ORDER: 'UNIT_ORDER'
};
export const GetTransactionResDtoFlowReportingCategory = {
    Conversions: 'Conversions',
    Corrective_Withdrawals: 'Corrective Withdrawals',
    Employer_Contributions: 'Employer Contributions',
    Fees: 'Fees',
    'Forfeitures/Suspense': 'Forfeitures/Suspense',
    'Gain/Losses': 'Gain/Losses',
    Income: 'Income',
    Contribution: 'Contribution',
    Investment_Updates: 'Investment Updates',
    Interest: 'Interest',
    Loan_Disbursements: 'Loan Disbursements',
    Loan_Repayments: 'Loan Repayments',
    Loans: 'Loans',
    Miscellaneous: 'Miscellaneous',
    Operational: 'Operational',
    'Other/Misc': 'Other/Misc',
    Other_Contributions: 'Other Contributions',
    Other_Repayments: 'Other Repayments',
    Rollover: 'Rollover',
    Rollover_Contributions: 'Rollover Contributions',
    Saver_Contributions: 'Saver Contributions',
    Withdrawals: 'Withdrawals'
};
export const GetTransactionResDtoByInvestmentReportingCategory = {
    Conversions: 'Conversions',
    Corrective_Withdrawals: 'Corrective Withdrawals',
    Employer_Contributions: 'Employer Contributions',
    Fees: 'Fees',
    'Forfeitures/Suspense': 'Forfeitures/Suspense',
    'Gain/Losses': 'Gain/Losses',
    Income: 'Income',
    Contribution: 'Contribution',
    Investment_Updates: 'Investment Updates',
    Interest: 'Interest',
    Loan_Disbursements: 'Loan Disbursements',
    Loan_Repayments: 'Loan Repayments',
    Loans: 'Loans',
    Miscellaneous: 'Miscellaneous',
    Operational: 'Operational',
    'Other/Misc': 'Other/Misc',
    Other_Contributions: 'Other Contributions',
    Other_Repayments: 'Other Repayments',
    Rollover: 'Rollover',
    Rollover_Contributions: 'Rollover Contributions',
    Saver_Contributions: 'Saver Contributions',
    Withdrawals: 'Withdrawals'
};
export const GetTransactionResDtoAccountLevel = {
    PARENT_ACCOUNT: 'PARENT_ACCOUNT',
    SUB_ACCOUNT: 'SUB_ACCOUNT'
};
export const GetSigningMappingsResDtoStatus = {
    pending: 'pending',
    signed: 'signed',
    void: 'void'
};
export const GetPlanStatisticsModelAgeDistributionModelType = {
    goal: 'goal',
    menu: 'menu',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli',
    pmenu: 'pmenu',
    risk: 'risk',
    target: 'target'
};
export const GetPlanStatisticsModelAgeDistributionAgeRange = {
    '26-35': '26-35',
    '36-45': '36-45',
    '46-55': '46-55',
    '56-65': '56-65',
    '<=25': '<=25',
    '>=66': '>=66'
};
export const GetPlanDesignConsultStateResDtoPlanDesignConsultType = {
    Full_Consultation: 'Full Consultation',
    Partner_Consultation: 'Partner Consultation',
    Sales_Consultation: 'Sales Consultation',
    Self_Service_Tiles: 'Self Service Tiles',
    'Solo(K)': 'Solo(K)',
    Website_Direct: 'Website Direct'
};
export const GetPendingWithdrawalsResDtoStatus = {
    Canceled: 'Canceled',
    Disbursed: 'Disbursed',
    Fraud_Check_Complete: 'Fraud Check Complete',
    IRA_Established: 'IRA Established',
    Pending: 'Pending',
    Processing: 'Processing',
    Rejected: 'Rejected',
    Reversed: 'Reversed'
};
export const GetPendingRolloversResDtoFlowReportingCategory = {
    'Pre-Tax_Rollover': 'Pre-Tax Rollover',
    Rollover: 'Rollover',
    Roth_Rollover: 'Roth Rollover'
};
export const GetPendingContributionsResDtoStatus = {
    cancelled: 'cancelled',
    confirmed: 'confirmed',
    deleted: 'deleted',
    pending: 'pending'
};
export const GetPendingContributionsResDtoSecurityOrderType = {
    DOLLAR_ALL: 'DOLLAR_ALL',
    DOLLAR_ORDER: 'DOLLAR_ORDER',
    UNIT_ALL: 'UNIT_ALL',
    UNIT_ORDER: 'UNIT_ORDER'
};
export const GetPendingContributionsResDtoFlowReportingCategory = {
    Employer_Contributions: 'Employer Contributions',
    Other_Contributions: 'Other Contributions',
    Saver_Contributions: 'Saver Contributions'
};
export const GetPendingContributionsResDtoAccountLevel = {
    PARENT_ACCOUNT: 'PARENT_ACCOUNT',
    SUB_ACCOUNT: 'SUB_ACCOUNT'
};
export const GetParticipantLoanCreateLoanPreferencesAllowedPayFrequenciesItem = {
    B: 'B',
    M: 'M',
    ME: 'ME',
    S: 'S',
    SC: 'SC',
    W: 'W'
};
export const GetParticipantLoanCreateLoanPreferencesAllowedLoanPurposesItem = {
    General: 'General',
    Principal_Residence_Purchase: 'Principal Residence Purchase'
};
export const GetParticipantBeneficiariesResDtoRelationship = {
    child: 'child',
    other: 'other',
    parent: 'parent',
    spouse: 'spouse'
};
export const GetParticipantBeneficiariesResDtoBeneficiaryType = {
    organization: 'organization',
    person: 'person',
    trust: 'trust'
};
export const GetOnboardingDtoStatus = {
    completed_successfully: 'completed_successfully',
    completed_unsuccessfully: 'completed_unsuccessfully',
    in_progress: 'in_progress',
    needs_attention: 'needs_attention',
    new: 'new',
    ongoing: 'ongoing'
};
export const GetMsManagedAccountsPreviewAllocationResDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
export const GetCanceledRolloversResDtoFlowReportingCategory = {
    'Pre-Tax_Rollover': 'Pre-Tax Rollover',
    Rollover: 'Rollover',
    Roth_Rollover: 'Roth Rollover'
};
export const CompletedContributionDtoStatus = {
    CONFIRMED: 'CONFIRMED',
    REVERSED: 'REVERSED'
};
export const CompletedContributionDtoSecurityOrderType = {
    DOLLAR_ALL: 'DOLLAR_ALL',
    DOLLAR_ORDER: 'DOLLAR_ORDER',
    UNIT_ALL: 'UNIT_ALL',
    UNIT_ORDER: 'UNIT_ORDER'
};
export const CompletedContributionDtoFlowReportingCategory = {
    Employer_Contributions: 'Employer Contributions',
    Other_Contributions: 'Other Contributions',
    Rollover_Contributions: 'Rollover Contributions',
    Saver_Contributions: 'Saver Contributions'
};
export const CompletedContributionDtoAccountLevel = {
    PARENT_ACCOUNT: 'PARENT_ACCOUNT',
    SUB_ACCOUNT: 'SUB_ACCOUNT'
};
export const CensusValidationEmployeesMaritalStatus = {
    '': '',
    Divorced: 'Divorced',
    Single: 'Single',
    Widowed: 'Widowed',
    head_of_household: 'head_of_household',
    married: 'married',
    qualified_widower: 'qualified_widower',
    single: 'single'
};
export const AgeBasedBodyDtoModelType = {
    nli: 'nli',
    target: 'target'
};
export const ActivitySummaryDtoGroupByCategory = {
    Conversions: 'Conversions',
    Corrective_Withdrawals: 'Corrective Withdrawals',
    Employer_Contributions: 'Employer Contributions',
    Fees: 'Fees',
    'Forfeitures/Suspense': 'Forfeitures/Suspense',
    'Gain/Losses': 'Gain/Losses',
    Income: 'Income',
    Investment_Updates: 'Investment Updates',
    Loan_Disbursements: 'Loan Disbursements',
    Loan_Repayments: 'Loan Repayments',
    Miscellaneous: 'Miscellaneous',
    Operational: 'Operational',
    Other_Contributions: 'Other Contributions',
    Other_Repayments: 'Other Repayments',
    Rollover_Contributions: 'Rollover Contributions',
    Saver_Contributions: 'Saver Contributions',
    Withdrawals: 'Withdrawals'
};
export const payrollIntegrationsPostProviderAuthorizationFromCompanyId = (gustoProviderAuthDto)=>{
    return client({
        data: gustoProviderAuthDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/api/v2/gusto/oauth/grant`
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return payrollIntegrationsPostProviderAuthorizationFromCompanyId(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePayrollIntegrationsPostProviderAuthorizationFromCompanyId = (options)=>{
    const mutationOptions = getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const payrollIntegrationsDeleteProviderAuthorizationFromCompanyId = (gustoProviderRevokeDto)=>{
    return client({
        data: gustoProviderRevokeDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/api/v2/gusto/oauth/revoke`
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return payrollIntegrationsDeleteProviderAuthorizationFromCompanyId(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePayrollIntegrationsDeleteProviderAuthorizationFromCompanyId = (options)=>{
    const mutationOptions = getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const healthGetConnectivity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/connectivity`
    });
};
export const getHealthGetConnectivityQueryKey = ()=>{
    return [
        `/connectivity`
    ];
};
export const getHealthGetConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getHealthGetConnectivityQueryKey();
    const queryFn = ({ signal })=>healthGetConnectivity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useHealthGetConnectivity(options) {
    const queryOptions = getHealthGetConnectivityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const healthPostDemoSDK = (introspectReqDto)=>{
    return client({
        data: introspectReqDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/demo-sdk`
    });
};
export const getHealthPostDemoSDKMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return healthPostDemoSDK(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useHealthPostDemoSDK = (options)=>{
    const mutationOptions = getHealthPostDemoSDKMutationOptions(options);
    return useMutation(mutationOptions);
};
export const healthGetHealth = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/health`
    });
};
export const getHealthGetHealthQueryKey = ()=>{
    return [
        `/health`
    ];
};
export const getHealthGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getHealthGetHealthQueryKey();
    const queryFn = ({ signal })=>healthGetHealth(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useHealthGetHealth(options) {
    const queryOptions = getHealthGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingCensusPostValidation = (schemaType, censusValidationReqDto)=>{
    return client({
        data: censusValidationReqDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/ob/census/validation/${schemaType}`
    });
};
export const getOnboardingCensusPostValidationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { schemaType, data } = props ?? {};
        return onboardingCensusPostValidation(schemaType, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingCensusPostValidation = (options)=>{
    const mutationOptions = getOnboardingCensusPostValidationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingHealthGetConnectivity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/connectivity`
    });
};
export const getOnboardingHealthGetConnectivityQueryKey = ()=>{
    return [
        `/ob/connectivity`
    ];
};
export const getOnboardingHealthGetConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingHealthGetConnectivityQueryKey();
    const queryFn = ({ signal })=>onboardingHealthGetConnectivity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingHealthGetConnectivity(options) {
    const queryOptions = getOnboardingHealthGetConnectivityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingContributionPostContribution = ()=>{
    return client({
        method: 'POST',
        url: `/ob/contributions`
    });
};
export const getOnboardingContributionPostContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return onboardingContributionPostContribution();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingContributionPostContribution = (options)=>{
    const mutationOptions = getOnboardingContributionPostContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingContributionPostIngestionFlowStart = (ucid)=>{
    return client({
        method: 'POST',
        url: `/ob/contributions/${ucid}/start`
    });
};
export const getOnboardingContributionPostIngestionFlowStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return onboardingContributionPostIngestionFlowStart(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingContributionPostIngestionFlowStart = (options)=>{
    const mutationOptions = getOnboardingContributionPostIngestionFlowStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingHealthPostDemoSdk = (demoReqDto)=>{
    return client({
        data: demoReqDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/ob/demo-sdk`
    });
};
export const getOnboardingHealthPostDemoSdkMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return onboardingHealthPostDemoSdk(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingHealthPostDemoSdk = (options)=>{
    const mutationOptions = getOnboardingHealthPostDemoSdkMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingDocumentGetSigningMappings = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/ob/document/signing-mappings`
    });
};
export const getOnboardingDocumentGetSigningMappingsQueryKey = (params)=>{
    return [
        `/ob/document/signing-mappings`,
        ...params ? [
            params
        ] : []
    ];
};
export const getOnboardingDocumentGetSigningMappingsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocumentGetSigningMappingsQueryKey(params);
    const queryFn = ({ signal })=>onboardingDocumentGetSigningMappings(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocumentGetSigningMappings(params, options) {
    const queryOptions = getOnboardingDocumentGetSigningMappingsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetAuthenticate = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/auth`
    });
};
export const getOnboardingDocusignGetAuthenticateQueryKey = ()=>{
    return [
        `/ob/docusign/auth`
    ];
};
export const getOnboardingDocusignGetAuthenticateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetAuthenticateQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetAuthenticate(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetAuthenticate(options) {
    const queryOptions = getOnboardingDocusignGetAuthenticateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetDocusignConnectivity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/connectivity`
    });
};
export const getOnboardingDocusignGetDocusignConnectivityQueryKey = ()=>{
    return [
        `/ob/docusign/connectivity`
    ];
};
export const getOnboardingDocusignGetDocusignConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetDocusignConnectivityQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetDocusignConnectivity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetDocusignConnectivity(options) {
    const queryOptions = getOnboardingDocusignGetDocusignConnectivityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetDocusignEnvelopeWsdl = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/envelope-ingestion-wsdl`
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlQueryKey = ()=>{
    return [
        `/ob/docusign/envelope-ingestion-wsdl`
    ];
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetDocusignEnvelopeWsdlQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetDocusignEnvelopeWsdl(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetDocusignEnvelopeWsdl(options) {
    const queryOptions = getOnboardingDocusignGetDocusignEnvelopeWsdlQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetEnvelopes = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/envelopes`
    });
};
export const getOnboardingDocusignGetEnvelopesQueryKey = ()=>{
    return [
        `/ob/docusign/envelopes`
    ];
};
export const getOnboardingDocusignGetEnvelopesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetEnvelopesQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetEnvelopes(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetEnvelopes(options) {
    const queryOptions = getOnboardingDocusignGetEnvelopesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetEnvelope = (envelopeId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/envelopes/${envelopeId}`
    });
};
export const getOnboardingDocusignGetEnvelopeQueryKey = (envelopeId)=>{
    return [
        `/ob/docusign/envelopes/${envelopeId}`
    ];
};
export const getOnboardingDocusignGetEnvelopeQueryOptions = (envelopeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetEnvelopeQueryKey(envelopeId);
    const queryFn = ({ signal })=>onboardingDocusignGetEnvelope(envelopeId, signal);
    return {
        enabled: !!envelopeId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetEnvelope(envelopeId, options) {
    const queryOptions = getOnboardingDocusignGetEnvelopeQueryOptions(envelopeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetEnvelopeRecipients = (envelopeId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/envelopes/${envelopeId}/signers`
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsQueryKey = (envelopeId)=>{
    return [
        `/ob/docusign/envelopes/${envelopeId}/signers`
    ];
};
export const getOnboardingDocusignGetEnvelopeRecipientsQueryOptions = (envelopeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetEnvelopeRecipientsQueryKey(envelopeId);
    const queryFn = ({ signal })=>onboardingDocusignGetEnvelopeRecipients(envelopeId, signal);
    return {
        enabled: !!envelopeId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetEnvelopeRecipients(envelopeId, options) {
    const queryOptions = getOnboardingDocusignGetEnvelopeRecipientsQueryOptions(envelopeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignPostEnvelopeRecipient = (envelopeId, postEnvelopeRecipientBodyDto)=>{
    return client({
        data: postEnvelopeRecipientBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/ob/docusign/envelopes/${envelopeId}/views/recipient`
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { envelopeId, data } = props ?? {};
        return onboardingDocusignPostEnvelopeRecipient(envelopeId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingDocusignPostEnvelopeRecipient = (options)=>{
    const mutationOptions = getOnboardingDocusignPostEnvelopeRecipientMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingDocusignGetRedirect = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/redirect`
    });
};
export const getOnboardingDocusignGetRedirectQueryKey = ()=>{
    return [
        `/ob/docusign/redirect`
    ];
};
export const getOnboardingDocusignGetRedirectQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetRedirectQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetRedirect(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetRedirect(options) {
    const queryOptions = getOnboardingDocusignGetRedirectQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignGetAccessToken = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/token`
    });
};
export const getOnboardingDocusignGetAccessTokenQueryKey = ()=>{
    return [
        `/ob/docusign/token`
    ];
};
export const getOnboardingDocusignGetAccessTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetAccessTokenQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetAccessToken(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetAccessToken(options) {
    const queryOptions = getOnboardingDocusignGetAccessTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingDocusignPostTriggerDocusignEnvelope = (postTriggerEnvelopeIngestionBodyDto)=>{
    return client({
        data: postTriggerEnvelopeIngestionBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/ob/docusign/trigger-envelope-ingestion`
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return onboardingDocusignPostTriggerDocusignEnvelope(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingDocusignPostTriggerDocusignEnvelope = (options)=>{
    const mutationOptions = getOnboardingDocusignPostTriggerDocusignEnvelopeMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingDocusignGetUserInfo = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/docusign/user-info`
    });
};
export const getOnboardingDocusignGetUserInfoQueryKey = ()=>{
    return [
        `/ob/docusign/user-info`
    ];
};
export const getOnboardingDocusignGetUserInfoQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingDocusignGetUserInfoQueryKey();
    const queryFn = ({ signal })=>onboardingDocusignGetUserInfo(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingDocusignGetUserInfo(options) {
    const queryOptions = getOnboardingDocusignGetUserInfoQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingHealthGetHealth = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/health`
    });
};
export const getOnboardingHealthGetHealthQueryKey = ()=>{
    return [
        `/ob/health`
    ];
};
export const getOnboardingHealthGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingHealthGetHealthQueryKey();
    const queryFn = ({ signal })=>onboardingHealthGetHealth(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingHealthGetHealth(options) {
    const queryOptions = getOnboardingHealthGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingPizzaTrackerGetMultiplePizzaTrackers = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/ob/pizza-tracker/multiple`
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersQueryKey = (params)=>{
    return [
        `/ob/pizza-tracker/multiple`,
        ...params ? [
            params
        ] : []
    ];
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingPizzaTrackerGetMultiplePizzaTrackersQueryKey(params);
    const queryFn = ({ signal })=>onboardingPizzaTrackerGetMultiplePizzaTrackers(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingPizzaTrackerGetMultiplePizzaTrackers(params, options) {
    const queryOptions = getOnboardingPizzaTrackerGetMultiplePizzaTrackersQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingPizzaTrackerGetPizzaTracker = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/pizza-tracker/${planId}`
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerQueryKey = (planId)=>{
    return [
        `/ob/pizza-tracker/${planId}`
    ];
};
export const getOnboardingPizzaTrackerGetPizzaTrackerQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingPizzaTrackerGetPizzaTrackerQueryKey(planId);
    const queryFn = ({ signal })=>onboardingPizzaTrackerGetPizzaTracker(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingPizzaTrackerGetPizzaTracker(planId, options) {
    const queryOptions = getOnboardingPizzaTrackerGetPizzaTrackerQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const onboardingRecordkeepingPostToCustodian = (postToCustodianDto)=>{
    return client({
        data: postToCustodianDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/ob/recordkeeping/ship-to-custodian`
    });
};
export const getOnboardingRecordkeepingPostToCustodianMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return onboardingRecordkeepingPostToCustodian(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingRecordkeepingPostToCustodian = (options)=>{
    const mutationOptions = getOnboardingRecordkeepingPostToCustodianMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingSalesforcePostLaunchDocusignFlow = (launchDocusignFlowDto)=>{
    return client({
        data: launchDocusignFlowDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/ob/salesforce/flow/launch`
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return onboardingSalesforcePostLaunchDocusignFlow(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingSalesforcePostLaunchDocusignFlow = (options)=>{
    const mutationOptions = getOnboardingSalesforcePostLaunchDocusignFlowMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingSalesforcePostLogout = ()=>{
    return client({
        method: 'POST',
        url: `/ob/salesforce/logout`
    });
};
export const getOnboardingSalesforcePostLogoutMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return onboardingSalesforcePostLogout();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useOnboardingSalesforcePostLogout = (options)=>{
    const mutationOptions = getOnboardingSalesforcePostLogoutMutationOptions(options);
    return useMutation(mutationOptions);
};
export const onboardingSalesforceGetRecord = (objectName, id, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/ob/salesforce/record/${objectName}/${id}`
    });
};
export const getOnboardingSalesforceGetRecordQueryKey = (objectName, id)=>{
    return [
        `/ob/salesforce/record/${objectName}/${id}`
    ];
};
export const getOnboardingSalesforceGetRecordQueryOptions = (objectName, id, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOnboardingSalesforceGetRecordQueryKey(objectName, id);
    const queryFn = ({ signal })=>onboardingSalesforceGetRecord(objectName, id, signal);
    return {
        enabled: !!(objectName && id),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useOnboardingSalesforceGetRecord(objectName, id, options) {
    const queryOptions = getOnboardingSalesforceGetRecordQueryOptions(objectName, id, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const payrollIntegrationsPostGustoWebhookEvent = ()=>{
    return client({
        method: 'POST',
        url: `/payrollIntegrations/gusto/events`
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return payrollIntegrationsPostGustoWebhookEvent();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePayrollIntegrationsPostGustoWebhookEvent = (options)=>{
    const mutationOptions = getPayrollIntegrationsPostGustoWebhookEventMutationOptions(options);
    return useMutation(mutationOptions);
};
export const payrollIntegrationsPostVestwellWebhookEvent = ()=>{
    return client({
        method: 'POST',
        url: `/payrollIntegrations/vestwell/events`
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return payrollIntegrationsPostVestwellWebhookEvent();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePayrollIntegrationsPostVestwellWebhookEvent = (options)=>{
    const mutationOptions = getPayrollIntegrationsPostVestwellWebhookEventMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetAdvisorById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor`
    });
};
export const getPortalMiddlewareGetAdvisorByIdQueryKey = (params)=>{
    return [
        `/pm/api/advisor`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorById(params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorCommercialPlatforms = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/commercial-platforms`
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsQueryKey = (params)=>{
    return [
        `/pm/api/advisor/commercial-platforms`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorCommercialPlatformsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorCommercialPlatforms(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorCommercialPlatforms(params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorCommercialPlatformsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorContactCard = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/advisor/contact-card`
    });
};
export const getPortalMiddlewareGetAdvisorContactCardQueryKey = ()=>{
    return [
        `/pm/api/advisor/contact-card`
    ];
};
export const getPortalMiddlewareGetAdvisorContactCardQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorContactCardQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorContactCard(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorContactCard(options) {
    const queryOptions = getPortalMiddlewareGetAdvisorContactCardQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutAdvisorContactCard = (advisorContactCardBodyDto)=>{
    return client({
        data: advisorContactCardBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/advisor/contact-card`
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutAdvisorContactCard(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutAdvisorContactCard = (options)=>{
    const mutationOptions = getPortalMiddlewarePutAdvisorContactCardMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlans = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/plans`
    });
};
export const getPortalMiddlewareGetPlansQueryKey = (params)=>{
    return [
        `/pm/api/advisor/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlansQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlans(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlans(params, options) {
    const queryOptions = getPortalMiddlewareGetPlansQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorAnnualTestingPlansPerYear = (year, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/plans/annual-testing/${year}`
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearQueryKey = (year, params)=>{
    return [
        `/pm/api/advisor/plans/annual-testing/${year}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearQueryOptions = (year, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearQueryKey(year, params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorAnnualTestingPlansPerYear(year, params, signal);
    return {
        enabled: !!year,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorAnnualTestingPlansPerYear(year, params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearQueryOptions(year, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlansTracker = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/plans/tracker`
    });
};
export const getPortalMiddlewareGetPlansTrackerQueryKey = (params)=>{
    return [
        `/pm/api/advisor/plans/tracker`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlansTrackerQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlansTrackerQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlansTracker(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlansTracker(params, options) {
    const queryOptions = getPortalMiddlewareGetPlansTrackerQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorPlanEmployees = (planId, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/plans/${planId}/employees`
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesQueryKey = (planId, params)=>{
    return [
        `/pm/api/advisor/plans/${planId}/employees`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesQueryOptions = (planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorPlanEmployeesQueryKey(planId, params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorPlanEmployees(planId, params, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorPlanEmployees(planId, params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorPlanEmployeesQueryOptions(planId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanEmployee = (planId, employeeId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/advisor/plans/${planId}/employees/${employeeId}`
    });
};
export const getPortalMiddlewareGetPlanEmployeeQueryKey = (planId, employeeId)=>{
    return [
        `/pm/api/advisor/plans/${planId}/employees/${employeeId}`
    ];
};
export const getPortalMiddlewareGetPlanEmployeeQueryOptions = (planId, employeeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanEmployeeQueryKey(planId, employeeId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanEmployee(planId, employeeId, signal);
    return {
        enabled: !!(planId && employeeId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanEmployee(planId, employeeId, options) {
    const queryOptions = getPortalMiddlewareGetPlanEmployeeQueryOptions(planId, employeeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorPlanStatistics = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/advisor/plans/${planId}/stats`
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsQueryKey = (planId)=>{
    return [
        `/pm/api/advisor/plans/${planId}/stats`
    ];
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorPlanStatisticsQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorPlanStatistics(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorPlanStatistics(planId, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorPlanStatisticsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostLinkSponsor = (advisorSponsorLinksBody)=>{
    return client({
        data: advisorSponsorLinksBody,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/advisor/sponsors/link`
    });
};
export const getPortalMiddlewarePostLinkSponsorMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostLinkSponsor(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostLinkSponsor = (options)=>{
    const mutationOptions = getPortalMiddlewarePostLinkSponsorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetAdvisorStats = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/advisor/statistics`
    });
};
export const getPortalMiddlewareGetAdvisorStatsQueryKey = (params)=>{
    return [
        `/pm/api/advisor/statistics`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorStatsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorStatsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorStats(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorStats(params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorStatsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCarousel = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/carousel`
    });
};
export const getPortalMiddlewareGetCarouselQueryKey = ()=>{
    return [
        `/pm/api/carousel`
    ];
};
export const getPortalMiddlewareGetCarouselQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCarouselQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetCarousel(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCarousel(options) {
    const queryOptions = getPortalMiddlewareGetCarouselQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetConnectivity = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/connectivity`
    });
};
export const getPortalMiddlewareGetConnectivityQueryKey = (params)=>{
    return [
        `/pm/api/connectivity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetConnectivityQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetConnectivityQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetConnectivity(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetConnectivity(params, options) {
    const queryOptions = getPortalMiddlewareGetConnectivityQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCsm = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/csm`
    });
};
export const getPortalMiddlewareGetCsmQueryKey = (params)=>{
    return [
        `/pm/api/csm`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCsmQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCsmQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetCsm(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCsm(params, options) {
    const queryOptions = getPortalMiddlewareGetCsmQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetLoginDisclosure = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/disclosure/login`
    });
};
export const getPortalMiddlewareGetLoginDisclosureQueryKey = ()=>{
    return [
        `/pm/api/disclosure/login`
    ];
};
export const getPortalMiddlewareGetLoginDisclosureQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetLoginDisclosureQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetLoginDisclosure(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetLoginDisclosure(options) {
    const queryOptions = getPortalMiddlewareGetLoginDisclosureQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutLoginDisclosure = (putLoginDisclosureBodyDto)=>{
    return client({
        data: putLoginDisclosureBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/disclosure/login`
    });
};
export const getPortalMiddlewarePutLoginDisclosureMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutLoginDisclosure(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutLoginDisclosure = (options)=>{
    const mutationOptions = getPortalMiddlewarePutLoginDisclosureMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetLoginDisclosureAgreement = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/disclosure/login/agreement`
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementQueryKey = ()=>{
    return [
        `/pm/api/disclosure/login/agreement`
    ];
};
export const getPortalMiddlewareGetLoginDisclosureAgreementQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetLoginDisclosureAgreementQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetLoginDisclosureAgreement(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetLoginDisclosureAgreement(options) {
    const queryOptions = getPortalMiddlewareGetLoginDisclosureAgreementQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/document`
    });
};
export const getPortalMiddlewareGetDocumentByIdQueryKey = (params)=>{
    return [
        `/pm/api/document`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentById(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchDeleteDocumentById = (documentQueryDto)=>{
    return client({
        data: documentQueryDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/document`
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchDeleteDocumentById(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchDeleteDocumentById = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchDeleteDocumentByIdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetAllDocuments = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents`
    });
};
export const getPortalMiddlewareGetAllDocumentsQueryKey = (params)=>{
    return [
        `/pm/api/documents`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAllDocumentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAllDocumentsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAllDocuments(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAllDocuments(params, options) {
    const queryOptions = getPortalMiddlewareGetAllDocumentsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentAgreement = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents/agreement`
    });
};
export const getPortalMiddlewareGetDocumentAgreementQueryKey = (params)=>{
    return [
        `/pm/api/documents/agreement`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentAgreementQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentAgreementQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentAgreement(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentAgreement(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentAgreementQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostDocumentAgreement = (postDocumentAgreementBodyDto)=>{
    return client({
        data: postDocumentAgreementBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/documents/agreement`
    });
};
export const getPortalMiddlewarePostDocumentAgreementMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostDocumentAgreement(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostDocumentAgreement = (options)=>{
    const mutationOptions = getPortalMiddlewarePostDocumentAgreementMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDocumentDownloadById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents/download`
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdQueryKey = (params)=>{
    return [
        `/pm/api/documents/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentDownloadByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentDownloadByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentDownloadById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentDownloadById(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentDownloadByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentDownloadByKey = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents/download-by-key`
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyQueryKey = (params)=>{
    return [
        `/pm/api/documents/download-by-key`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentDownloadByKeyQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentDownloadByKeyQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentDownloadByKey(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentDownloadByKey(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentDownloadByKeyQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentAsHtml = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/documents/html`
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlQueryKey = (params)=>{
    return [
        `/pm/api/documents/html`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentAsHtmlQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentAsHtmlQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentAsHtml(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentAsHtml(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentAsHtmlQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDocumentAsHtmlAndDownload = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
        url: `/pm/api/documents/html/download`
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadQueryKey = (params)=>{
    return [
        `/pm/api/documents/html/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDocumentAsHtmlAndDownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetDocumentAsHtmlAndDownload(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDocumentAsHtmlAndDownload(params, options) {
    const queryOptions = getPortalMiddlewareGetDocumentAsHtmlAndDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPdf = (postPdfBodyDto)=>{
    return client({
        data: postPdfBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        responseType: 'blob',
        url: `/pm/api/documents/pdf`
    });
};
export const getPortalMiddlewarePostPdfMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPdf(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPdf = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPdfMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostProcessDocument = (postProcessDocumentBodyDto)=>{
    return client({
        data: postProcessDocumentBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/documents/process`
    });
};
export const getPortalMiddlewarePostProcessDocumentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostProcessDocument(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostProcessDocument = (options)=>{
    const mutationOptions = getPortalMiddlewarePostProcessDocumentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostUploadDocument = (uploadDocumentDto)=>{
    return client({
        data: uploadDocumentDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/documents/upload`
    });
};
export const getPortalMiddlewarePostUploadDocumentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostUploadDocument(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostUploadDocument = (options)=>{
    const mutationOptions = getPortalMiddlewarePostUploadDocumentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostEmail = (postEmailBodyDto)=>{
    return client({
        data: postEmailBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/email`
    });
};
export const getPortalMiddlewarePostEmailMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostEmail(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostEmail = (options)=>{
    const mutationOptions = getPortalMiddlewarePostEmailMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostEmailPreviewRender = (emailPreviewRenderBodyDto)=>{
    return client({
        data: emailPreviewRenderBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/email/preview/render`
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostEmailPreviewRender(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostEmailPreviewRender = (options)=>{
    const mutationOptions = getPortalMiddlewarePostEmailPreviewRenderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEmailPreviewById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/email/previews`
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdQueryKey = (params)=>{
    return [
        `/pm/api/email/previews`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmailPreviewByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmailPreviewByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmailPreviewById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmailPreviewById(params, options) {
    const queryOptions = getPortalMiddlewareGetEmailPreviewByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeHoldings = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/holdings`
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsQueryKey = (params)=>{
    return [
        `/pm/api/employee/holdings`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeHoldingsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeHoldingsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeHoldings(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeHoldings(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeHoldingsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeLoans = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/loans`
    });
};
export const getPortalMiddlewareGetEmployeeLoansQueryKey = (params)=>{
    return [
        `/pm/api/employee/loans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeLoansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeLoansQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeLoans(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeLoans(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeLoansQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeePerformance = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/performance`
    });
};
export const getPortalMiddlewareGetEmployeePerformanceQueryKey = (params)=>{
    return [
        `/pm/api/employee/performance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeePerformanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeePerformanceQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeePerformance(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeePerformance(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeePerformanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeTransactions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/transactions`
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsQueryKey = (params)=>{
    return [
        `/pm/api/employee/transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeTransactionsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeTransactions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeTransactions(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeePendingTransactions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/transactions/pending`
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsQueryKey = (params)=>{
    return [
        `/pm/api/employee/transactions/pending`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeePendingTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeePendingTransactionsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeePendingTransactions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeePendingTransactions(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeePendingTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeTransactionsYears = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employee/transactions/years`
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsQueryKey = (params)=>{
    return [
        `/pm/api/employee/transactions/years`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeTransactionsYearsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeTransactionsYears(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeTransactionsYears(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeTransactionsYearsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetProgramModelSecurities = (employeeId, type, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/employee/${employeeId}/model-securities/${type}`
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesQueryKey = (employeeId, type)=>{
    return [
        `/pm/api/employee/${employeeId}/model-securities/${type}`
    ];
};
export const getPortalMiddlewareGetProgramModelSecuritiesQueryOptions = (employeeId, type, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetProgramModelSecuritiesQueryKey(employeeId, type);
    const queryFn = ({ signal })=>portalMiddlewareGetProgramModelSecurities(employeeId, type, signal);
    return {
        enabled: !!(employeeId && type),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetProgramModelSecurities(employeeId, type, options) {
    const queryOptions = getPortalMiddlewareGetProgramModelSecuritiesQueryOptions(employeeId, type, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeesWithContributions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employees/contributions`
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsQueryKey = (params)=>{
    return [
        `/pm/api/employees/contributions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeesWithContributionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeesWithContributionsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeesWithContributions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeesWithContributions(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeesWithContributionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeLoanDetails = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employees/loans/details`
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsQueryKey = (params)=>{
    return [
        `/pm/api/employees/loans/details`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeLoanDetailsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeLoanDetailsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeLoanDetails(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeLoanDetails(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeLoanDetailsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeesTransactionsYears = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/employees/transactions/years`
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsQueryKey = (params)=>{
    return [
        `/pm/api/employees/transactions/years`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeesTransactionsYearsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeesTransactionsYears(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeesTransactionsYears(params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeesTransactionsYearsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchEsaParticipantGoal = (patchEsaParticipantGoalBodyDto)=>{
    return client({
        data: patchEsaParticipantGoalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/esa/participant/goal`
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchEsaParticipantGoal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchEsaParticipantGoal = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchEsaParticipantGoalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEsaParticipantGoals = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/participant/goals`
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsQueryKey = ()=>{
    return [
        `/pm/api/esa/participant/goals`
    ];
};
export const getPortalMiddlewareGetEsaParticipantGoalsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaParticipantGoalsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaParticipantGoals(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaParticipantGoals(options) {
    const queryOptions = getPortalMiddlewareGetEsaParticipantGoalsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaParticipantIncentives = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/participant/incentives`
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesQueryKey = ()=>{
    return [
        `/pm/api/esa/participant/incentives`
    ];
};
export const getPortalMiddlewareGetEsaParticipantIncentivesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaParticipantIncentivesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaParticipantIncentives(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaParticipantIncentives(options) {
    const queryOptions = getPortalMiddlewareGetEsaParticipantIncentivesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanCashInterestRate = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/plan/cash-interest-rate`
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateQueryKey = ()=>{
    return [
        `/pm/api/esa/plan/cash-interest-rate`
    ];
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanCashInterestRateQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanCashInterestRate(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanCashInterestRate(options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanCashInterestRateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanGroupBalanceOverTime = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/esa/plan/group-balance-over-time`
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeQueryKey = (params)=>{
    return [
        `/pm/api/esa/plan/group-balance-over-time`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanGroupBalanceOverTime(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanGroupBalanceOverTime(params, options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanGroupStats = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/esa/plan/group-stats`
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsQueryKey = (params)=>{
    return [
        `/pm/api/esa/plan/group-stats`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEsaPlanGroupStatsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanGroupStatsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanGroupStats(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanGroupStats(params, options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanGroupStatsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanGroups = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/plan/groups`
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsQueryKey = ()=>{
    return [
        `/pm/api/esa/plan/groups`
    ];
};
export const getPortalMiddlewareGetEsaPlanGroupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanGroupsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanGroups(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanGroups(options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanGroupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEsaPlanIncentives = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/esa/plan/incentives`
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesQueryKey = ()=>{
    return [
        `/pm/api/esa/plan/incentives`
    ];
};
export const getPortalMiddlewareGetEsaPlanIncentivesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaPlanIncentivesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEsaPlanIncentives(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaPlanIncentives(options) {
    const queryOptions = getPortalMiddlewareGetEsaPlanIncentivesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchEsaWithdrawal = (patchEsaWithdrawalBodyDto)=>{
    return client({
        data: patchEsaWithdrawalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/esa/withdrawal`
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchEsaWithdrawal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchEsaWithdrawal = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchEsaWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetFi360Download = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/fact-sheets`
    });
};
export const getPortalMiddlewareGetFi360DownloadQueryKey = (params)=>{
    return [
        `/pm/api/fact-sheets`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetFi360DownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetFi360DownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetFi360Download(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetFi360Download(params, options) {
    const queryOptions = getPortalMiddlewareGetFi360DownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetFeatureToggles = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/feature-toggle`
    });
};
export const getPortalMiddlewareGetFeatureTogglesQueryKey = (params)=>{
    return [
        `/pm/api/feature-toggle`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetFeatureTogglesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetFeatureTogglesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetFeatureToggles(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetFeatureToggles(params, options) {
    const queryOptions = getPortalMiddlewareGetFeatureTogglesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetFeatureTogglesList = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/feature-toggle/list`
    });
};
export const getPortalMiddlewareGetFeatureTogglesListQueryKey = (params)=>{
    return [
        `/pm/api/feature-toggle/list`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetFeatureTogglesListQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetFeatureTogglesListQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetFeatureTogglesList(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetFeatureTogglesList(params, options) {
    const queryOptions = getPortalMiddlewareGetFeatureTogglesListQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetFirmById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/firm/entity`
    });
};
export const getPortalMiddlewareGetFirmByIdQueryKey = (params)=>{
    return [
        `/pm/api/firm/entity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetFirmByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetFirmByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetFirmById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetFirmById(params, options) {
    const queryOptions = getPortalMiddlewareGetFirmByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftContributorRecurring = (giftContributorId, giftAccountId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/contributor/${giftContributorId}/gift-account/${giftAccountId}/recurring`
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringQueryKey = (giftContributorId, giftAccountId)=>{
    return [
        `/pm/api/gifting/contributor/${giftContributorId}/gift-account/${giftAccountId}/recurring`
    ];
};
export const getPortalMiddlewareGetGiftContributorRecurringQueryOptions = (giftContributorId, giftAccountId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftContributorRecurringQueryKey(giftContributorId, giftAccountId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftContributorRecurring(giftContributorId, giftAccountId, signal);
    return {
        enabled: !!(giftContributorId && giftAccountId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftContributorRecurring(giftContributorId, giftAccountId, options) {
    const queryOptions = getPortalMiddlewareGetGiftContributorRecurringQueryOptions(giftContributorId, giftAccountId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareDeleteGiftContributorRecurring = (giftContributorId, giftAccountId, recurringId)=>{
    return client({
        method: 'DELETE',
        url: `/pm/api/gifting/contributor/${giftContributorId}/gift-account/${giftAccountId}/recurring/${recurringId}`
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { giftContributorId, giftAccountId, recurringId } = props ?? {};
        return portalMiddlewareDeleteGiftContributorRecurring(giftContributorId, giftAccountId, recurringId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeleteGiftContributorRecurring = (options)=>{
    const mutationOptions = getPortalMiddlewareDeleteGiftContributorRecurringMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetGiftContributorBanks = (giftContributorId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/contributor/${giftContributorId}/gift-banks`
    });
};
export const getPortalMiddlewareGetGiftContributorBanksQueryKey = (giftContributorId)=>{
    return [
        `/pm/api/gifting/contributor/${giftContributorId}/gift-banks`
    ];
};
export const getPortalMiddlewareGetGiftContributorBanksQueryOptions = (giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftContributorBanksQueryKey(giftContributorId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftContributorBanks(giftContributorId, signal);
    return {
        enabled: !!giftContributorId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftContributorBanks(giftContributorId, options) {
    const queryOptions = getPortalMiddlewareGetGiftContributorBanksQueryOptions(giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftContributorPayments = (giftContributorId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/contributor/${giftContributorId}/gift-payments`
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsQueryKey = (giftContributorId)=>{
    return [
        `/pm/api/gifting/contributor/${giftContributorId}/gift-payments`
    ];
};
export const getPortalMiddlewareGetGiftContributorPaymentsQueryOptions = (giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftContributorPaymentsQueryKey(giftContributorId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftContributorPayments(giftContributorId, signal);
    return {
        enabled: !!giftContributorId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftContributorPayments(giftContributorId, options) {
    const queryOptions = getPortalMiddlewareGetGiftContributorPaymentsQueryOptions(giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftContributorRecipients = (giftContributorId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/contributor/${giftContributorId}/recipients`
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsQueryKey = (giftContributorId)=>{
    return [
        `/pm/api/gifting/contributor/${giftContributorId}/recipients`
    ];
};
export const getPortalMiddlewareGetGiftContributorRecipientsQueryOptions = (giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftContributorRecipientsQueryKey(giftContributorId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftContributorRecipients(giftContributorId, signal);
    return {
        enabled: !!giftContributorId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftContributorRecipients(giftContributorId, options) {
    const queryOptions = getPortalMiddlewareGetGiftContributorRecipientsQueryOptions(giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftingPageAndAccountById = (giftingId, giftContributorId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/gift-account/${giftingId}/${giftContributorId}`
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdQueryKey = (giftingId, giftContributorId)=>{
    return [
        `/pm/api/gifting/gift-account/${giftingId}/${giftContributorId}`
    ];
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdQueryOptions = (giftingId, giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftingPageAndAccountByIdQueryKey(giftingId, giftContributorId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftingPageAndAccountById(giftingId, giftContributorId, signal);
    return {
        enabled: !!(giftingId && giftContributorId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftingPageAndAccountById(giftingId, giftContributorId, options) {
    const queryOptions = getPortalMiddlewareGetGiftingPageAndAccountByIdQueryOptions(giftingId, giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGiftingPageById = (planId, giftingId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/gifting/gift/${planId}/${giftingId}`
    });
};
export const getPortalMiddlewareGetGiftingPageByIdQueryKey = (planId, giftingId)=>{
    return [
        `/pm/api/gifting/gift/${planId}/${giftingId}`
    ];
};
export const getPortalMiddlewareGetGiftingPageByIdQueryOptions = (planId, giftingId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGiftingPageByIdQueryKey(planId, giftingId);
    const queryFn = ({ signal })=>portalMiddlewareGetGiftingPageById(planId, giftingId, signal);
    return {
        enabled: !!(planId && giftingId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGiftingPageById(planId, giftingId, options) {
    const queryOptions = getPortalMiddlewareGetGiftingPageByIdQueryOptions(planId, giftingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostCreateGiftorProfile = (postCreateGiftorProfileParamsDto)=>{
    return client({
        data: postCreateGiftorProfileParamsDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/gifting/profile`
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostCreateGiftorProfile(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCreateGiftorProfile = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCreateGiftorProfileMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutValidateGiftorProfile = (putValidateCreateGiftorProfileParamsDto)=>{
    return client({
        data: putValidateCreateGiftorProfileParamsDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/gifting/profile`
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutValidateGiftorProfile(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutValidateGiftorProfile = (options)=>{
    const mutationOptions = getPortalMiddlewarePutValidateGiftorProfileMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostGiftSubmission = (giftingId, giftSubmissionBodyDto)=>{
    return client({
        data: giftSubmissionBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/gifting/${giftingId}`
    });
};
export const getPortalMiddlewarePostGiftSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { giftingId, data } = props ?? {};
        return portalMiddlewarePostGiftSubmission(giftingId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostGiftSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePostGiftSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutValidateGiftSubmission = (giftingId, giftSubmissionBodyDto)=>{
    return client({
        data: giftSubmissionBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/gifting/${giftingId}`
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { giftingId, data } = props ?? {};
        return portalMiddlewarePutValidateGiftSubmission(giftingId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutValidateGiftSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePutValidateGiftSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetHealth = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/health`
    });
};
export const getPortalMiddlewareGetHealthQueryKey = ()=>{
    return [
        `/pm/api/health`
    ];
};
export const getPortalMiddlewareGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetHealthQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetHealth(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetHealth(options) {
    const queryOptions = getPortalMiddlewareGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetLoanAmortizationPdf = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
        url: `/pm/api/loans/amortization/pdf`
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfQueryKey = (params)=>{
    return [
        `/pm/api/loans/amortization/pdf`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetLoanAmortizationPdfQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetLoanAmortizationPdfQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetLoanAmortizationPdf(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetLoanAmortizationPdf(params, options) {
    const queryOptions = getPortalMiddlewareGetLoanAmortizationPdfQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetManagedAccountsPlaidToken = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/managed-accounts/plaid-link-token`
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenQueryKey = ()=>{
    return [
        `/pm/api/managed-accounts/plaid-link-token`
    ];
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetManagedAccountsPlaidTokenQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetManagedAccountsPlaidToken(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetManagedAccountsPlaidToken(options) {
    const queryOptions = getPortalMiddlewareGetManagedAccountsPlaidTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareDeleteManagedAccountsPlaidLinks = (deletePlaidLinkBodyDto)=>{
    return client({
        data: deletePlaidLinkBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/managed-accounts/plaid-links`
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeleteManagedAccountsPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeleteManagedAccountsPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewareDeleteManagedAccountsPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetManagedAccountsPlaidLinks = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/managed-accounts/plaid-links`
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksQueryKey = ()=>{
    return [
        `/pm/api/managed-accounts/plaid-links`
    ];
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetManagedAccountsPlaidLinksQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetManagedAccountsPlaidLinks(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetManagedAccountsPlaidLinks(options) {
    const queryOptions = getPortalMiddlewareGetManagedAccountsPlaidLinksQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostManagedAccountsPlaidLinks = (postPlaidLinkBodyDto)=>{
    return client({
        data: postPlaidLinkBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/managed-accounts/plaid-links`
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostManagedAccountsPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostManagedAccountsPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewarePostManagedAccountsPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostManagedAccountsPlaidBalances = (postPlaidBalancesBodyDto)=>{
    return client({
        data: postPlaidBalancesBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/managed-accounts/plaid-links/balance/get`
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostManagedAccountsPlaidBalances(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostManagedAccountsPlaidBalances = (options)=>{
    const mutationOptions = getPortalMiddlewarePostManagedAccountsPlaidBalancesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetMidYearTesting = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/midYearTesting`
    });
};
export const getPortalMiddlewareGetMidYearTestingQueryKey = (params)=>{
    return [
        `/pm/api/midYearTesting`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetMidYearTestingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetMidYearTestingQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetMidYearTesting(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetMidYearTesting(params, options) {
    const queryOptions = getPortalMiddlewareGetMidYearTestingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetMidYearTestingCensusRecord = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/midYearTesting/censusRecord`
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordQueryKey = (params)=>{
    return [
        `/pm/api/midYearTesting/censusRecord`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetMidYearTestingCensusRecordQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetMidYearTestingCensusRecord(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetMidYearTestingCensusRecord(params, options) {
    const queryOptions = getPortalMiddlewareGetMidYearTestingCensusRecordQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetMidYearTestingCensusRecordGrid = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/midYearTesting/censusRecord/grid`
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridQueryKey = (params)=>{
    return [
        `/pm/api/midYearTesting/censusRecord/grid`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetMidYearTestingCensusRecordGridQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetMidYearTestingCensusRecordGrid(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetMidYearTestingCensusRecordGrid(params, options) {
    const queryOptions = getPortalMiddlewareGetMidYearTestingCensusRecordGridQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostMidYearTestingCensusRecordRunTest = (midYearTestingCensusRecordTestBodyDto)=>{
    return client({
        data: midYearTestingCensusRecordTestBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/midYearTesting/censusRecord/test`
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostMidYearTestingCensusRecordRunTest(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMidYearTestingCensusRecordRunTest = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostMsManagedAccounts401KManagerQuestionnaire = (postMsManagedAccounts401KManagerQuestionnaireBodyDto)=>{
    return client({
        data: postMsManagedAccounts401KManagerQuestionnaireBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/ms-managed-accounts/401k-manager-questionnaire`
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostMsManagedAccounts401KManagerQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaire = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostMsManagedAccountsActivate = (postMsManagedAccountsActivateBodyDto)=>{
    return client({
        data: postMsManagedAccountsActivateBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/ms-managed-accounts/activate`
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostMsManagedAccountsActivate(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMsManagedAccountsActivate = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMsManagedAccountsActivateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostMsManagedAccountsDeactivate = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/ms-managed-accounts/deactivate`
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostMsManagedAccountsDeactivate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMsManagedAccountsDeactivate = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMsManagedAccountsDeactivateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetMsManagedAccountsPreviewAllocation = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/ms-managed-accounts/preview-allocation`
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationQueryKey = ()=>{
    return [
        `/pm/api/ms-managed-accounts/preview-allocation`
    ];
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetMsManagedAccountsPreviewAllocationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetMsManagedAccountsPreviewAllocation(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetMsManagedAccountsPreviewAllocation(options) {
    const queryOptions = getPortalMiddlewareGetMsManagedAccountsPreviewAllocationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostMsManagedAccountsPreviewAllocation = (postMsManagedAccountsPreviewAllocationBodyDto)=>{
    return client({
        data: postMsManagedAccountsPreviewAllocationBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/ms-managed-accounts/preview-allocation`
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostMsManagedAccountsPreviewAllocation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMsManagedAccountsPreviewAllocation = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDigitalOnboardingState = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/onboarding/digital`
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateQueryKey = ()=>{
    return [
        `/pm/api/onboarding/digital`
    ];
};
export const getPortalMiddlewareGetDigitalOnboardingStateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDigitalOnboardingStateQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetDigitalOnboardingState(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDigitalOnboardingState(options) {
    const queryOptions = getPortalMiddlewareGetDigitalOnboardingStateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchDigitalOnboardingState = (patchDigitalOnboardingStateBodyDto)=>{
    return client({
        data: patchDigitalOnboardingStateBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/onboarding/digital`
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchDigitalOnboardingState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchDigitalOnboardingState = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchDigitalOnboardingStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutDigitalOnboardingState = (putDigitalOnboardingStateBodyDto)=>{
    return client({
        data: putDigitalOnboardingStateBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/onboarding/digital`
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutDigitalOnboardingState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutDigitalOnboardingState = (options)=>{
    const mutationOptions = getPortalMiddlewarePutDigitalOnboardingStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePatchStatefulSchemaTrackingStatus = (schemaType, patchStatefulSchemaTrackingStatusBodyDto)=>{
    return client({
        data: patchStatefulSchemaTrackingStatusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/onboarding/stateful-schema-tracking/${schemaType}/status`
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { schemaType, data } = props ?? {};
        return portalMiddlewarePatchStatefulSchemaTrackingStatus(schemaType, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchStatefulSchemaTrackingStatus = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchStatefulSchemaTrackingStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant`
    });
};
export const getPortalMiddlewareGetParticipantByIdQueryKey = (params)=>{
    return [
        `/pm/api/participant`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantById(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantAccountBalanceById = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/account-balance`
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdQueryKey = (params)=>{
    return [
        `/pm/api/participant/account-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantAccountBalanceByIdQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantAccountBalanceById(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantAccountBalanceById(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantAccountBalanceByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantLoan = (loanBodyDto)=>{
    return client({
        data: loanBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/account/loans`
    });
};
export const getPortalMiddlewarePostParticipantLoanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantLoan(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantLoan = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantLoanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantPlaidLinkToken = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/account/loans/plaid-link-token`
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenQueryKey = (params)=>{
    return [
        `/pm/api/participant/account/loans/plaid-link-token`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantPlaidLinkTokenQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantPlaidLinkToken(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantPlaidLinkToken(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantPlaidLinkTokenQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantPlaidLinks = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/account/loans/plaid-links`
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksQueryKey = ()=>{
    return [
        `/pm/api/participant/account/loans/plaid-links`
    ];
};
export const getPortalMiddlewareGetParticipantPlaidLinksQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantPlaidLinksQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantPlaidLinks(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantPlaidLinks(options) {
    const queryOptions = getPortalMiddlewareGetParticipantPlaidLinksQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantPlaidLinks = (plaidLinkBodyDto)=>{
    return client({
        data: plaidLinkBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/account/loans/plaid-links`
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantLoanCreate = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/account/loans/request`
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateQueryKey = ()=>{
    return [
        `/pm/api/participant/account/loans/request`
    ];
};
export const getPortalMiddlewareGetParticipantLoanCreateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantLoanCreateQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantLoanCreate(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantLoanCreate(options) {
    const queryOptions = getPortalMiddlewareGetParticipantLoanCreateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchParticipantLoan = (loanId, loanAgreementBodyDto)=>{
    return client({
        data: loanAgreementBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/participant/account/loans/${loanId}`
    });
};
export const getPortalMiddlewarePatchParticipantLoanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { loanId, data } = props ?? {};
        return portalMiddlewarePatchParticipantLoan(loanId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchParticipantLoan = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchParticipantLoanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostLoanManualRepayment = (loanId, bankAccountIdDto)=>{
    return client({
        data: bankAccountIdDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/account/loans/${loanId}/payment`
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { loanId, data } = props ?? {};
        return portalMiddlewarePostLoanManualRepayment(loanId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostLoanManualRepayment = (options)=>{
    const mutationOptions = getPortalMiddlewarePostLoanManualRepaymentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantAccounts = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/accounts`
    });
};
export const getPortalMiddlewareGetParticipantAccountsQueryKey = (params)=>{
    return [
        `/pm/api/participant/accounts`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantAccountsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantAccountsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantAccounts(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantAccounts(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantAccountsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantBalanceOverTime = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/balance-over-time`
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeQueryKey = ()=>{
    return [
        `/pm/api/participant/balance-over-time`
    ];
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantBalanceOverTimeQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantBalanceOverTime(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantBalanceOverTime(options) {
    const queryOptions = getPortalMiddlewareGetParticipantBalanceOverTimeQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutArchiveBankAccount = (bankAccountId)=>{
    return client({
        method: 'PUT',
        url: `/pm/api/participant/bank-account/${bankAccountId}/archive`
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { bankAccountId } = props ?? {};
        return portalMiddlewarePutArchiveBankAccount(bankAccountId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutArchiveBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePutArchiveBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantBankAccounts = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/bank-accounts`
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsQueryKey = ()=>{
    return [
        `/pm/api/participant/bank-accounts`
    ];
};
export const getPortalMiddlewareGetParticipantBankAccountsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantBankAccountsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantBankAccounts(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantBankAccounts(options) {
    const queryOptions = getPortalMiddlewareGetParticipantBankAccountsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantDeposits = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/deposit`
    });
};
export const getPortalMiddlewareGetParticipantDepositsQueryKey = (params)=>{
    return [
        `/pm/api/participant/deposit`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantDepositsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantDepositsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantDeposits(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantDeposits(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantDepositsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostDepositData = (postParticipantDepositBodyDto)=>{
    return client({
        data: postParticipantDepositBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/deposit`
    });
};
export const getPortalMiddlewarePostDepositDataMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostDepositData(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostDepositData = (options)=>{
    const mutationOptions = getPortalMiddlewarePostDepositDataMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantRecurringSchedules = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/deposit/schedule`
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesQueryKey = (params)=>{
    return [
        `/pm/api/participant/deposit/schedule`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantRecurringSchedulesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantRecurringSchedules(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantRecurringSchedules(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantRecurringSchedulesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutRecurringSchedule = (recurringScheduleId, putDepositDto)=>{
    return client({
        data: putDepositDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/deposit/schedule/${recurringScheduleId}`
    });
};
export const getPortalMiddlewarePutRecurringScheduleMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { recurringScheduleId, data } = props ?? {};
        return portalMiddlewarePutRecurringSchedule(recurringScheduleId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutRecurringSchedule = (options)=>{
    const mutationOptions = getPortalMiddlewarePutRecurringScheduleMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDeposit = (depositId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/deposit/${depositId}`
    });
};
export const getPortalMiddlewareGetDepositQueryKey = (depositId)=>{
    return [
        `/pm/api/participant/deposit/${depositId}`
    ];
};
export const getPortalMiddlewareGetDepositQueryOptions = (depositId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDepositQueryKey(depositId);
    const queryFn = ({ signal })=>portalMiddlewareGetDeposit(depositId, signal);
    return {
        enabled: !!depositId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDeposit(depositId, options) {
    const queryOptions = getPortalMiddlewareGetDepositQueryOptions(depositId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetRecentParticipantDocuments = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/documents/recent`
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsQueryKey = ()=>{
    return [
        `/pm/api/participant/documents/recent`
    ];
};
export const getPortalMiddlewareGetRecentParticipantDocumentsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRecentParticipantDocumentsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRecentParticipantDocuments(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRecentParticipantDocuments(options) {
    const queryOptions = getPortalMiddlewareGetRecentParticipantDocumentsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantEligibility = (postParticipantsEligibilityBodyDto)=>{
    return client({
        data: postParticipantsEligibilityBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/eligibility`
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantEligibility(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantEligibility = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantEligibilityMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostEsaGoal = (participantEsaGoalDto)=>{
    return client({
        data: participantEsaGoalDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/esa/goal`
    });
};
export const getPortalMiddlewarePostEsaGoalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostEsaGoal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostEsaGoal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostEsaGoalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantIdentityVerification = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/identity-verification`
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationQueryKey = ()=>{
    return [
        `/pm/api/participant/identity-verification`
    ];
};
export const getPortalMiddlewareGetParticipantIdentityVerificationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantIdentityVerificationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantIdentityVerification(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantIdentityVerification(options) {
    const queryOptions = getPortalMiddlewareGetParticipantIdentityVerificationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchParticipantInfoWithEmails = (patchParticipantBodyDto)=>{
    return client({
        data: patchParticipantBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/participant/info`
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchParticipantInfoWithEmails(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchParticipantInfoWithEmails = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchParticipantInfoWithEmailsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetGoalFeedback = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investment-election`
    });
};
export const getPortalMiddlewareGetGoalFeedbackQueryKey = ()=>{
    return [
        `/pm/api/participant/investment-election`
    ];
};
export const getPortalMiddlewareGetGoalFeedbackQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGoalFeedbackQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetGoalFeedback(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGoalFeedback(options) {
    const queryOptions = getPortalMiddlewareGetGoalFeedbackQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostElectionAgeSuggestion = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/investment-election/age-suggestion`
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostElectionAgeSuggestion();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostElectionAgeSuggestion = (options)=>{
    const mutationOptions = getPortalMiddlewarePostElectionAgeSuggestionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostElectionRetirementIncomeSuggestion = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/investment-election/retirement-income-suggestion`
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostElectionRetirementIncomeSuggestion();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostElectionRetirementIncomeSuggestion = (options)=>{
    const mutationOptions = getPortalMiddlewarePostElectionRetirementIncomeSuggestionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetElectionsSetup = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investment-election/setup`
    });
};
export const getPortalMiddlewareGetElectionsSetupQueryKey = ()=>{
    return [
        `/pm/api/participant/investment-election/setup`
    ];
};
export const getPortalMiddlewareGetElectionsSetupQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetElectionsSetupQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetElectionsSetup(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetElectionsSetup(options) {
    const queryOptions = getPortalMiddlewareGetElectionsSetupQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostElectionsSetup = (investmentElectionSetupDto)=>{
    return client({
        data: investmentElectionSetupDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/investment-election/setup`
    });
};
export const getPortalMiddlewarePostElectionsSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostElectionsSetup(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostElectionsSetup = (options)=>{
    const mutationOptions = getPortalMiddlewarePostElectionsSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetInvestmentsModelDisplay = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/model`
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayQueryKey = ()=>{
    return [
        `/pm/api/participant/investments/model`
    ];
};
export const getPortalMiddlewareGetInvestmentsModelDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetInvestmentsModelDisplayQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetInvestmentsModelDisplay(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetInvestmentsModelDisplay(options) {
    const queryOptions = getPortalMiddlewareGetInvestmentsModelDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanParticipantStats = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/options/plans/${planId}/stats`
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsQueryKey = (planId)=>{
    return [
        `/pm/api/participant/investments/options/plans/${planId}/stats`
    ];
};
export const getPortalMiddlewareGetPlanParticipantStatsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanParticipantStatsQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanParticipantStats(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanParticipantStats(planId, options) {
    const queryOptions = getPortalMiddlewareGetPlanParticipantStatsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostRebalanceRequest = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/investments/rebalance-request`
    });
};
export const getPortalMiddlewarePostRebalanceRequestMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostRebalanceRequest();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostRebalanceRequest = (options)=>{
    const mutationOptions = getPortalMiddlewarePostRebalanceRequestMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostRebalanceRequestPreview = (rebalancePreviewBodyDto)=>{
    return client({
        data: rebalancePreviewBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/investments/rebalance-request/preview`
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostRebalanceRequestPreview(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostRebalanceRequestPreview = (options)=>{
    const mutationOptions = getPortalMiddlewarePostRebalanceRequestPreviewMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRebalanceSettings = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/rebalance-settings`
    });
};
export const getPortalMiddlewareGetRebalanceSettingsQueryKey = ()=>{
    return [
        `/pm/api/participant/investments/rebalance-settings`
    ];
};
export const getPortalMiddlewareGetRebalanceSettingsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRebalanceSettingsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRebalanceSettings(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRebalanceSettings(options) {
    const queryOptions = getPortalMiddlewareGetRebalanceSettingsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutRebalanceSettings = (rebalanceBodyDto)=>{
    return client({
        data: rebalanceBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/investments/rebalance-settings`
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutRebalanceSettings(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutRebalanceSettings = (options)=>{
    const mutationOptions = getPortalMiddlewarePutRebalanceSettingsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetStrategiesIndex = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/strategies`
    });
};
export const getPortalMiddlewareGetStrategiesIndexQueryKey = ()=>{
    return [
        `/pm/api/participant/investments/strategies`
    ];
};
export const getPortalMiddlewareGetStrategiesIndexQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetStrategiesIndexQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetStrategiesIndex(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetStrategiesIndex(options) {
    const queryOptions = getPortalMiddlewareGetStrategiesIndexQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAgeBased = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/investments/strategies/age-based`
    });
};
export const getPortalMiddlewareGetAgeBasedQueryKey = (params)=>{
    return [
        `/pm/api/participant/investments/strategies/age-based`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAgeBasedQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAgeBasedQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAgeBased(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAgeBased(params, options) {
    const queryOptions = getPortalMiddlewareGetAgeBasedQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutAgeBased = (ageBasedBodyDto)=>{
    return client({
        data: ageBasedBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/investments/strategies/age-based`
    });
};
export const getPortalMiddlewarePutAgeBasedMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutAgeBased(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutAgeBased = (options)=>{
    const mutationOptions = getPortalMiddlewarePutAgeBasedMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutCustomAllocation = (allocationsBodyDto)=>{
    return client({
        data: allocationsBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/investments/strategies/custom-allocation`
    });
};
export const getPortalMiddlewarePutCustomAllocationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutCustomAllocation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutCustomAllocation = (options)=>{
    const mutationOptions = getPortalMiddlewarePutCustomAllocationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRiskBased = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/investments/strategies/risk-based`
    });
};
export const getPortalMiddlewareGetRiskBasedQueryKey = ()=>{
    return [
        `/pm/api/participant/investments/strategies/risk-based`
    ];
};
export const getPortalMiddlewareGetRiskBasedQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRiskBasedQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRiskBased(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRiskBased(options) {
    const queryOptions = getPortalMiddlewareGetRiskBasedQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutRiskBased = (riskBasedBodyDto)=>{
    return client({
        data: riskBasedBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/investments/strategies/risk-based`
    });
};
export const getPortalMiddlewarePutRiskBasedMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutRiskBased(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutRiskBased = (options)=>{
    const mutationOptions = getPortalMiddlewarePutRiskBasedMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRiskModelQuestionnaire = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participant/investments/strategies/risk-based/questionnaire`
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireQueryKey = (params)=>{
    return [
        `/pm/api/participant/investments/strategies/risk-based/questionnaire`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetRiskModelQuestionnaireQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRiskModelQuestionnaireQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetRiskModelQuestionnaire(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRiskModelQuestionnaire(params, options) {
    const queryOptions = getPortalMiddlewareGetRiskModelQuestionnaireQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetMailPreferences = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/mail-preferences`
    });
};
export const getPortalMiddlewareGetMailPreferencesQueryKey = ()=>{
    return [
        `/pm/api/participant/mail-preferences`
    ];
};
export const getPortalMiddlewareGetMailPreferencesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetMailPreferencesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetMailPreferences(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetMailPreferences(options) {
    const queryOptions = getPortalMiddlewareGetMailPreferencesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutMailPreferences = (paperlessNoticesDto)=>{
    return client({
        data: paperlessNoticesDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/mail-preferences`
    });
};
export const getPortalMiddlewarePutMailPreferencesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutMailPreferences(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutMailPreferences = (options)=>{
    const mutationOptions = getPortalMiddlewarePutMailPreferencesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantOnboarding = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/onboarding`
    });
};
export const getPortalMiddlewareGetParticipantOnboardingQueryKey = ()=>{
    return [
        `/pm/api/participant/onboarding`
    ];
};
export const getPortalMiddlewareGetParticipantOnboardingQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantOnboardingQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantOnboarding(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantOnboarding(options) {
    const queryOptions = getPortalMiddlewareGetParticipantOnboardingQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantOverview = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/overview`
    });
};
export const getPortalMiddlewareGetParticipantOverviewQueryKey = ()=>{
    return [
        `/pm/api/participant/overview`
    ];
};
export const getPortalMiddlewareGetParticipantOverviewQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantOverviewQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantOverview(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantOverview(options) {
    const queryOptions = getPortalMiddlewareGetParticipantOverviewQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantPlaidLinksBalance = (plaidLinkBodyDto)=>{
    return client({
        data: plaidLinkBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/plaid-links/balance`
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantPlaidLinksBalance(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantPlaidLinksBalance = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantPlaidLinksBalanceMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostParticipantPlaidLinksBankAccount = (partipantPlaidLinkBankAccountDto)=>{
    return client({
        data: partipantPlaidLinkBankAccountDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participant/plaid-links/bank-account`
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantPlaidLinksBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantPlaidLinksBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantPlaidLinksBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostParticipantDiscardPendingPlaidLinks = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/plaid-links/discard-pending`
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostParticipantDiscardPendingPlaidLinks();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantDiscardPendingPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPositions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/positions`
    });
};
export const getPortalMiddlewareGetPositionsQueryKey = ()=>{
    return [
        `/pm/api/participant/positions`
    ];
};
export const getPortalMiddlewareGetPositionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPositionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPositions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPositions(options) {
    const queryOptions = getPortalMiddlewareGetPositionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetQboadWithdrawals = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/qboad/withdrawals`
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsQueryKey = ()=>{
    return [
        `/pm/api/participant/qboad/withdrawals`
    ];
};
export const getPortalMiddlewareGetQboadWithdrawalsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetQboadWithdrawalsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetQboadWithdrawals(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetQboadWithdrawals(options) {
    const queryOptions = getPortalMiddlewareGetQboadWithdrawalsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchParticipantRollover = (rolloverBodyDto)=>{
    return client({
        data: rolloverBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/participant/rollovers`
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchParticipantRollover(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchParticipantRollover = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchParticipantRolloverMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRolloverInstructions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/rollovers/instructions`
    });
};
export const getPortalMiddlewareGetRolloverInstructionsQueryKey = ()=>{
    return [
        `/pm/api/participant/rollovers/instructions`
    ];
};
export const getPortalMiddlewareGetRolloverInstructionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRolloverInstructionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRolloverInstructions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRolloverInstructions(options) {
    const queryOptions = getPortalMiddlewareGetRolloverInstructionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetRolloverEligibility = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/rollovers/request`
    });
};
export const getPortalMiddlewareGetRolloverEligibilityQueryKey = ()=>{
    return [
        `/pm/api/participant/rollovers/request`
    ];
};
export const getPortalMiddlewareGetRolloverEligibilityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRolloverEligibilityQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRolloverEligibility(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRolloverEligibility(options) {
    const queryOptions = getPortalMiddlewareGetRolloverEligibilityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantRollover = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/rollovers/request`
    });
};
export const getPortalMiddlewarePostParticipantRolloverMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostParticipantRollover();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantRollover = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantRolloverMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantRollover = (rolloverId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/rollovers/${rolloverId}`
    });
};
export const getPortalMiddlewareGetParticipantRolloverQueryKey = (rolloverId)=>{
    return [
        `/pm/api/participant/rollovers/${rolloverId}`
    ];
};
export const getPortalMiddlewareGetParticipantRolloverQueryOptions = (rolloverId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantRolloverQueryKey(rolloverId);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantRollover(rolloverId, signal);
    return {
        enabled: !!rolloverId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantRollover(rolloverId, options) {
    const queryOptions = getPortalMiddlewareGetParticipantRolloverQueryOptions(rolloverId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetGenerateRolloverLetter = (rolloverId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/rollovers/${rolloverId}/letter`
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterQueryKey = (rolloverId)=>{
    return [
        `/pm/api/participant/rollovers/${rolloverId}/letter`
    ];
};
export const getPortalMiddlewareGetGenerateRolloverLetterQueryOptions = (rolloverId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGenerateRolloverLetterQueryKey(rolloverId);
    const queryFn = ({ signal })=>portalMiddlewareGetGenerateRolloverLetter(rolloverId, signal);
    return {
        enabled: !!rolloverId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGenerateRolloverLetter(rolloverId, options) {
    const queryOptions = getPortalMiddlewareGetGenerateRolloverLetterQueryOptions(rolloverId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSavingsDisplay = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/savings`
    });
};
export const getPortalMiddlewareGetSavingsDisplayQueryKey = ()=>{
    return [
        `/pm/api/participant/savings`
    ];
};
export const getPortalMiddlewareGetSavingsDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSavingsDisplayQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSavingsDisplay(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSavingsDisplay(options) {
    const queryOptions = getPortalMiddlewareGetSavingsDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutSavings = (savingsBodyDto)=>{
    return client({
        data: savingsBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/participant/savings`
    });
};
export const getPortalMiddlewarePutSavingsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutSavings(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutSavings = (options)=>{
    const mutationOptions = getPortalMiddlewarePutSavingsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSurveyLink = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/survey/link`
    });
};
export const getPortalMiddlewareGetSurveyLinkQueryKey = ()=>{
    return [
        `/pm/api/participant/survey/link`
    ];
};
export const getPortalMiddlewareGetSurveyLinkQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSurveyLinkQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSurveyLink(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSurveyLink(options) {
    const queryOptions = getPortalMiddlewareGetSurveyLinkQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantAggregatedByCategoryTransactions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/transactions/aggregated-by-category`
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsQueryKey = ()=>{
    return [
        `/pm/api/participant/transactions/aggregated-by-category`
    ];
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantAggregatedByCategoryTransactions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantAggregatedByCategoryTransactions(options) {
    const queryOptions = getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAllowedWithdrawalReasons = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/participant/withdrawals`
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsQueryKey = ()=>{
    return [
        `/pm/api/participant/withdrawals`
    ];
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAllowedWithdrawalReasonsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetAllowedWithdrawalReasons(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAllowedWithdrawalReasons(options) {
    const queryOptions = getPortalMiddlewareGetAllowedWithdrawalReasonsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostWithdrawal = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/participant/withdrawals`
    });
};
export const getPortalMiddlewarePostWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostWithdrawal();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostWithdrawal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePatchOverrideParticipantEligibility = (participantId, patchOverrideParticipantEligibilityBodyDto)=>{
    return client({
        data: patchOverrideParticipantEligibilityBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/participant/${participantId}/override-eligibility`
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { participantId, data } = props ?? {};
        return portalMiddlewarePatchOverrideParticipantEligibility(participantId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchOverrideParticipantEligibility = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchOverrideParticipantEligibilityMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEligibleAutoEnrolledParticipants = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/opt-out`
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsQueryKey = (params)=>{
    return [
        `/pm/api/participants/opt-out`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEligibleAutoEnrolledParticipantsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetEligibleAutoEnrolledParticipants(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEligibleAutoEnrolledParticipants(params, options) {
    const queryOptions = getPortalMiddlewareGetEligibleAutoEnrolledParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantOptOutEmailDownload = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
        url: `/pm/api/participants/opt-out-confirmation/download`
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadQueryKey = (params)=>{
    return [
        `/pm/api/participants/opt-out-confirmation/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantOptOutEmailDownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantOptOutEmailDownload(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantOptOutEmailDownload(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantOptOutEmailDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetOptedOutAutoEnrolledParticipants = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/opt-out/enrolled`
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsQueryKey = (params)=>{
    return [
        `/pm/api/participants/opt-out/enrolled`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetOptedOutAutoEnrolledParticipants(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetOptedOutAutoEnrolledParticipants(params, options) {
    const queryOptions = getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetUnregisteredParticipants = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/unregistered`
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsQueryKey = (params)=>{
    return [
        `/pm/api/participants/unregistered`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetUnregisteredParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetUnregisteredParticipantsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetUnregisteredParticipants(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetUnregisteredParticipants(params, options) {
    const queryOptions = getPortalMiddlewareGetUnregisteredParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetUnregisteredParticipantsCount = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/unregistered/count`
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountQueryKey = (params)=>{
    return [
        `/pm/api/participants/unregistered/count`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetUnregisteredParticipantsCountQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetUnregisteredParticipantsCount(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetUnregisteredParticipantsCount(params, options) {
    const queryOptions = getPortalMiddlewareGetUnregisteredParticipantsCountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantsWelcomeEmails = (postParticipantWelcomeEmailsBodyDto)=>{
    return client({
        data: postParticipantWelcomeEmailsBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participants/welcome-emails/bulk`
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostParticipantsWelcomeEmails(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantsWelcomeEmails = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantsWelcomeEmailsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantWelcomeEmailDownload = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
        url: `/pm/api/participants/welcome-emails/download`
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadQueryKey = (params)=>{
    return [
        `/pm/api/participants/welcome-emails/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantWelcomeEmailDownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantWelcomeEmailDownload(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantWelcomeEmailDownload(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantWelcomeEmailDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetParticipantWelcomeEmailsHistory = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/welcome-emails/history`
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryQueryKey = (params)=>{
    return [
        `/pm/api/participants/welcome-emails/history`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantWelcomeEmailsHistoryQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantWelcomeEmailsHistory(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantWelcomeEmailsHistory(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantWelcomeEmailsHistoryQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCalculatedEsaEmployerContributions = (participantId, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/${participantId}/calculate-employer-contributions`
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsQueryKey = (participantId, params)=>{
    return [
        `/pm/api/participants/${participantId}/calculate-employer-contributions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCalculatedEsaEmployerContributionsQueryKey(participantId, params);
    const queryFn = ({ signal })=>portalMiddlewareGetCalculatedEsaEmployerContributions(participantId, params, signal);
    return {
        enabled: !!participantId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCalculatedEsaEmployerContributions(participantId, params, options) {
    const queryOptions = getPortalMiddlewareGetCalculatedEsaEmployerContributionsQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCalculatedEmployerMatchContribution = (participantId, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/participants/${participantId}/calculate-employer-match`
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionQueryKey = (participantId, params)=>{
    return [
        `/pm/api/participants/${participantId}/calculate-employer-match`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCalculatedEmployerMatchContributionQueryKey(participantId, params);
    const queryFn = ({ signal })=>portalMiddlewareGetCalculatedEmployerMatchContribution(participantId, params, signal);
    return {
        enabled: !!participantId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCalculatedEmployerMatchContribution(participantId, params, options) {
    const queryOptions = getPortalMiddlewareGetCalculatedEmployerMatchContributionQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostParticipantsAutoEnrollOptOut = (planId, postParticipantsAutoEnrollOptOutBodyDto)=>{
    return client({
        data: postParticipantsAutoEnrollOptOutBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/participants/${planId}/opt-out`
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return portalMiddlewarePostParticipantsAutoEnrollOptOut(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostParticipantsAutoEnrollOptOut = (options)=>{
    const mutationOptions = getPortalMiddlewarePostParticipantsAutoEnrollOptOutMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanDesign = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plan-design`
    });
};
export const getPortalMiddlewareGetPlanDesignQueryKey = ()=>{
    return [
        `/pm/api/plan-design`
    ];
};
export const getPortalMiddlewareGetPlanDesignQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanDesignQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanDesign(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanDesign(options) {
    const queryOptions = getPortalMiddlewareGetPlanDesignQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchUpdatePlanDesign = (planDesignDto)=>{
    return client({
        data: planDesignDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/plan-design`
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchUpdatePlanDesign(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchUpdatePlanDesign = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchUpdatePlanDesignMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanDesignTiles = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plan-design/tiles`
    });
};
export const getPortalMiddlewareGetPlanDesignTilesQueryKey = ()=>{
    return [
        `/pm/api/plan-design/tiles`
    ];
};
export const getPortalMiddlewareGetPlanDesignTilesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanDesignTilesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanDesignTiles(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanDesignTiles(options) {
    const queryOptions = getPortalMiddlewareGetPlanDesignTilesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanParticipants = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/plan/participants`
    });
};
export const getPortalMiddlewareGetPlanParticipantsQueryKey = (params)=>{
    return [
        `/pm/api/plan/participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanParticipantsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanParticipants(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanParticipants(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanModel = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/plans/models`
    });
};
export const getPortalMiddlewareGetPlanModelQueryKey = (params)=>{
    return [
        `/pm/api/plans/models`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanModelQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanModelQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanModel(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanModel(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanModelQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchPlan = (planId, patchPlanBodyDto)=>{
    return client({
        data: patchPlanBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/plans/${planId}`
    });
};
export const getPortalMiddlewarePatchPlanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return portalMiddlewarePatchPlan(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchPlan = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchPlanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEsaProgram = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plans/${planId}/esa-program`
    });
};
export const getPortalMiddlewareGetEsaProgramQueryKey = (planId)=>{
    return [
        `/pm/api/plans/${planId}/esa-program`
    ];
};
export const getPortalMiddlewareGetEsaProgramQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEsaProgramQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetEsaProgram(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEsaProgram(planId, options) {
    const queryOptions = getPortalMiddlewareGetEsaProgramQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanInvestments = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plans/${planId}/investments`
    });
};
export const getPortalMiddlewareGetPlanInvestmentsQueryKey = (planId)=>{
    return [
        `/pm/api/plans/${planId}/investments`
    ];
};
export const getPortalMiddlewareGetPlanInvestmentsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanInvestmentsQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanInvestments(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanInvestments(planId, options) {
    const queryOptions = getPortalMiddlewareGetPlanInvestmentsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanModelSecurities = (planId, modelId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/plans/${planId}/models/${modelId}/securities`
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesQueryKey = (planId, modelId)=>{
    return [
        `/pm/api/plans/${planId}/models/${modelId}/securities`
    ];
};
export const getPortalMiddlewareGetPlanModelSecuritiesQueryOptions = (planId, modelId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanModelSecuritiesQueryKey(planId, modelId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanModelSecurities(planId, modelId, signal);
    return {
        enabled: !!(planId && modelId),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanModelSecurities(planId, modelId, options) {
    const queryOptions = getPortalMiddlewareGetPlanModelSecuritiesQueryOptions(planId, modelId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetProgramModels = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/program/models`
    });
};
export const getPortalMiddlewareGetProgramModelsQueryKey = (params)=>{
    return [
        `/pm/api/program/models`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetProgramModelsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetProgramModelsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetProgramModels(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetProgramModels(params, options) {
    const queryOptions = getPortalMiddlewareGetProgramModelsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetProgramInvestmentOptionsExport = (programId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/program/${programId}/investment-options/download`
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportQueryKey = (programId)=>{
    return [
        `/pm/api/program/${programId}/investment-options/download`
    ];
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportQueryOptions = (programId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetProgramInvestmentOptionsExportQueryKey(programId);
    const queryFn = ({ signal })=>portalMiddlewareGetProgramInvestmentOptionsExport(programId, signal);
    return {
        enabled: !!programId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetProgramInvestmentOptionsExport(programId, options) {
    const queryOptions = getPortalMiddlewareGetProgramInvestmentOptionsExportQueryOptions(programId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetProspectusUrlParts = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/prospectus/url`
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsQueryKey = ()=>{
    return [
        `/pm/api/prospectus/url`
    ];
};
export const getPortalMiddlewareGetProspectusUrlPartsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetProspectusUrlPartsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetProspectusUrlParts(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetProspectusUrlParts(options) {
    const queryOptions = getPortalMiddlewareGetProspectusUrlPartsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAdvisorReport = (advisorId, reportType, fileName, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/advisors/${advisorId}/${reportType}/${fileName}`
    });
};
export const getPortalMiddlewareGetAdvisorReportQueryKey = (advisorId, reportType, fileName, params)=>{
    return [
        `/pm/api/reports/advisors/${advisorId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAdvisorReportQueryOptions = (advisorId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAdvisorReportQueryKey(advisorId, reportType, fileName, params);
    const queryFn = ({ signal })=>portalMiddlewareGetAdvisorReport(advisorId, reportType, fileName, params, signal);
    return {
        enabled: !!(advisorId && reportType && fileName),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAdvisorReport(advisorId, reportType, fileName, params, options) {
    const queryOptions = getPortalMiddlewareGetAdvisorReportQueryOptions(advisorId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployeeReport = (employeeId, reportType, fileName, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/employees/${employeeId}/${reportType}/${fileName}`
    });
};
export const getPortalMiddlewareGetEmployeeReportQueryKey = (employeeId, reportType, fileName, params)=>{
    return [
        `/pm/api/reports/employees/${employeeId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeReportQueryOptions = (employeeId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeReportQueryKey(employeeId, reportType, fileName, params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeReport(employeeId, reportType, fileName, params, signal);
    return {
        enabled: !!(employeeId && reportType && fileName),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeReport(employeeId, reportType, fileName, params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeReportQueryOptions(employeeId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetUnregisteredParticipantsReport = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/participants/unregistered`
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportQueryKey = (params)=>{
    return [
        `/pm/api/reports/participants/unregistered`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetUnregisteredParticipantsReportQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetUnregisteredParticipantsReport(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetUnregisteredParticipantsReport(params, options) {
    const queryOptions = getPortalMiddlewareGetUnregisteredParticipantsReportQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanReport = (planId, reportType, fileName, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/reports/plans/${planId}/${reportType}/${fileName}`
    });
};
export const getPortalMiddlewareGetPlanReportQueryKey = (planId, reportType, fileName)=>{
    return [
        `/pm/api/reports/plans/${planId}/${reportType}/${fileName}`
    ];
};
export const getPortalMiddlewareGetPlanReportQueryOptions = (planId, reportType, fileName, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanReportQueryKey(planId, reportType, fileName);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanReport(planId, reportType, fileName, signal);
    return {
        enabled: !!(planId && reportType && fileName),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanReport(planId, reportType, fileName, options) {
    const queryOptions = getPortalMiddlewareGetPlanReportQueryOptions(planId, reportType, fileName, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSponsorReport = (sponsorId, reportType, fileName, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/sponsors/${sponsorId}/${reportType}/${fileName}`
    });
};
export const getPortalMiddlewareGetSponsorReportQueryKey = (sponsorId, reportType, fileName, params)=>{
    return [
        `/pm/api/reports/sponsors/${sponsorId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSponsorReportQueryOptions = (sponsorId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorReportQueryKey(sponsorId, reportType, fileName, params);
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorReport(sponsorId, reportType, fileName, params, signal);
    return {
        enabled: !!(sponsorId && reportType && fileName),
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorReport(sponsorId, reportType, fileName, params, options) {
    const queryOptions = getPortalMiddlewareGetSponsorReportQueryOptions(sponsorId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSubaTransactionsReport = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/reports/suba-transactions`
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportQueryKey = (params)=>{
    return [
        `/pm/api/reports/suba-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSubaTransactionsReportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSubaTransactionsReportQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSubaTransactionsReport(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSubaTransactionsReport(params, options) {
    const queryOptions = getPortalMiddlewareGetSubaTransactionsReportQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAllSafeHarborContributionTypes = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/safe-harbor-contribution-types`
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesQueryKey = ()=>{
    return [
        `/pm/api/safe-harbor-contribution-types`
    ];
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAllSafeHarborContributionTypesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetAllSafeHarborContributionTypes(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAllSafeHarborContributionTypes(options) {
    const queryOptions = getPortalMiddlewareGetAllSafeHarborContributionTypesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSubaExternalMarketValue = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sdba/external-market-value`
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueQueryKey = (params)=>{
    return [
        `/pm/api/sdba/external-market-value`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSubaExternalMarketValueQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSubaExternalMarketValueQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSubaExternalMarketValue(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSubaExternalMarketValue(params, options) {
    const queryOptions = getPortalMiddlewareGetSubaExternalMarketValueQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostSubaInitiateExternalTransfer = (postSubaInitiateExternalTransferBodyDto)=>{
    return client({
        data: postSubaInitiateExternalTransferBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sdba/initiate-external-transfer`
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostSubaInitiateExternalTransfer(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostSubaInitiateExternalTransfer = (options)=>{
    const mutationOptions = getPortalMiddlewarePostSubaInitiateExternalTransferMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSdbaSetup = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sdba/setup`
    });
};
export const getPortalMiddlewareGetSdbaSetupQueryKey = ()=>{
    return [
        `/pm/api/sdba/setup`
    ];
};
export const getPortalMiddlewareGetSdbaSetupQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSdbaSetupQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSdbaSetup(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSdbaSetup(options) {
    const queryOptions = getPortalMiddlewareGetSdbaSetupQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSdbaTransfersInfo = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sdba/transfers`
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoQueryKey = (params)=>{
    return [
        `/pm/api/sdba/transfers`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSdbaTransfersInfoQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSdbaTransfersInfoQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSdbaTransfersInfo(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSdbaTransfersInfo(params, options) {
    const queryOptions = getPortalMiddlewareGetSdbaTransfersInfoQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCheckActiveSdbaTransfers = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sdba/transfers-in-progress`
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersQueryKey = (params)=>{
    return [
        `/pm/api/sdba/transfers-in-progress`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCheckActiveSdbaTransfersQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetCheckActiveSdbaTransfers(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCheckActiveSdbaTransfers(params, options) {
    const queryOptions = getPortalMiddlewareGetCheckActiveSdbaTransfersQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSession = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/session`
    });
};
export const getPortalMiddlewareGetSessionQueryKey = ()=>{
    return [
        `/pm/api/session`
    ];
};
export const getPortalMiddlewareGetSessionQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSessionQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSession(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSession(options) {
    const queryOptions = getPortalMiddlewareGetSessionQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSponsorAbilities = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/abilities`
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/abilities`
    ];
};
export const getPortalMiddlewareGetSponsorAbilitiesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorAbilitiesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorAbilities(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorAbilities(options) {
    const queryOptions = getPortalMiddlewareGetSponsorAbilitiesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetAutoEnrollSponsorPlan = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/auto-enroll`
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/auto-enroll`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetAutoEnrollSponsorPlanQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetAutoEnrollSponsorPlan(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetAutoEnrollSponsorPlan(params, options) {
    const queryOptions = getPortalMiddlewareGetAutoEnrollSponsorPlanQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetCensusParticipants = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/census/participants`
    });
};
export const getPortalMiddlewareGetCensusParticipantsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/census/participants`
    ];
};
export const getPortalMiddlewareGetCensusParticipantsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCensusParticipantsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetCensusParticipants(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCensusParticipants(options) {
    const queryOptions = getPortalMiddlewareGetCensusParticipantsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetBankAccount = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/company/bank-account`
    });
};
export const getPortalMiddlewareGetBankAccountQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/company/bank-account`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetBankAccountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetBankAccountQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetBankAccount(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetBankAccount(params, options) {
    const queryOptions = getPortalMiddlewareGetBankAccountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostBankAccount = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/company/bank-account`
    });
};
export const getPortalMiddlewarePostBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostBankAccount();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePostBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutBankAccount = (postBankAccountDto)=>{
    return client({
        data: postBankAccountDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/company/bank-account`
    });
};
export const getPortalMiddlewarePutBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePutBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutSponsorArchiveBankAccount = (putBankAccountArchiveDto)=>{
    return client({
        data: putBankAccountArchiveDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/company/bank-account/archive`
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutSponsorArchiveBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutSponsorArchiveBankAccount = (options)=>{
    const mutationOptions = getPortalMiddlewarePutSponsorArchiveBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutFeePaymentMethod = (putFeePaymentMethodDto)=>{
    return client({
        data: putFeePaymentMethodDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/company/bank-account/fee-payment-method`
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutFeePaymentMethod(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutFeePaymentMethod = (options)=>{
    const mutationOptions = getPortalMiddlewarePutFeePaymentMethodMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePatchSponsor = (companyInfoBodyDto)=>{
    return client({
        data: companyInfoBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/sponsor/company/company-info`
    });
};
export const getPortalMiddlewarePatchSponsorMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchSponsor(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchSponsor = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchSponsorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorTeammates = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/company/manage-teammate`
    });
};
export const getPortalMiddlewareGetSponsorTeammatesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/company/manage-teammate`
    ];
};
export const getPortalMiddlewareGetSponsorTeammatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorTeammatesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorTeammates(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorTeammates(options) {
    const queryOptions = getPortalMiddlewareGetSponsorTeammatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchDeleteTeammate = ()=>{
    return client({
        method: 'PATCH',
        url: `/pm/api/sponsor/company/manage-teammate`
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePatchDeleteTeammate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchDeleteTeammate = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchDeleteTeammateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostSendUserInvite = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/company/manage-teammate`
    });
};
export const getPortalMiddlewarePostSendUserInviteMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostSendUserInvite();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostSendUserInvite = (options)=>{
    const mutationOptions = getPortalMiddlewarePostSendUserInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanConfigurationV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/configuration`
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/configuration`
    ];
};
export const getPortalMiddlewareGetPlanConfigurationV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanConfigurationV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanConfigurationV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanConfigurationV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanConfigurationV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanConfigurationV2 = (putPlanConfigurationBodyDtoV2)=>{
    return client({
        data: putPlanConfigurationBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/configuration`
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanConfigurationV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanConfigurationV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanConfigurationV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanEmployeesV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/employees`
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/employees`
    ];
};
export const getPortalMiddlewareGetPlanEmployeesV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanEmployeesV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanEmployeesV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanEmployeesV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanEmployeesV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanGrossCompensationV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/gross-compensation`
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/gross-compensation`
    ];
};
export const getPortalMiddlewareGetPlanGrossCompensationV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanGrossCompensationV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanGrossCompensationV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanGrossCompensationV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanGrossCompensationV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanEmployeeGrossCompensationV2 = (putPlanGrossCompensationBodyDtoV2)=>{
    return client({
        data: putPlanGrossCompensationBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/gross-compensation`
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanEmployeeGrossCompensationV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanEmployeeGrossCompensationV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetGrossCompensationTemplateV2 = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/compliance/gross-compensation/download/template`
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2QueryKey = (params)=>{
    return [
        `/pm/api/sponsor/compliance/gross-compensation/download/template`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGrossCompensationTemplateV2QueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetGrossCompensationTemplateV2(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGrossCompensationTemplateV2(params, options) {
    const queryOptions = getPortalMiddlewareGetGrossCompensationTemplateV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPlanEmployeeGrossCompensationUploadV2 = (postPlanGrossCompensationUploadBodyDtoV2)=>{
    return client({
        data: postPlanGrossCompensationUploadBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/compliance/gross-compensation/upload`
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanEmployeeGrossCompensationUploadV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostPlanNonEmployeeOwnerV2 = (postPlanNonEmployeeOwnerBodyDtoV2)=>{
    return client({
        data: postPlanNonEmployeeOwnerBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/compliance/non-employee-owner`
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanNonEmployeeOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanNonEmployeeOwnerV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanNonEmployeeOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOfficersV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/officers`
    });
};
export const getPortalMiddlewareGetPlanOfficersV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/officers`
    ];
};
export const getPortalMiddlewareGetPlanOfficersV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOfficersV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOfficersV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOfficersV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanOfficersV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanOfficerStatusV2 = (putPlanOfficersBodyDtoV2)=>{
    return client({
        data: putPlanOfficersBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/officers`
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanOfficerStatusV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanOfficerStatusV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanOfficerStatusV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePlanOwnerV2 = (deletePlanOwnerBodyDtoV2)=>{
    return client({
        data: deletePlanOwnerBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/sponsor/compliance/owners`
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeletePlanOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePlanOwnerV2 = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePlanOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOwnersV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/compliance/owners`
    });
};
export const getPortalMiddlewareGetPlanOwnersV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/compliance/owners`
    ];
};
export const getPortalMiddlewareGetPlanOwnersV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOwnersV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOwnersV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOwnersV2(options) {
    const queryOptions = getPortalMiddlewareGetPlanOwnersV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPlanEmployeeOwnerV2 = (postPlanEmployeeOwnerBodyDtoV2)=>{
    return client({
        data: postPlanEmployeeOwnerBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/compliance/owners`
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanEmployeeOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanEmployeeOwnerV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanEmployeeOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPlanEmployeeOwnerV2 = (putPlanEmployeeOwnerBodyDtoV2)=>{
    return client({
        data: putPlanEmployeeOwnerBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/owners`
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanEmployeeOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanEmployeeOwnerV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanEmployeeOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePlanOwnersFamilyV2 = (deletePlanOwnersFamilyBodyDtoV2)=>{
    return client({
        data: deletePlanOwnersFamilyBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/sponsor/compliance/owners-family`
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeletePlanOwnersFamilyV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePlanOwnersFamilyV2 = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePlanOwnersFamilyV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOwnersFamilyV2 = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/compliance/owners-family`
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2QueryKey = (params)=>{
    return [
        `/pm/api/sponsor/compliance/owners-family`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOwnersFamilyV2QueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOwnersFamilyV2(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOwnersFamilyV2(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanOwnersFamilyV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanOwnersFamilyV2 = (putPlanOwnersFamilyBodyDtoV2)=>{
    return client({
        data: putPlanOwnersFamilyBodyDtoV2,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/compliance/owners-family`
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanOwnersFamilyV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanOwnersFamilyV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanOwnersFamilyV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostFileHeadersUpdate = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contribution/headers/mapping`
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostFileHeadersUpdate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostFileHeadersUpdate = (options)=>{
    const mutationOptions = getPortalMiddlewarePostFileHeadersUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionsLandingPageDisplay = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions`
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayQueryKey = ()=>{
    return [
        `/pm/api/sponsor/contributions`
    ];
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionsLandingPageDisplayQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetContributionsLandingPageDisplay(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionsLandingPageDisplay(options) {
    const queryOptions = getPortalMiddlewareGetContributionsLandingPageDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContribution = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions`
    });
};
export const getPortalMiddlewarePostContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostContribution();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContribution = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostCancelSubmission = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/cancel`
    });
};
export const getPortalMiddlewarePostCancelSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostCancelSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCancelSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCancelSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostCancellationSubmission = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/cancellation`
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostCancellationSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCancellationSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCancellationSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantsLoans = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/loans`
    });
};
export const getPortalMiddlewareGetParticipantsLoansQueryKey = ()=>{
    return [
        `/pm/api/sponsor/contributions/loans`
    ];
};
export const getPortalMiddlewareGetParticipantsLoansQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantsLoansQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantsLoans(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantsLoans(options) {
    const queryOptions = getPortalMiddlewareGetParticipantsLoansQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostMatchRemediationContribution = (postMatchRemediationContributionBodyDto)=>{
    return client({
        data: postMatchRemediationContributionBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/contributions/match-remediation`
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostMatchRemediationContribution(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostMatchRemediationContribution = (options)=>{
    const mutationOptions = getPortalMiddlewarePostMatchRemediationContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostOffCycleContribution = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/offcycle`
    });
};
export const getPortalMiddlewarePostOffCycleContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostOffCycleContribution();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostOffCycleContribution = (options)=>{
    const mutationOptions = getPortalMiddlewarePostOffCycleContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostResumeSubmission = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/resume`
    });
};
export const getPortalMiddlewarePostResumeSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostResumeSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostResumeSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePostResumeSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostIngestionFlowValidation = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/validate`
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostIngestionFlowValidation();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostIngestionFlowValidation = (options)=>{
    const mutationOptions = getPortalMiddlewarePostIngestionFlowValidationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostContributionValidation = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/validation`
    });
};
export const getPortalMiddlewarePostContributionValidationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostContributionValidation();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionValidation = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionValidationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionSubmissionDisplay = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}`
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}`
    ];
};
export const getPortalMiddlewareGetContributionSubmissionDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionSubmissionDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionSubmissionDisplay(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionSubmissionDisplay(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionSubmissionDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionAdjustments = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/adjustments`
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/adjustments`
    ];
};
export const getPortalMiddlewareGetContributionAdjustmentsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionAdjustmentsQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionAdjustments(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionAdjustments(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionAdjustmentsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContributionConfirmation = (ucid, postContributionConfirmationBodyDto)=>{
    return client({
        data: postContributionConfirmationBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/confirm`
    });
};
export const getPortalMiddlewarePostContributionConfirmationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid, data } = props ?? {};
        return portalMiddlewarePostContributionConfirmation(ucid, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionConfirmation = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionConfirmationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionConfirmationDisplay = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/confirmation`
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/confirmation`
    ];
};
export const getPortalMiddlewareGetContributionConfirmationDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionConfirmationDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionConfirmationDisplay(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionConfirmationDisplay(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionConfirmationDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContributionCorrection = (ucid)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/correction`
    });
};
export const getPortalMiddlewarePostContributionCorrectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return portalMiddlewarePostContributionCorrection(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionCorrection = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionCorrectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionCorrections = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/corrections`
    });
};
export const getPortalMiddlewareGetContributionCorrectionsQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/corrections`
    ];
};
export const getPortalMiddlewareGetContributionCorrectionsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionCorrectionsQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionCorrections(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionCorrections(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionCorrectionsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionDetails = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/details`
    });
};
export const getPortalMiddlewareGetContributionDetailsQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/details`
    ];
};
export const getPortalMiddlewareGetContributionDetailsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionDetailsQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionDetails(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionDetails(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionDetailsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionDisplay = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/display`
    });
};
export const getPortalMiddlewareGetContributionDisplayQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/display`
    ];
};
export const getPortalMiddlewareGetContributionDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionDisplay(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionDisplay(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContributionUpload = (ucid, categoryId)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/document-category/${categoryId}/upload`
    });
};
export const getPortalMiddlewarePostContributionUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid, categoryId } = props ?? {};
        return portalMiddlewarePostContributionUpload(ucid, categoryId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionUpload = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDownloadContributionFile = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/file`
    });
};
export const getPortalMiddlewareGetDownloadContributionFileQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/file`
    ];
};
export const getPortalMiddlewareGetDownloadContributionFileQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDownloadContributionFileQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetDownloadContributionFile(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDownloadContributionFile(ucid, options) {
    const queryOptions = getPortalMiddlewareGetDownloadContributionFileQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetForfeiture = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/forfeiture`
    });
};
export const getPortalMiddlewareGetForfeitureQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/forfeiture`
    ];
};
export const getPortalMiddlewareGetForfeitureQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetForfeitureQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetForfeiture(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetForfeiture(ucid, options) {
    const queryOptions = getPortalMiddlewareGetForfeitureQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostForfeiture = (ucid)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/forfeiture`
    });
};
export const getPortalMiddlewarePostForfeitureMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return portalMiddlewarePostForfeiture(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostForfeiture = (options)=>{
    const mutationOptions = getPortalMiddlewarePostForfeitureMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetContributionHeaderValidations = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/headers`
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/headers`
    ];
};
export const getPortalMiddlewareGetContributionHeaderValidationsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionHeaderValidationsQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionHeaderValidations(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionHeaderValidations(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionHeaderValidationsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetNormalizedContributionData = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/normalized`
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/normalized`
    ];
};
export const getPortalMiddlewareGetNormalizedContributionDataQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetNormalizedContributionDataQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetNormalizedContributionData(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetNormalizedContributionData(ucid, options) {
    const queryOptions = getPortalMiddlewareGetNormalizedContributionDataQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostIngestionFlowStart = (ucid)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/contributions/${ucid}/start`
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return portalMiddlewarePostIngestionFlowStart(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostIngestionFlowStart = (options)=>{
    const mutationOptions = getPortalMiddlewarePostIngestionFlowStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetDownloadContributionTemplate = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/template.xlsx`
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/template.xlsx`
    ];
};
export const getPortalMiddlewareGetDownloadContributionTemplateQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDownloadContributionTemplateQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetDownloadContributionTemplate(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDownloadContributionTemplate(ucid, options) {
    const queryOptions = getPortalMiddlewareGetDownloadContributionTemplateQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetUnallocatedFunds = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/unallocated-funds`
    });
};
export const getPortalMiddlewareGetUnallocatedFundsQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/unallocated-funds`
    ];
};
export const getPortalMiddlewareGetUnallocatedFundsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetUnallocatedFundsQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetUnallocatedFunds(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetUnallocatedFunds(ucid, options) {
    const queryOptions = getPortalMiddlewareGetUnallocatedFundsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionValidationPageDisplay = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/validate`
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/validate`
    ];
};
export const getPortalMiddlewareGetContributionValidationPageDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionValidationPageDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionValidationPageDisplay(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionValidationPageDisplay(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionValidationPageDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributionValidation = (ucid, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/contributions/${ucid}/validation`
    });
};
export const getPortalMiddlewareGetContributionValidationQueryKey = (ucid)=>{
    return [
        `/pm/api/sponsor/contributions/${ucid}/validation`
    ];
};
export const getPortalMiddlewareGetContributionValidationQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionValidationQueryKey(ucid);
    const queryFn = ({ signal })=>portalMiddlewareGetContributionValidation(ucid, signal);
    return {
        enabled: !!ucid,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributionValidation(ucid, options) {
    const queryOptions = getPortalMiddlewareGetContributionValidationQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetDeferralChanges = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/deferral/changes`
    });
};
export const getPortalMiddlewareGetDeferralChangesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/deferral/changes`
    ];
};
export const getPortalMiddlewareGetDeferralChangesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetDeferralChangesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetDeferralChanges(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetDeferralChanges(options) {
    const queryOptions = getPortalMiddlewareGetDeferralChangesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchDeferralChangesActivities = ()=>{
    return client({
        method: 'PATCH',
        url: `/pm/api/sponsor/deferral/changes`
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePatchDeferralChangesActivities();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchDeferralChangesActivities = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchDeferralChangesActivitiesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutParticipant = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/employee`
    });
};
export const getPortalMiddlewarePutParticipantMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutParticipant();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutParticipant = (options)=>{
    const mutationOptions = getPortalMiddlewarePutParticipantMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEmployeeClasses = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/employee-classes`
    });
};
export const getPortalMiddlewareGetEmployeeClassesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/employee-classes`
    ];
};
export const getPortalMiddlewareGetEmployeeClassesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeClassesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeClasses(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeClasses(options) {
    const queryOptions = getPortalMiddlewareGetEmployeeClassesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEmployees = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/employees`
    });
};
export const getPortalMiddlewareGetEmployeesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/employees`
    ];
};
export const getPortalMiddlewareGetEmployeesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetEmployees(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployees(options) {
    const queryOptions = getPortalMiddlewareGetEmployeesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutParticipants = (putParticipantsBodyDto)=>{
    return client({
        data: putParticipantsBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/employees`
    });
};
export const getPortalMiddlewarePutParticipantsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutParticipants(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutParticipants = (options)=>{
    const mutationOptions = getPortalMiddlewarePutParticipantsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostUploadCensusOriginal = (postCensusOriginalBodyDto)=>{
    return client({
        data: postCensusOriginalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/employees/original`
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostUploadCensusOriginal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostUploadCensusOriginal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostUploadCensusOriginalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEmployeeDetailsV2 = (employeeId, params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/employees/v2/${employeeId}`
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2QueryKey = (employeeId, params)=>{
    return [
        `/pm/api/sponsor/employees/v2/${employeeId}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetEmployeeDetailsV2QueryOptions = (employeeId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeDetailsV2QueryKey(employeeId, params);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeDetailsV2(employeeId, params, signal);
    return {
        enabled: !!employeeId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeDetailsV2(employeeId, params, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeDetailsV2QueryOptions(employeeId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostValidateEmployee = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/employees/validate`
    });
};
export const getPortalMiddlewarePostValidateEmployeeMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostValidateEmployee();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostValidateEmployee = (options)=>{
    const mutationOptions = getPortalMiddlewarePostValidateEmployeeMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetEmployeeDetails = (employeeId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/employees/${employeeId}`
    });
};
export const getPortalMiddlewareGetEmployeeDetailsQueryKey = (employeeId)=>{
    return [
        `/pm/api/sponsor/employees/${employeeId}`
    ];
};
export const getPortalMiddlewareGetEmployeeDetailsQueryOptions = (employeeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEmployeeDetailsQueryKey(employeeId);
    const queryFn = ({ signal })=>portalMiddlewareGetEmployeeDetails(employeeId, signal);
    return {
        enabled: !!employeeId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEmployeeDetails(employeeId, options) {
    const queryOptions = getPortalMiddlewareGetEmployeeDetailsQueryOptions(employeeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContactInfo = (employeeId)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/employees/${employeeId}/address`
    });
};
export const getPortalMiddlewarePostContactInfoMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { employeeId } = props ?? {};
        return portalMiddlewarePostContactInfo(employeeId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContactInfo = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContactInfoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutParticipantContributions = (employeeId)=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/employees/${employeeId}/contributions`
    });
};
export const getPortalMiddlewarePutParticipantContributionsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { employeeId } = props ?? {};
        return portalMiddlewarePutParticipantContributions(employeeId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutParticipantContributions = (options)=>{
    const mutationOptions = getPortalMiddlewarePutParticipantContributionsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorEntity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/entity`
    });
};
export const getPortalMiddlewareGetSponsorEntityQueryKey = ()=>{
    return [
        `/pm/api/sponsor/entity`
    ];
};
export const getPortalMiddlewareGetSponsorEntityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorEntityQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorEntity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorEntity(options) {
    const queryOptions = getPortalMiddlewareGetSponsorEntityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetForfeiturePreference = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/forfeiture-preference`
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceQueryKey = ()=>{
    return [
        `/pm/api/sponsor/forfeiture-preference`
    ];
};
export const getPortalMiddlewareGetForfeiturePreferenceQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetForfeiturePreferenceQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetForfeiturePreference(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetForfeiturePreference(options) {
    const queryOptions = getPortalMiddlewareGetForfeiturePreferenceQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutForfeiturePreference = (putForfeiturePreferenceBodyDto)=>{
    return client({
        data: putForfeiturePreferenceBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/forfeiture-preference`
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutForfeiturePreference(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutForfeiturePreference = (options)=>{
    const mutationOptions = getPortalMiddlewarePutForfeiturePreferenceMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetHeapData = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/heap`
    });
};
export const getPortalMiddlewareGetHeapDataQueryKey = ()=>{
    return [
        `/pm/api/sponsor/heap`
    ];
};
export const getPortalMiddlewareGetHeapDataQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetHeapDataQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetHeapData(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetHeapData(options) {
    const queryOptions = getPortalMiddlewareGetHeapDataQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetOnboarding = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/onboarding`
    });
};
export const getPortalMiddlewareGetOnboardingQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/onboarding`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetOnboardingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetOnboardingQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetOnboarding(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetOnboarding(params, options) {
    const queryOptions = getPortalMiddlewareGetOnboardingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostOnboarding = (params)=>{
    return client({
        method: 'POST',
        params,
        url: `/pm/api/sponsor/onboarding`
    });
};
export const getPortalMiddlewarePostOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { params } = props ?? {};
        return portalMiddlewarePostOnboarding(params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostOnboarding = (options)=>{
    const mutationOptions = getPortalMiddlewarePostOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutOnboarding = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/onboarding`
    });
};
export const getPortalMiddlewarePutOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutOnboarding();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutOnboarding = (options)=>{
    const mutationOptions = getPortalMiddlewarePutOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorOnboardingInformation = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding-information`
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding-information`
    ];
};
export const getPortalMiddlewareGetSponsorOnboardingInformationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorOnboardingInformationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorOnboardingInformation(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorOnboardingInformation(options) {
    const queryOptions = getPortalMiddlewareGetSponsorOnboardingInformationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutSponsorOnboardingInformation = (putSponsorOnboardingInformationDto)=>{
    return client({
        data: putSponsorOnboardingInformationDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/onboarding-information`
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutSponsorOnboardingInformation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutSponsorOnboardingInformation = (options)=>{
    const mutationOptions = getPortalMiddlewarePutSponsorOnboardingInformationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostUploadCensus = (postCensusBodyDto)=>{
    return client({
        data: postCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/add-employees`
    });
};
export const getPortalMiddlewarePostUploadCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostUploadCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostUploadCensus = (options)=>{
    const mutationOptions = getPortalMiddlewarePostUploadCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostUploadOnboardingCensusOriginal = (postCensusOriginalBodyDto)=>{
    return client({
        data: postCensusOriginalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/add-employees/original`
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostUploadOnboardingCensusOriginal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostUploadOnboardingCensusOriginal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostUploadOnboardingCensusOriginalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetInitialCensus = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/onboarding/census`
    });
};
export const getPortalMiddlewareGetInitialCensusQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/onboarding/census`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetInitialCensusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetInitialCensusQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetInitialCensus(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetInitialCensus(params, options) {
    const queryOptions = getPortalMiddlewareGetInitialCensusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareDeleteCensusCache = ()=>{
    return client({
        method: 'DELETE',
        url: `/pm/api/sponsor/onboarding/census-cache`
    });
};
export const getPortalMiddlewareDeleteCensusCacheMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewareDeleteCensusCache();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeleteCensusCache = (options)=>{
    const mutationOptions = getPortalMiddlewareDeleteCensusCacheMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetCensusCache = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/census-cache`
    });
};
export const getPortalMiddlewareGetCensusCacheQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/census-cache`
    ];
};
export const getPortalMiddlewareGetCensusCacheQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCensusCacheQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetCensusCache(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCensusCache(options) {
    const queryOptions = getPortalMiddlewareGetCensusCacheQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostCensusCache = (postCensusCacheBodyDto)=>{
    return client({
        data: postCensusCacheBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/census-cache`
    });
};
export const getPortalMiddlewarePostCensusCacheMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostCensusCache(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCensusCache = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCensusCacheMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorEsaProgram = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/onboarding/esa-program`
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/onboarding/esa-program`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSponsorEsaProgramQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorEsaProgramQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorEsaProgram(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorEsaProgram(params, options) {
    const queryOptions = getPortalMiddlewareGetSponsorEsaProgramQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostFinishOnboarding = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/finish`
    });
};
export const getPortalMiddlewarePostFinishOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostFinishOnboarding();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostFinishOnboarding = (options)=>{
    const mutationOptions = getPortalMiddlewarePostFinishOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetSponsorOnboardingTeammates = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/manage-teammate`
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/manage-teammate`
    ];
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorOnboardingTeammatesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorOnboardingTeammates(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorOnboardingTeammates(options) {
    const queryOptions = getPortalMiddlewareGetSponsorOnboardingTeammatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostSendOnboardingUserInvite = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/manage-teammate`
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostSendOnboardingUserInvite();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostSendOnboardingUserInvite = (options)=>{
    const mutationOptions = getPortalMiddlewarePostSendOnboardingUserInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetNextPayrollDates = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/payroll-dates`
    });
};
export const getPortalMiddlewareGetNextPayrollDatesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/payroll-dates`
    ];
};
export const getPortalMiddlewareGetNextPayrollDatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetNextPayrollDatesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetNextPayrollDates(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetNextPayrollDates(options) {
    const queryOptions = getPortalMiddlewareGetNextPayrollDatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollProviders = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/payroll-providers`
    });
};
export const getPortalMiddlewareGetPayrollProvidersQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/payroll-providers`
    ];
};
export const getPortalMiddlewareGetPayrollProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollProvidersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollProviders(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollProviders(options) {
    const queryOptions = getPortalMiddlewareGetPayrollProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSponsorPlaidLinkToken = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/plaid-link-token`
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/plaid-link-token`
    ];
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorPlaidLinkTokenQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorPlaidLinkToken(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorPlaidLinkToken(options) {
    const queryOptions = getPortalMiddlewareGetSponsorPlaidLinkTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostGetSponsorPlaidLinks = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/onboarding/plaid-links`
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostGetSponsorPlaidLinks();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostGetSponsorPlaidLinks = (options)=>{
    const mutationOptions = getPortalMiddlewarePostGetSponsorPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanDesignConsultState = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/plan-design-consult-state`
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/plan-design-consult-state`
    ];
};
export const getPortalMiddlewareGetPlanDesignConsultStateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanDesignConsultStateQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanDesignConsultState(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanDesignConsultState(options) {
    const queryOptions = getPortalMiddlewareGetPlanDesignConsultStateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchPlanDesignConsultState = (patchPlanDesignConsultStateDto)=>{
    return client({
        data: patchPlanDesignConsultStateDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/sponsor/onboarding/plan-design-consult-state`
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchPlanDesignConsultState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchPlanDesignConsultState = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchPlanDesignConsultStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanLaunchCallUrl = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/plan-launch-call`
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/plan-launch-call`
    ];
};
export const getPortalMiddlewareGetPlanLaunchCallUrlQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanLaunchCallUrlQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanLaunchCallUrl(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanLaunchCallUrl(options) {
    const queryOptions = getPortalMiddlewareGetPlanLaunchCallUrlQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetUserRoles = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/onboarding/user-roles`
    });
};
export const getPortalMiddlewareGetUserRolesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/onboarding/user-roles`
    ];
};
export const getPortalMiddlewareGetUserRolesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetUserRolesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetUserRoles(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetUserRoles(options) {
    const queryOptions = getPortalMiddlewareGetUserRolesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollConnectionStatus = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/payroll/connection-status`
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusQueryKey = ()=>{
    return [
        `/pm/api/sponsor/payroll/connection-status`
    ];
};
export const getPortalMiddlewareGetPayrollConnectionStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollConnectionStatusQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollConnectionStatus(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollConnectionStatus(options) {
    const queryOptions = getPortalMiddlewareGetPayrollConnectionStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollConnectionStatusV2 = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/payroll/connection-status/v2`
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2QueryKey = ()=>{
    return [
        `/pm/api/sponsor/payroll/connection-status/v2`
    ];
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollConnectionStatusV2QueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollConnectionStatusV2(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollConnectionStatusV2(options) {
    const queryOptions = getPortalMiddlewareGetPayrollConnectionStatusV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollDates = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/payroll/dates`
    });
};
export const getPortalMiddlewareGetPayrollDatesQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/payroll/dates`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPayrollDatesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollDatesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollDates(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollDates(params, options) {
    const queryOptions = getPortalMiddlewareGetPayrollDatesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollInfo = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/payroll/info`
    });
};
export const getPortalMiddlewareGetPayrollInfoQueryKey = ()=>{
    return [
        `/pm/api/sponsor/payroll/info`
    ];
};
export const getPortalMiddlewareGetPayrollInfoQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollInfoQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollInfo(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollInfo(options) {
    const queryOptions = getPortalMiddlewareGetPayrollInfoQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPayrollSetups = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/payroll/setup`
    });
};
export const getPortalMiddlewareGetPayrollSetupsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/payroll/setup`
    ];
};
export const getPortalMiddlewareGetPayrollSetupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollSetupsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollSetups(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollSetups(options) {
    const queryOptions = getPortalMiddlewareGetPayrollSetupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPayrollSetup = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/payroll/setup`
    });
};
export const getPortalMiddlewarePostPayrollSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostPayrollSetup();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPayrollSetup = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPayrollSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostBulkPayrollSetupDisconnection = (bulkPayrollSetupDto)=>{
    return client({
        data: bulkPayrollSetupDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/payroll/setup/disconnect`
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostBulkPayrollSetupDisconnection(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostBulkPayrollSetupDisconnection = (options)=>{
    const mutationOptions = getPortalMiddlewarePostBulkPayrollSetupDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPayrollFundingSetups = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/payroll/setup/funding`
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/payroll/setup/funding`
    ];
};
export const getPortalMiddlewareGetPayrollFundingSetupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPayrollFundingSetupsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPayrollFundingSetups(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPayrollFundingSetups(options) {
    const queryOptions = getPortalMiddlewareGetPayrollFundingSetupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPayrollProvider = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/provider`
    });
};
export const getPortalMiddlewarePutPayrollProviderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutPayrollProvider();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPayrollProvider = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPayrollProviderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPayrollSkipStatus = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/skip`
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutPayrollSkipStatus();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPayrollSkipStatus = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPayrollSkipStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutSkipSubmission = ()=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/skipping`
    });
};
export const getPortalMiddlewarePutSkipSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePutSkipSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutSkipSubmission = (options)=>{
    const mutationOptions = getPortalMiddlewarePutSkipSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePayrollSetup = (payrollSetupId)=>{
    return client({
        method: 'DELETE',
        url: `/pm/api/sponsor/payroll/setup/${payrollSetupId}`
    });
};
export const getPortalMiddlewareDeletePayrollSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return portalMiddlewareDeletePayrollSetup(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePayrollSetup = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePayrollSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPayrollDates = (payrollSetupId)=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/${payrollSetupId}/dates`
    });
};
export const getPortalMiddlewarePutPayrollDatesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return portalMiddlewarePutPayrollDates(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPayrollDates = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPayrollDatesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostPayrollSetupDisconnection = (payrollSetupId)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/payroll/setup/${payrollSetupId}/disconnect`
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return portalMiddlewarePostPayrollSetupDisconnection(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPayrollSetupDisconnection = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPayrollSetupDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPayrollSetupInfo = (payrollSetupId)=>{
    return client({
        method: 'PUT',
        url: `/pm/api/sponsor/payroll/setup/${payrollSetupId}/info`
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return portalMiddlewarePutPayrollSetupInfo(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPayrollSetupInfo = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPayrollSetupInfoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostPayrollValidations = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/payroll/validate`
    });
};
export const getPortalMiddlewarePostPayrollValidationsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostPayrollValidations();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPayrollValidations = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPayrollValidationsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanFeatures = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/plan-features`
    });
};
export const getPortalMiddlewareGetPlanFeaturesQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/plan-features`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanFeaturesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanFeaturesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanFeatures(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanFeatures(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanFeaturesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanOnboardingStatus = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/plan/onboarding/status`
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusQueryKey = ()=>{
    return [
        `/pm/api/sponsor/plan/onboarding/status`
    ];
};
export const getPortalMiddlewareGetPlanOnboardingStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOnboardingStatusQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOnboardingStatus(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOnboardingStatus(options) {
    const queryOptions = getPortalMiddlewareGetPlanOnboardingStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostSponsorPlanDisconnection = (planId)=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/plan/${planId}/disconnect`
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return portalMiddlewarePostSponsorPlanDisconnection(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostSponsorPlanDisconnection = (options)=>{
    const mutationOptions = getPortalMiddlewarePostSponsorPlanDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanStatistics = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/plans/${planId}/stats`
    });
};
export const getPortalMiddlewareGetPlanStatisticsQueryKey = (planId)=>{
    return [
        `/pm/api/sponsor/plans/${planId}/stats`
    ];
};
export const getPortalMiddlewareGetPlanStatisticsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanStatisticsQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanStatistics(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanStatistics(planId, options) {
    const queryOptions = getPortalMiddlewareGetPlanStatisticsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanConfiguration = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/configuration`
    });
};
export const getPortalMiddlewareGetPlanConfigurationQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/configuration`
    ];
};
export const getPortalMiddlewareGetPlanConfigurationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanConfigurationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanConfiguration(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanConfiguration(options) {
    const queryOptions = getPortalMiddlewareGetPlanConfigurationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanConfiguration = (putPlanConfigurationBodyDto)=>{
    return client({
        data: putPlanConfigurationBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/configuration`
    });
};
export const getPortalMiddlewarePutPlanConfigurationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanConfiguration(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanConfiguration = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanConfigurationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanEmployees = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/employees`
    });
};
export const getPortalMiddlewareGetPlanEmployeesQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/employees`
    ];
};
export const getPortalMiddlewareGetPlanEmployeesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanEmployeesQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanEmployees(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanEmployees(options) {
    const queryOptions = getPortalMiddlewareGetPlanEmployeesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetPlanGrossCompensation = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/gross-compensation`
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/gross-compensation`
    ];
};
export const getPortalMiddlewareGetPlanGrossCompensationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanGrossCompensationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanGrossCompensation(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanGrossCompensation(options) {
    const queryOptions = getPortalMiddlewareGetPlanGrossCompensationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanEmployeeGrossCompensation = (putPlanGrossCompensationBodyDto)=>{
    return client({
        data: putPlanGrossCompensationBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/gross-compensation`
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanEmployeeGrossCompensation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanEmployeeGrossCompensation = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanEmployeeGrossCompensationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetGrossCompensationTemplate = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/pocet/gross-compensation/download/template`
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/pocet/gross-compensation/download/template`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetGrossCompensationTemplateQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetGrossCompensationTemplateQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetGrossCompensationTemplate(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetGrossCompensationTemplate(params, options) {
    const queryOptions = getPortalMiddlewareGetGrossCompensationTemplateQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPlanEmployeeGrossCompensationUpload = (postPlanGrossCompensationUploadBodyDto)=>{
    return client({
        data: postPlanGrossCompensationUploadBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/pocet/gross-compensation/upload`
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanEmployeeGrossCompensationUpload(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanEmployeeGrossCompensationUpload = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostPlanNonEmployeeOwner = (postPlanNonEmployeeOwnerBodyDto)=>{
    return client({
        data: postPlanNonEmployeeOwnerBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/pocet/non-employee-owner`
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanNonEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanNonEmployeeOwner = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanNonEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOfficers = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/officers`
    });
};
export const getPortalMiddlewareGetPlanOfficersQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/officers`
    ];
};
export const getPortalMiddlewareGetPlanOfficersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOfficersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOfficers(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOfficers(options) {
    const queryOptions = getPortalMiddlewareGetPlanOfficersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanOfficerStatus = (putPlanOfficersBodyDto)=>{
    return client({
        data: putPlanOfficersBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/officers`
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanOfficerStatus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanOfficerStatus = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanOfficerStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePlanOwner = (deletePlanOwnerBodyDto)=>{
    return client({
        data: deletePlanOwnerBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/sponsor/pocet/owners`
    });
};
export const getPortalMiddlewareDeletePlanOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeletePlanOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePlanOwner = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePlanOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOwners = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/owners`
    });
};
export const getPortalMiddlewareGetPlanOwnersQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/owners`
    ];
};
export const getPortalMiddlewareGetPlanOwnersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOwnersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOwners(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOwners(options) {
    const queryOptions = getPortalMiddlewareGetPlanOwnersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPlanEmployeeOwner = (postPlanEmployeeOwnerBodyDto)=>{
    return client({
        data: postPlanEmployeeOwnerBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/pocet/owners`
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostPlanEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPlanEmployeeOwner = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPlanEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePutPlanEmployeeOwner = (putPlanEmployeeOwnerBodyDto)=>{
    return client({
        data: putPlanEmployeeOwnerBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/owners`
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanEmployeeOwner = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareDeletePlanOwnersFamily = (deletePlanOwnersFamilyBodyDto)=>{
    return client({
        data: deletePlanOwnersFamilyBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'DELETE',
        url: `/pm/api/sponsor/pocet/owners-family`
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewareDeletePlanOwnersFamily(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewareDeletePlanOwnersFamily = (options)=>{
    const mutationOptions = getPortalMiddlewareDeletePlanOwnersFamilyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanOwnersFamily = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/pocet/owners-family`
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/pocet/owners-family`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanOwnersFamilyQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanOwnersFamilyQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanOwnersFamily(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanOwnersFamily(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanOwnersFamilyQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutPlanOwnersFamily = (putPlanOwnersFamilyBodyDto)=>{
    return client({
        data: putPlanOwnersFamilyBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/sponsor/pocet/owners-family`
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutPlanOwnersFamily(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutPlanOwnersFamily = (options)=>{
    const mutationOptions = getPortalMiddlewarePutPlanOwnersFamilyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetTrackerDetails = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/pocet/tracker`
    });
};
export const getPortalMiddlewareGetTrackerDetailsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/pocet/tracker`
    ];
};
export const getPortalMiddlewareGetTrackerDetailsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetTrackerDetailsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetTrackerDetails(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetTrackerDetails(options) {
    const queryOptions = getPortalMiddlewareGetTrackerDetailsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostPriorProvider = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/sponsor/prior-provider`
    });
};
export const getPortalMiddlewarePostPriorProviderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostPriorProvider();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostPriorProvider = (options)=>{
    const mutationOptions = getPortalMiddlewarePostPriorProviderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPriorProviders = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/prior-providers`
    });
};
export const getPortalMiddlewareGetPriorProvidersQueryKey = ()=>{
    return [
        `/pm/api/sponsor/prior-providers`
    ];
};
export const getPortalMiddlewareGetPriorProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPriorProvidersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetPriorProviders(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPriorProviders(options) {
    const queryOptions = getPortalMiddlewareGetPriorProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSponsorQuestionnaire = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/questionnaire`
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireQueryKey = ()=>{
    return [
        `/pm/api/sponsor/questionnaire`
    ];
};
export const getPortalMiddlewareGetSponsorQuestionnaireQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSponsorQuestionnaireQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetSponsorQuestionnaire(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSponsorQuestionnaire(options) {
    const queryOptions = getPortalMiddlewareGetSponsorQuestionnaireQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchSponsorQuestionnaire = (patchSponsorQuestionnaireDto)=>{
    return client({
        data: patchSponsorQuestionnaireDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/sponsor/questionnaire`
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchSponsorQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchSponsorQuestionnaire = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchSponsorQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetQuestionnaireInformation = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/questionnaire-information`
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationQueryKey = ()=>{
    return [
        `/pm/api/sponsor/questionnaire-information`
    ];
};
export const getPortalMiddlewareGetQuestionnaireInformationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetQuestionnaireInformationQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetQuestionnaireInformation(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetQuestionnaireInformation(options) {
    const queryOptions = getPortalMiddlewareGetQuestionnaireInformationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetContributions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/sponsor-plan/contributions`
    });
};
export const getPortalMiddlewareGetContributionsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/sponsor-plan/contributions`
    ];
};
export const getPortalMiddlewareGetContributionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetContributionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetContributions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetContributions(options) {
    const queryOptions = getPortalMiddlewareGetContributionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSubaPlanDetails = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/suba-plan-details`
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/suba-plan-details`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSubaPlanDetailsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSubaPlanDetailsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSubaPlanDetails(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSubaPlanDetails(params, options) {
    const queryOptions = getPortalMiddlewareGetSubaPlanDetailsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetSubaTransactions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/suba-transactions`
    });
};
export const getPortalMiddlewareGetSubaTransactionsQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/suba-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetSubaTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetSubaTransactionsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetSubaTransactions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetSubaTransactions(params, options) {
    const queryOptions = getPortalMiddlewareGetSubaTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostYetCensusAutosave = (postYetCensusAutosaveBodyDto)=>{
    return client({
        data: postYetCensusAutosaveBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/autosave`
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetCensusAutosave(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetCensusAutosave = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetCensusAutosaveMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetCensusDataDownload = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/census/download`
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/census/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetCensusDataDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetCensusDataDownloadQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetCensusDataDownload(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetCensusDataDownload(params, options) {
    const queryOptions = getPortalMiddlewareGetYetCensusDataDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetYetCensusDataPaged = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/census/paged`
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/census/paged`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetCensusDataPagedQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetCensusDataPagedQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetCensusDataPaged(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetCensusDataPaged(params, options) {
    const queryOptions = getPortalMiddlewareGetYetCensusDataPagedQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostRefreshCensus = (postRestartCensusBodyDto)=>{
    return client({
        data: postRestartCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/refresh`
    });
};
export const getPortalMiddlewarePostRefreshCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostRefreshCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostRefreshCensus = (options)=>{
    const mutationOptions = getPortalMiddlewarePostRefreshCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostRestartCensus = (postRestartCensusBodyDto)=>{
    return client({
        data: postRestartCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/restart`
    });
};
export const getPortalMiddlewarePostRestartCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostRestartCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostRestartCensus = (options)=>{
    const mutationOptions = getPortalMiddlewarePostRestartCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostYetCensusStart = (yetCensusBodyDto)=>{
    return client({
        data: yetCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/start`
    });
};
export const getPortalMiddlewarePostYetCensusStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetCensusStart(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetCensusStart = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetCensusStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetCensusStatus = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/census/status`
    });
};
export const getPortalMiddlewareGetCensusStatusQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/census/status`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetCensusStatusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetCensusStatusQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetCensusStatus(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetCensusStatus(params, options) {
    const queryOptions = getPortalMiddlewareGetCensusStatusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostYetCensusSubmit = (yetCensusBodyDto)=>{
    return client({
        data: yetCensusBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/submit`
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetCensusSubmit(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetCensusSubmit = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetCensusSubmitMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostYetCensusUpload = (postYetCensusUploadBodyDto)=>{
    return client({
        data: postYetCensusUploadBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/census/upload`
    });
};
export const getPortalMiddlewarePostYetCensusUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetCensusUpload(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetCensusUpload = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetCensusUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetChecklist = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/checklist`
    });
};
export const getPortalMiddlewareGetYetChecklistQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/checklist`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetChecklistQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetChecklistQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetChecklist(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetChecklist(params, options) {
    const queryOptions = getPortalMiddlewareGetYetChecklistQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchYetChecklist = (patchYetChecklistBodyDto)=>{
    return client({
        data: patchYetChecklistBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        url: `/pm/api/sponsor/yet/checklist`
    });
};
export const getPortalMiddlewarePatchYetChecklistMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePatchYetChecklist(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchYetChecklist = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchYetChecklistMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetConfig = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/yet/config`
    });
};
export const getPortalMiddlewareGetYetConfigQueryKey = ()=>{
    return [
        `/pm/api/sponsor/yet/config`
    ];
};
export const getPortalMiddlewareGetYetConfigQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetConfigQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetYetConfig(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetConfig(options) {
    const queryOptions = getPortalMiddlewareGetYetConfigQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostContributionsFund = (yetDocumentIdBodyDto)=>{
    return client({
        data: yetDocumentIdBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/contributions/fund`
    });
};
export const getPortalMiddlewarePostContributionsFundMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostContributionsFund(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionsFund = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionsFundMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostContributionsRefund = (yetDocumentIdBodyDto)=>{
    return client({
        data: yetDocumentIdBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/contributions/refund`
    });
};
export const getPortalMiddlewarePostContributionsRefundMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostContributionsRefund(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostContributionsRefund = (options)=>{
    const mutationOptions = getPortalMiddlewarePostContributionsRefundMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetDocuments = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/documents`
    });
};
export const getPortalMiddlewareGetYetDocumentsQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/documents`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetDocumentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetDocumentsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetDocuments(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetDocuments(params, options) {
    const queryOptions = getPortalMiddlewareGetYetDocumentsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostStartOfPackaging = (getYetChecklistQueryDto)=>{
    return client({
        data: getYetChecklistQueryDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/packaging/start`
    });
};
export const getPortalMiddlewarePostStartOfPackagingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostStartOfPackaging(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostStartOfPackaging = (options)=>{
    const mutationOptions = getPortalMiddlewarePostStartOfPackagingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanTestResults = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/plan-test-results`
    });
};
export const getPortalMiddlewareGetPlanTestResultsQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/plan-test-results`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanTestResultsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanTestResultsQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanTestResults(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanTestResults(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanTestResultsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetYetSponsorQuestionnaire = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/questionnaire`
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/questionnaire`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetSponsorQuestionnaireQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetSponsorQuestionnaire(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetSponsorQuestionnaire(params, options) {
    const queryOptions = getPortalMiddlewareGetYetSponsorQuestionnaireQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostYetSponsorQuestionnaire = (postYetQuestionnaireDto)=>{
    return client({
        data: postYetQuestionnaireDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/questionnaire`
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostYetSponsorQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostYetSponsorQuestionnaire = (options)=>{
    const mutationOptions = getPortalMiddlewarePostYetSponsorQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewarePostRestartTestingProcess = (postRestartTestingProcessBodyDto)=>{
    return client({
        data: postRestartTestingProcessBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/sponsor/yet/restart`
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostRestartTestingProcess(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostRestartTestingProcess = (options)=>{
    const mutationOptions = getPortalMiddlewarePostRestartTestingProcessMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetYetStatus = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/sponsor/yet/status`
    });
};
export const getPortalMiddlewareGetYetStatusQueryKey = (params)=>{
    return [
        `/pm/api/sponsor/yet/status`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetYetStatusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetStatusQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetYetStatus(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetStatus(params, options) {
    const queryOptions = getPortalMiddlewareGetYetStatusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetYtdContributions = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/sponsor/ytd-contributions`
    });
};
export const getPortalMiddlewareGetYtdContributionsQueryKey = ()=>{
    return [
        `/pm/api/sponsor/ytd-contributions`
    ];
};
export const getPortalMiddlewareGetYtdContributionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYtdContributionsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetYtdContributions(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYtdContributions(options) {
    const queryOptions = getPortalMiddlewareGetYtdContributionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetTiaaIncomeProjection = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/tiaa/income-projection`
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionQueryKey = ()=>{
    return [
        `/pm/api/tiaa/income-projection`
    ];
};
export const getPortalMiddlewareGetTiaaIncomeProjectionQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetTiaaIncomeProjectionQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetTiaaIncomeProjection(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetTiaaIncomeProjection(options) {
    const queryOptions = getPortalMiddlewareGetTiaaIncomeProjectionQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePatchParticipantById = (patchParticipantBodyDto, params)=>{
    return client({
        data: patchParticipantBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PATCH',
        params,
        url: `/pm/api/v2/participant`
    });
};
export const getPortalMiddlewarePatchParticipantByIdMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data, params } = props ?? {};
        return portalMiddlewarePatchParticipantById(data, params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePatchParticipantById = (options)=>{
    const mutationOptions = getPortalMiddlewarePatchParticipantByIdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantBeneficiaries = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/v2/participant/beneficiaries`
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesQueryKey = (params)=>{
    return [
        `/pm/api/v2/participant/beneficiaries`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetParticipantBeneficiariesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantBeneficiariesQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantBeneficiaries(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantBeneficiaries(params, options) {
    const queryOptions = getPortalMiddlewareGetParticipantBeneficiariesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePutParticipantBeneficiariesV2 = (portalMiddlewarePutParticipantBeneficiariesV2Body)=>{
    return client({
        data: portalMiddlewarePutParticipantBeneficiariesV2Body,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'PUT',
        url: `/pm/api/v2/participant/beneficiaries`
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePutParticipantBeneficiariesV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePutParticipantBeneficiariesV2 = (options)=>{
    const mutationOptions = getPortalMiddlewarePutParticipantBeneficiariesV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetPlanByIdV2 = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/v2/plans`
    });
};
export const getPortalMiddlewareGetPlanByIdV2QueryKey = (params)=>{
    return [
        `/pm/api/v2/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetPlanByIdV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetPlanByIdV2QueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetPlanByIdV2(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetPlanByIdV2(params, options) {
    const queryOptions = getPortalMiddlewareGetPlanByIdV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetVestingSchedule = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/vesting/schedule`
    });
};
export const getPortalMiddlewareGetVestingScheduleQueryKey = (params)=>{
    return [
        `/pm/api/vesting/schedule`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetVestingScheduleQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetVestingScheduleQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetVestingSchedule(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetVestingSchedule(params, options) {
    const queryOptions = getPortalMiddlewareGetVestingScheduleQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetVssPlanById = (planId, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/vss/plans/${planId}`
    });
};
export const getPortalMiddlewareGetVssPlanByIdQueryKey = (planId)=>{
    return [
        `/pm/api/vss/plans/${planId}`
    ];
};
export const getPortalMiddlewareGetVssPlanByIdQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetVssPlanByIdQueryKey(planId);
    const queryFn = ({ signal })=>portalMiddlewareGetVssPlanById(planId, signal);
    return {
        enabled: !!planId,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetVssPlanById(planId, options) {
    const queryOptions = getPortalMiddlewareGetVssPlanByIdQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetVssStatus = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/vss/status`
    });
};
export const getPortalMiddlewareGetVssStatusQueryKey = ()=>{
    return [
        `/pm/api/vss/status`
    ];
};
export const getPortalMiddlewareGetVssStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetVssStatusQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetVssStatus(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetVssStatus(options) {
    const queryOptions = getPortalMiddlewareGetVssStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostLobLetterEventsWebhook = ()=>{
    return client({
        method: 'POST',
        url: `/pm/api/webhooks/lob/letter-events`
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return portalMiddlewarePostLobLetterEventsWebhook();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostLobLetterEventsWebhook = (options)=>{
    const mutationOptions = getPortalMiddlewarePostLobLetterEventsWebhookMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetWhiteLabel = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/whitelabel`
    });
};
export const getPortalMiddlewareGetWhiteLabelQueryKey = ()=>{
    return [
        `/pm/api/whitelabel`
    ];
};
export const getPortalMiddlewareGetWhiteLabelQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetWhiteLabelQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetWhiteLabel(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetWhiteLabel(options) {
    const queryOptions = getPortalMiddlewareGetWhiteLabelQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetWhiteLabelUnauthorized = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/whitelabel/unauthorized`
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedQueryKey = ()=>{
    return [
        `/pm/api/whitelabel/unauthorized`
    ];
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetWhiteLabelUnauthorizedQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetWhiteLabelUnauthorized(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetWhiteLabelUnauthorized(options) {
    const queryOptions = getPortalMiddlewareGetWhiteLabelUnauthorizedQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostCreateWithdrawal = (postWithdrawalBodyDto)=>{
    return client({
        data: postWithdrawalBodyDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/pm/api/withdrawal`
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return portalMiddlewarePostCreateWithdrawal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostCreateWithdrawal = (options)=>{
    const mutationOptions = getPortalMiddlewarePostCreateWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetParticipantCostBasis = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/withdrawal/cost-basis`
    });
};
export const getPortalMiddlewareGetParticipantCostBasisQueryKey = ()=>{
    return [
        `/pm/api/withdrawal/cost-basis`
    ];
};
export const getPortalMiddlewareGetParticipantCostBasisQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetParticipantCostBasisQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetParticipantCostBasis(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetParticipantCostBasis(options) {
    const queryOptions = getPortalMiddlewareGetParticipantCostBasisQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewarePostWithdrawalIdentityVerification = (params)=>{
    return client({
        method: 'POST',
        params,
        url: `/pm/api/withdrawal/identity-verification`
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { params } = props ?? {};
        return portalMiddlewarePostWithdrawalIdentityVerification(params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePortalMiddlewarePostWithdrawalIdentityVerification = (options)=>{
    const mutationOptions = getPortalMiddlewarePostWithdrawalIdentityVerificationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const portalMiddlewareGetRmdAmount = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/withdrawal/rmd-amount`
    });
};
export const getPortalMiddlewareGetRmdAmountQueryKey = (params)=>{
    return [
        `/pm/api/withdrawal/rmd-amount`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetRmdAmountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRmdAmountQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetRmdAmount(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRmdAmount(params, options) {
    const queryOptions = getPortalMiddlewareGetRmdAmountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetRmdBalance = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/withdrawal/rmd-balance`
    });
};
export const getPortalMiddlewareGetRmdBalanceQueryKey = (params)=>{
    return [
        `/pm/api/withdrawal/rmd-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetRmdBalanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRmdBalanceQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetRmdBalance(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRmdBalance(params, options) {
    const queryOptions = getPortalMiddlewareGetRmdBalanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetRolloverProviders = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/withdrawal/rollover-providers`
    });
};
export const getPortalMiddlewareGetRolloverProvidersQueryKey = ()=>{
    return [
        `/pm/api/withdrawal/rollover-providers`
    ];
};
export const getPortalMiddlewareGetRolloverProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetRolloverProvidersQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetRolloverProviders(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetRolloverProviders(options) {
    const queryOptions = getPortalMiddlewareGetRolloverProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetWithholding = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/withdrawal/withholding`
    });
};
export const getPortalMiddlewareGetWithholdingQueryKey = (params)=>{
    return [
        `/pm/api/withdrawal/withholding`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetWithholdingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetWithholdingQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetWithholding(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetWithholding(params, options) {
    const queryOptions = getPortalMiddlewareGetWithholdingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetWithholdingDetail = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/pm/api/withdrawal/withholding/total-estimate`
    });
};
export const getPortalMiddlewareGetWithholdingDetailQueryKey = (params)=>{
    return [
        `/pm/api/withdrawal/withholding/total-estimate`,
        ...params ? [
            params
        ] : []
    ];
};
export const getPortalMiddlewareGetWithholdingDetailQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetWithholdingDetailQueryKey(params);
    const queryFn = ({ signal })=>portalMiddlewareGetWithholdingDetail(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetWithholdingDetail(params, options) {
    const queryOptions = getPortalMiddlewareGetWithholdingDetailQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetYetNaics = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/yet/naics`
    });
};
export const getPortalMiddlewareGetYetNaicsQueryKey = ()=>{
    return [
        `/pm/api/yet/naics`
    ];
};
export const getPortalMiddlewareGetYetNaicsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetYetNaicsQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetYetNaics(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetYetNaics(options) {
    const queryOptions = getPortalMiddlewareGetYetNaicsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetZendeskJwt = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/zendesk/jwt`
    });
};
export const getPortalMiddlewareGetZendeskJwtQueryKey = ()=>{
    return [
        `/pm/api/zendesk/jwt`
    ];
};
export const getPortalMiddlewareGetZendeskJwtQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetZendeskJwtQueryKey();
    const queryFn = ({ signal })=>portalMiddlewareGetZendeskJwt(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetZendeskJwt(options) {
    const queryOptions = getPortalMiddlewareGetZendeskJwtQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const portalMiddlewareGetEntitySession = (entity, signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/pm/api/${entity}/session`
    });
};
export const getPortalMiddlewareGetEntitySessionQueryKey = (entity)=>{
    return [
        `/pm/api/${entity}/session`
    ];
};
export const getPortalMiddlewareGetEntitySessionQueryOptions = (entity, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPortalMiddlewareGetEntitySessionQueryKey(entity);
    const queryFn = ({ signal })=>portalMiddlewareGetEntitySession(entity, signal);
    return {
        enabled: !!entity,
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function usePortalMiddlewareGetEntitySession(entity, options) {
    const queryOptions = getPortalMiddlewareGetEntitySessionQueryOptions(entity, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const healthGetPublicRoute = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/public`
    });
};
export const getHealthGetPublicRouteQueryKey = ()=>{
    return [
        `/public`
    ];
};
export const getHealthGetPublicRouteQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getHealthGetPublicRouteQueryKey();
    const queryFn = ({ signal })=>healthGetPublicRoute(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useHealthGetPublicRoute(options) {
    const queryOptions = getHealthGetPublicRouteQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthHealthGetConnectivity = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/wt/connectivity`
    });
};
export const getWentworthHealthGetConnectivityQueryKey = ()=>{
    return [
        `/wt/connectivity`
    ];
};
export const getWentworthHealthGetConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthHealthGetConnectivityQueryKey();
    const queryFn = ({ signal })=>wentworthHealthGetConnectivity(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthHealthGetConnectivity(options) {
    const queryOptions = getWentworthHealthGetConnectivityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthHealthPostDemoSdk = (demoReqDto)=>{
    return client({
        data: demoReqDto,
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        url: `/wt/demo-sdk`
    });
};
export const getWentworthHealthPostDemoSdkMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return wentworthHealthPostDemoSdk(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useWentworthHealthPostDemoSdk = (options)=>{
    const mutationOptions = getWentworthHealthPostDemoSdkMutationOptions(options);
    return useMutation(mutationOptions);
};
export const wentworthHealthGetHealth = (signal)=>{
    return client({
        method: 'GET',
        signal,
        url: `/wt/health`
    });
};
export const getWentworthHealthGetHealthQueryKey = ()=>{
    return [
        `/wt/health`
    ];
};
export const getWentworthHealthGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthHealthGetHealthQueryKey();
    const queryFn = ({ signal })=>wentworthHealthGetHealth(signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthHealthGetHealth(options) {
    const queryOptions = getWentworthHealthGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthBalanceGetActivitySummary = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/activity-summary`
    });
};
export const getWentworthBalanceGetActivitySummaryQueryKey = (params)=>{
    return [
        `/wt/participant/activity-summary`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthBalanceGetActivitySummaryQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthBalanceGetActivitySummaryQueryKey(params);
    const queryFn = ({ signal })=>wentworthBalanceGetActivitySummary(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthBalanceGetActivitySummary(params, options) {
    const queryOptions = getWentworthBalanceGetActivitySummaryQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthBalanceGetCurrentBalance = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/balance`
    });
};
export const getWentworthBalanceGetCurrentBalanceQueryKey = (params)=>{
    return [
        `/wt/participant/balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthBalanceGetCurrentBalanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthBalanceGetCurrentBalanceQueryKey(params);
    const queryFn = ({ signal })=>wentworthBalanceGetCurrentBalance(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthBalanceGetCurrentBalance(params, options) {
    const queryOptions = getWentworthBalanceGetCurrentBalanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthBalanceGetBalanceOverTime = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/balance-over-time`
    });
};
export const getWentworthBalanceGetBalanceOverTimeQueryKey = (params)=>{
    return [
        `/wt/participant/balance-over-time`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthBalanceGetBalanceOverTimeQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthBalanceGetBalanceOverTimeQueryKey(params);
    const queryFn = ({ signal })=>wentworthBalanceGetBalanceOverTime(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthBalanceGetBalanceOverTime(params, options) {
    const queryOptions = getWentworthBalanceGetBalanceOverTimeQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthBalanceGetBalancesGroupedBySource = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/balances/by-source`
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceQueryKey = (params)=>{
    return [
        `/wt/participant/balances/by-source`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthBalanceGetBalancesGroupedBySourceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthBalanceGetBalancesGroupedBySourceQueryKey(params);
    const queryFn = ({ signal })=>wentworthBalanceGetBalancesGroupedBySource(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthBalanceGetBalancesGroupedBySource(params, options) {
    const queryOptions = getWentworthBalanceGetBalancesGroupedBySourceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthContributionsGetCompletedContributions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/contributions/completed`
    });
};
export const getWentworthContributionsGetCompletedContributionsQueryKey = (params)=>{
    return [
        `/wt/participant/contributions/completed`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthContributionsGetCompletedContributionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthContributionsGetCompletedContributionsQueryKey(params);
    const queryFn = ({ signal })=>wentworthContributionsGetCompletedContributions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthContributionsGetCompletedContributions(params, options) {
    const queryOptions = getWentworthContributionsGetCompletedContributionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthContributionsGetContributionDetails = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/contributions/details`
    });
};
export const getWentworthContributionsGetContributionDetailsQueryKey = (params)=>{
    return [
        `/wt/participant/contributions/details`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthContributionsGetContributionDetailsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthContributionsGetContributionDetailsQueryKey(params);
    const queryFn = ({ signal })=>wentworthContributionsGetContributionDetails(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthContributionsGetContributionDetails(params, options) {
    const queryOptions = getWentworthContributionsGetContributionDetailsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthContributionsGetPendingContributions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/contributions/pending`
    });
};
export const getWentworthContributionsGetPendingContributionsQueryKey = (params)=>{
    return [
        `/wt/participant/contributions/pending`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthContributionsGetPendingContributionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthContributionsGetPendingContributionsQueryKey(params);
    const queryFn = ({ signal })=>wentworthContributionsGetPendingContributions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthContributionsGetPendingContributions(params, options) {
    const queryOptions = getWentworthContributionsGetPendingContributionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthContributionsGetTotalContributed = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/contributions/total`
    });
};
export const getWentworthContributionsGetTotalContributedQueryKey = (params)=>{
    return [
        `/wt/participant/contributions/total`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthContributionsGetTotalContributedQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthContributionsGetTotalContributedQueryKey(params);
    const queryFn = ({ signal })=>wentworthContributionsGetTotalContributed(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthContributionsGetTotalContributed(params, options) {
    const queryOptions = getWentworthContributionsGetTotalContributedQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthContributionsGetYearlyContributions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/contributions/yearly`
    });
};
export const getWentworthContributionsGetYearlyContributionsQueryKey = (params)=>{
    return [
        `/wt/participant/contributions/yearly`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthContributionsGetYearlyContributionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthContributionsGetYearlyContributionsQueryKey(params);
    const queryFn = ({ signal })=>wentworthContributionsGetYearlyContributions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthContributionsGetYearlyContributions(params, options) {
    const queryOptions = getWentworthContributionsGetYearlyContributionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthInvestmentsGetInvestmentPositions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/investments/positions`
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsQueryKey = (params)=>{
    return [
        `/wt/participant/investments/positions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthInvestmentsGetInvestmentPositionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthInvestmentsGetInvestmentPositionsQueryKey(params);
    const queryFn = ({ signal })=>wentworthInvestmentsGetInvestmentPositions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthInvestmentsGetInvestmentPositions(params, options) {
    const queryOptions = getWentworthInvestmentsGetInvestmentPositionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthBalanceGetLoanBalance = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/loan-balance`
    });
};
export const getWentworthBalanceGetLoanBalanceQueryKey = (params)=>{
    return [
        `/wt/participant/loan-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthBalanceGetLoanBalanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthBalanceGetLoanBalanceQueryKey(params);
    const queryFn = ({ signal })=>wentworthBalanceGetLoanBalance(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthBalanceGetLoanBalance(params, options) {
    const queryOptions = getWentworthBalanceGetLoanBalanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthBalanceGetRateOfReturn = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/rate-of-return`
    });
};
export const getWentworthBalanceGetRateOfReturnQueryKey = (params)=>{
    return [
        `/wt/participant/rate-of-return`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthBalanceGetRateOfReturnQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthBalanceGetRateOfReturnQueryKey(params);
    const queryFn = ({ signal })=>wentworthBalanceGetRateOfReturn(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthBalanceGetRateOfReturn(params, options) {
    const queryOptions = getWentworthBalanceGetRateOfReturnQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthContributionsGetCanceledRollovers = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/rollovers/canceled`
    });
};
export const getWentworthContributionsGetCanceledRolloversQueryKey = (params)=>{
    return [
        `/wt/participant/rollovers/canceled`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthContributionsGetCanceledRolloversQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthContributionsGetCanceledRolloversQueryKey(params);
    const queryFn = ({ signal })=>wentworthContributionsGetCanceledRollovers(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthContributionsGetCanceledRollovers(params, options) {
    const queryOptions = getWentworthContributionsGetCanceledRolloversQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthContributionsGetPendingRollovers = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/rollovers/pending`
    });
};
export const getWentworthContributionsGetPendingRolloversQueryKey = (params)=>{
    return [
        `/wt/participant/rollovers/pending`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthContributionsGetPendingRolloversQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthContributionsGetPendingRolloversQueryKey(params);
    const queryFn = ({ signal })=>wentworthContributionsGetPendingRollovers(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthContributionsGetPendingRollovers(params, options) {
    const queryOptions = getWentworthContributionsGetPendingRolloversQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthTransactionsGetAllTransactions = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/transactions`
    });
};
export const getWentworthTransactionsGetAllTransactionsQueryKey = (params)=>{
    return [
        `/wt/participant/transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthTransactionsGetAllTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthTransactionsGetAllTransactionsQueryKey(params);
    const queryFn = ({ signal })=>wentworthTransactionsGetAllTransactions(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthTransactionsGetAllTransactions(params, options) {
    const queryOptions = getWentworthTransactionsGetAllTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthTransactionsGetTransactionsReport = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/transactions/report`
    });
};
export const getWentworthTransactionsGetTransactionsReportQueryKey = (params)=>{
    return [
        `/wt/participant/transactions/report`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthTransactionsGetTransactionsReportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthTransactionsGetTransactionsReportQueryKey(params);
    const queryFn = ({ signal })=>wentworthTransactionsGetTransactionsReport(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthTransactionsGetTransactionsReport(params, options) {
    const queryOptions = getWentworthTransactionsGetTransactionsReportQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthBalanceGetVestedBalance = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/vested-balance`
    });
};
export const getWentworthBalanceGetVestedBalanceQueryKey = (params)=>{
    return [
        `/wt/participant/vested-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthBalanceGetVestedBalanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthBalanceGetVestedBalanceQueryKey(params);
    const queryFn = ({ signal })=>wentworthBalanceGetVestedBalance(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthBalanceGetVestedBalance(params, options) {
    const queryOptions = getWentworthBalanceGetVestedBalanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const wentworthWithdrawalGetPendingWithdrawals = (params, signal)=>{
    return client({
        method: 'GET',
        params,
        signal,
        url: `/wt/participant/withdrawals/pending`
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsQueryKey = (params)=>{
    return [
        `/wt/participant/withdrawals/pending`,
        ...params ? [
            params
        ] : []
    ];
};
export const getWentworthWithdrawalGetPendingWithdrawalsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getWentworthWithdrawalGetPendingWithdrawalsQueryKey(params);
    const queryFn = ({ signal })=>wentworthWithdrawalGetPendingWithdrawals(params, signal);
    return {
        queryFn,
        queryKey,
        ...queryOptions
    };
};
export function useWentworthWithdrawalGetPendingWithdrawals(params, options) {
    const queryOptions = getWentworthWithdrawalGetPendingWithdrawalsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock = (overrideResponse = {})=>({
        company_id: faker.word.sample(),
        url: faker.word.sample(),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock200 = (overrideResponse = {})=>({
        company_id: faker.word.sample(),
        url: faker.word.sample(),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock = (overrideResponse = {})=>({
        company_id: faker.word.sample(),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock200 = (overrideResponse = {})=>({
        company_id: faker.word.sample(),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetConnectivityResponseMock = (overrideResponse = {})=>({
        details: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        error: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        info: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        status: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getHealthGetConnectivityResponseMock200 = (overrideResponse = {})=>({
        details: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        error: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        info: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        status: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getHealthGetConnectivityResponseMock503 = (overrideResponse = {})=>({
        details: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        error: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        info: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        status: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock = (overrideResponse = {})=>({
        active: faker.datatype.boolean(),
        aud: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        client_id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        exp: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        iat: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        iss: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        jti: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        nbf: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        scope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sub: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        token_type: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        username: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock200 = (overrideResponse = {})=>({
        active: faker.datatype.boolean(),
        aud: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        client_id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        exp: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        iat: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        iss: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        jti: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        nbf: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        scope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sub: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        token_type: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        username: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthPostDemoSDKResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingCensusPostValidationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock = (overrideResponse = {})=>({
        isNew: faker.datatype.boolean(),
        ucid: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock200 = (overrideResponse = {})=>({
        isNew: faker.datatype.boolean(),
        ucid: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostContributionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingContributionPostIngestionFlowStartResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock = (overrideResponse = {})=>({
        demo: faker.datatype.boolean(),
        name: faker.word.sample(),
        nestedProp: {
            nested: faker.datatype.boolean()
        },
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock200 = (overrideResponse = {})=>({
        demo: faker.datatype.boolean(),
        name: faker.word.sample(),
        nestedProp: {
            nested: faker.datatype.boolean()
        },
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthPostDemoSdkResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            docusignEnvelopeId: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            signedAt: faker.word.sample(),
            sponsorPlanId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            status: faker.helpers.arrayElement([
                'pending',
                'void',
                'signed'
            ]),
            type: faker.word.sample()
        }));
export const getOnboardingDocumentGetSigningMappingsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            docusignEnvelopeId: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            signedAt: faker.word.sample(),
            sponsorPlanId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            status: faker.helpers.arrayElement([
                'pending',
                'void',
                'signed'
            ]),
            type: faker.word.sample()
        }));
export const getOnboardingDocumentGetSigningMappingsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocumentGetSigningMappingsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAuthenticateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignConnectivityResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock = (overrideResponse = {})=>({
        endPosition: faker.word.sample(),
        envelopes: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                allowMarkup: faker.word.sample(),
                allowReassign: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowViewHistory: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                anySigner: faker.word.sample(),
                attachmentsUri: faker.word.sample(),
                autoNavigation: faker.word.sample(),
                burnDefaultTabData: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                certificateUri: faker.word.sample(),
                createdDateTime: faker.word.sample(),
                customFieldsUri: faker.word.sample(),
                deliveredDateTime: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                documentsCombinedUri: faker.word.sample(),
                documentsUri: faker.word.sample(),
                emailSubject: faker.word.sample(),
                enableWetSign: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                envelopeId: faker.word.sample(),
                envelopeIdStamping: faker.word.sample(),
                envelopeLocation: faker.word.sample(),
                envelopeMetadata: faker.helpers.arrayElement([
                    {
                        allowAdvancedCorrect: faker.word.sample(),
                        allowCorrect: faker.word.sample(),
                        enableSignWithNotary: faker.word.sample()
                    },
                    undefined
                ]),
                envelopeUri: faker.word.sample(),
                expireAfter: faker.word.sample(),
                expireDateTime: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expireEnabled: faker.word.sample(),
                hasFormDataChanged: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                initialSentDateTime: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                is21CFRPart11: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isDynamicEnvelope: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isSignatureProviderEnvelope: faker.word.sample(),
                lastModifiedDateTime: faker.word.sample(),
                notificationUri: faker.word.sample(),
                purgeState: faker.word.sample(),
                recipientsUri: faker.word.sample(),
                sender: {
                    accountId: faker.word.sample(),
                    email: faker.word.sample(),
                    ipAddress: faker.word.sample(),
                    userId: faker.word.sample(),
                    userName: faker.word.sample()
                },
                sentDateTime: faker.word.sample(),
                signerCanSignOnMobile: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                signingLocation: faker.word.sample(),
                status: faker.word.sample(),
                statusChangedDateTime: faker.word.sample(),
                templatesUri: faker.word.sample(),
                uSigState: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                useDisclosure: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        nextUri: faker.word.sample(),
        previousUri: faker.word.sample(),
        resultSetSize: faker.word.sample(),
        startPosition: faker.word.sample(),
        totalSetSize: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock200 = (overrideResponse = {})=>({
        endPosition: faker.word.sample(),
        envelopes: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                allowMarkup: faker.word.sample(),
                allowReassign: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowViewHistory: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                anySigner: faker.word.sample(),
                attachmentsUri: faker.word.sample(),
                autoNavigation: faker.word.sample(),
                burnDefaultTabData: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                certificateUri: faker.word.sample(),
                createdDateTime: faker.word.sample(),
                customFieldsUri: faker.word.sample(),
                deliveredDateTime: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                documentsCombinedUri: faker.word.sample(),
                documentsUri: faker.word.sample(),
                emailSubject: faker.word.sample(),
                enableWetSign: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                envelopeId: faker.word.sample(),
                envelopeIdStamping: faker.word.sample(),
                envelopeLocation: faker.word.sample(),
                envelopeMetadata: faker.helpers.arrayElement([
                    {
                        allowAdvancedCorrect: faker.word.sample(),
                        allowCorrect: faker.word.sample(),
                        enableSignWithNotary: faker.word.sample()
                    },
                    undefined
                ]),
                envelopeUri: faker.word.sample(),
                expireAfter: faker.word.sample(),
                expireDateTime: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expireEnabled: faker.word.sample(),
                hasFormDataChanged: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                initialSentDateTime: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                is21CFRPart11: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isDynamicEnvelope: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isSignatureProviderEnvelope: faker.word.sample(),
                lastModifiedDateTime: faker.word.sample(),
                notificationUri: faker.word.sample(),
                purgeState: faker.word.sample(),
                recipientsUri: faker.word.sample(),
                sender: {
                    accountId: faker.word.sample(),
                    email: faker.word.sample(),
                    ipAddress: faker.word.sample(),
                    userId: faker.word.sample(),
                    userName: faker.word.sample()
                },
                sentDateTime: faker.word.sample(),
                signerCanSignOnMobile: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                signingLocation: faker.word.sample(),
                status: faker.word.sample(),
                statusChangedDateTime: faker.word.sample(),
                templatesUri: faker.word.sample(),
                uSigState: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                useDisclosure: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        nextUri: faker.word.sample(),
        previousUri: faker.word.sample(),
        resultSetSize: faker.word.sample(),
        startPosition: faker.word.sample(),
        totalSetSize: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock = (overrideResponse = {})=>({
        allowMarkup: faker.word.sample(),
        allowReassign: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        allowViewHistory: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        anySigner: faker.word.sample(),
        attachmentsUri: faker.word.sample(),
        autoNavigation: faker.word.sample(),
        burnDefaultTabData: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        certificateUri: faker.word.sample(),
        createdDateTime: faker.word.sample(),
        customFieldsUri: faker.word.sample(),
        deliveredDateTime: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        documentsCombinedUri: faker.word.sample(),
        documentsUri: faker.word.sample(),
        emailSubject: faker.word.sample(),
        enableWetSign: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        envelopeId: faker.word.sample(),
        envelopeIdStamping: faker.word.sample(),
        envelopeLocation: faker.word.sample(),
        envelopeMetadata: faker.helpers.arrayElement([
            {
                allowAdvancedCorrect: faker.word.sample(),
                allowCorrect: faker.word.sample(),
                enableSignWithNotary: faker.word.sample()
            },
            undefined
        ]),
        envelopeUri: faker.word.sample(),
        expireAfter: faker.word.sample(),
        expireDateTime: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        expireEnabled: faker.word.sample(),
        hasFormDataChanged: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        initialSentDateTime: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        is21CFRPart11: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isDynamicEnvelope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isSignatureProviderEnvelope: faker.word.sample(),
        lastModifiedDateTime: faker.word.sample(),
        notificationUri: faker.word.sample(),
        purgeState: faker.word.sample(),
        recipientsUri: faker.word.sample(),
        sender: {
            accountId: faker.word.sample(),
            email: faker.word.sample(),
            ipAddress: faker.word.sample(),
            userId: faker.word.sample(),
            userName: faker.word.sample()
        },
        sentDateTime: faker.word.sample(),
        signerCanSignOnMobile: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        signingLocation: faker.word.sample(),
        status: faker.word.sample(),
        statusChangedDateTime: faker.word.sample(),
        templatesUri: faker.word.sample(),
        uSigState: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        useDisclosure: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock200 = (overrideResponse = {})=>({
        allowMarkup: faker.word.sample(),
        allowReassign: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        allowViewHistory: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        anySigner: faker.word.sample(),
        attachmentsUri: faker.word.sample(),
        autoNavigation: faker.word.sample(),
        burnDefaultTabData: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        certificateUri: faker.word.sample(),
        createdDateTime: faker.word.sample(),
        customFieldsUri: faker.word.sample(),
        deliveredDateTime: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        documentsCombinedUri: faker.word.sample(),
        documentsUri: faker.word.sample(),
        emailSubject: faker.word.sample(),
        enableWetSign: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        envelopeId: faker.word.sample(),
        envelopeIdStamping: faker.word.sample(),
        envelopeLocation: faker.word.sample(),
        envelopeMetadata: faker.helpers.arrayElement([
            {
                allowAdvancedCorrect: faker.word.sample(),
                allowCorrect: faker.word.sample(),
                enableSignWithNotary: faker.word.sample()
            },
            undefined
        ]),
        envelopeUri: faker.word.sample(),
        expireAfter: faker.word.sample(),
        expireDateTime: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        expireEnabled: faker.word.sample(),
        hasFormDataChanged: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        initialSentDateTime: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        is21CFRPart11: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isDynamicEnvelope: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isSignatureProviderEnvelope: faker.word.sample(),
        lastModifiedDateTime: faker.word.sample(),
        notificationUri: faker.word.sample(),
        purgeState: faker.word.sample(),
        recipientsUri: faker.word.sample(),
        sender: {
            accountId: faker.word.sample(),
            email: faker.word.sample(),
            ipAddress: faker.word.sample(),
            userId: faker.word.sample(),
            userName: faker.word.sample()
        },
        sentDateTime: faker.word.sample(),
        signerCanSignOnMobile: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        signingLocation: faker.word.sample(),
        status: faker.word.sample(),
        statusChangedDateTime: faker.word.sample(),
        templatesUri: faker.word.sample(),
        uSigState: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        useDisclosure: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            clientUserId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            completedCount: faker.word.sample(),
            creationReason: faker.word.sample(),
            deliveredDateTime: faker.word.sample(),
            deliveryMethod: faker.word.sample(),
            email: faker.word.sample(),
            embeddedRecipientStartURL: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.word.sample(),
            isBulkRecipient: faker.word.sample(),
            lastName: faker.word.sample(),
            name: faker.word.sample(),
            note: faker.word.sample(),
            recipientId: faker.word.sample(),
            recipientIdGuid: faker.word.sample(),
            recipientType: faker.word.sample(),
            requireIdLookup: faker.word.sample(),
            requireUploadSignature: faker.word.sample(),
            roleName: faker.word.sample(),
            routingOrder: faker.word.sample(),
            sentDateTime: faker.word.sample(),
            signInEachLocation: faker.word.sample(),
            signatureInfo: {
                fontStyle: faker.word.sample(),
                signatureInitials: faker.word.sample(),
                signatureName: faker.word.sample()
            },
            status: faker.word.sample(),
            templateRequired: faker.word.sample(),
            userId: faker.word.sample()
        }));
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            clientUserId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            completedCount: faker.word.sample(),
            creationReason: faker.word.sample(),
            deliveredDateTime: faker.word.sample(),
            deliveryMethod: faker.word.sample(),
            email: faker.word.sample(),
            embeddedRecipientStartURL: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.word.sample(),
            isBulkRecipient: faker.word.sample(),
            lastName: faker.word.sample(),
            name: faker.word.sample(),
            note: faker.word.sample(),
            recipientId: faker.word.sample(),
            recipientIdGuid: faker.word.sample(),
            recipientType: faker.word.sample(),
            requireIdLookup: faker.word.sample(),
            requireUploadSignature: faker.word.sample(),
            roleName: faker.word.sample(),
            routingOrder: faker.word.sample(),
            sentDateTime: faker.word.sample(),
            signInEachLocation: faker.word.sample(),
            signatureInfo: {
                fontStyle: faker.word.sample(),
                signatureInitials: faker.word.sample(),
                signatureName: faker.word.sample()
            },
            status: faker.word.sample(),
            templateRequired: faker.word.sample(),
            userId: faker.word.sample()
        }));
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetEnvelopeRecipientsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock = (overrideResponse = {})=>({
        url: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock200 = (overrideResponse = {})=>({
        url: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostEnvelopeRecipientResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock = (overrideResponse = {})=>({
        access_token: faker.word.sample(),
        expires_in: faker.number.int({
            max: undefined,
            min: undefined
        }),
        token_type: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock200 = (overrideResponse = {})=>({
        access_token: faker.word.sample(),
        expires_in: faker.number.int({
            max: undefined,
            min: undefined
        }),
        token_type: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetRedirectResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock = (overrideResponse = {})=>({
        access_token: faker.word.sample(),
        expires_in: faker.number.int({
            max: undefined,
            min: undefined
        }),
        token_type: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock200 = (overrideResponse = {})=>({
        access_token: faker.word.sample(),
        expires_in: faker.number.int({
            max: undefined,
            min: undefined
        }),
        token_type: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetAccessTokenResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock = (overrideResponse = {})=>({
        xmlResponse: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock200 = (overrideResponse = {})=>({
        xmlResponse: faker.word.sample(),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock = (overrideResponse = {})=>({
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock200 = (overrideResponse = {})=>({
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingDocusignGetUserInfoResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingHealthGetHealthResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingPizzaTrackerGetPizzaTrackerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingRecordkeepingPostToCustodianResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLaunchDocusignFlowResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforcePostLogoutResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getOnboardingSalesforceGetRecordResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostGustoWebhookEventResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostVestwellWebhookEventResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.word.sample(),
        firmId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        firstName: faker.word.sample(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        lastName: faker.word.sample(),
        phone: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock200 = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.word.sample(),
        firmId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        firstName: faker.word.sample(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        lastName: faker.word.sample(),
        phone: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            commercialPlatformId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            navbar: faker.helpers.arrayElement([
                {
                    logo: {
                        desktop: faker.word.sample(),
                        mobile: faker.word.sample()
                    }
                },
                undefined
            ]),
            numberOfSponsorPlans: faker.number.int({
                max: undefined,
                min: undefined
            }),
            stats: {
                totalBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            subdomain: faker.word.sample()
        }));
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            commercialPlatformId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            navbar: faker.helpers.arrayElement([
                {
                    logo: {
                        desktop: faker.word.sample(),
                        mobile: faker.word.sample()
                    }
                },
                undefined
            ]),
            numberOfSponsorPlans: faker.number.int({
                max: undefined,
                min: undefined
            }),
            stats: {
                totalBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            subdomain: faker.word.sample()
        }));
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorContactCardResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAdvisorContactCardResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibleParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    employeeBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    employerBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    forfeitureBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    hasPriorLoans: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    inboundBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    inboundBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isBlackout: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isOffboardingBlackoutActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    loanBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantsWithBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    participantsWithDeferrals: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    readyToEnrollParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    recordkeeper: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    registeredParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    rolloverBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    sponsorCompanyName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    statefulSchemaTrackingState: faker.helpers.arrayElement([
                        {
                            attributes: faker.helpers.arrayElement([
                                {
                                    createdAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    status: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    updatedAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    status: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    totalBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                relationships: {
                    advisor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    firm: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    program: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    sponsor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    tpa: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                max: undefined,
                                                min: undefined
                                            }),
                                            undefined
                                        ]),
                                        name: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                }
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibleParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    employeeBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    employerBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    forfeitureBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    hasPriorLoans: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    inboundBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    inboundBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isBlackout: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isOffboardingBlackoutActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    loanBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantsWithBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    participantsWithDeferrals: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    readyToEnrollParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    recordkeeper: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    registeredParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    rolloverBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    sponsorCompanyName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    statefulSchemaTrackingState: faker.helpers.arrayElement([
                        {
                            attributes: faker.helpers.arrayElement([
                                {
                                    createdAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    status: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    updatedAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    status: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    totalBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                relationships: {
                    advisor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    firm: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    program: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    sponsor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    tpa: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                max: undefined,
                                                min: undefined
                                            }),
                                            undefined
                                        ]),
                                        name: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                }
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                hasNoOfficers: faker.datatype.boolean(),
                hasNoOwners: faker.datatype.boolean(),
                name: faker.word.sample(),
                officersCompleted: faker.datatype.boolean(),
                ownersCompleted: faker.datatype.boolean(),
                packagingCompleted: faker.datatype.boolean(),
                planName: faker.word.sample(),
                processEvents: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        createdAt: faker.word.sample(),
                        eventName: faker.word.sample(),
                        processEventId: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                processId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                questionnaireCompleted: faker.datatype.boolean(),
                sponsorPlanId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sponsorYearEndChecklistId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                year: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                yearEndCensusCompleted: faker.datatype.boolean()
            })),
        meta: {
            count: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                hasNoOfficers: faker.datatype.boolean(),
                hasNoOwners: faker.datatype.boolean(),
                name: faker.word.sample(),
                officersCompleted: faker.datatype.boolean(),
                ownersCompleted: faker.datatype.boolean(),
                packagingCompleted: faker.datatype.boolean(),
                planName: faker.word.sample(),
                processEvents: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        createdAt: faker.word.sample(),
                        eventName: faker.word.sample(),
                        processEventId: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                processId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                questionnaireCompleted: faker.datatype.boolean(),
                sponsorPlanId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sponsorYearEndChecklistId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                year: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                yearEndCensusCompleted: faker.datatype.boolean()
            })),
        meta: {
            count: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlansTrackerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeeResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        accountBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashBalanceInterestRate: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployer: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsLoan: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsRollover: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        employedParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        modelAgeDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    ageRange: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        modelDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    factsheet: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    viewName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        mostRecentEmployeeContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        mostRecentEmployerContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        mostRecentLoanContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        nextPayrollDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participantsWithDeferrals: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participationRate: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        readyToEnrollParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        registeredParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        totalContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        totalParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        totalPlanMarketValue: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        accountBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashBalanceInterestRate: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployer: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsLoan: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsRollover: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        employedParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        modelAgeDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    ageRange: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        modelDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    factsheet: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    viewName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        mostRecentEmployeeContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        mostRecentEmployerContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        mostRecentLoanContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        nextPayrollDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participantsWithDeferrals: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participationRate: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        readyToEnrollParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        registeredParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        totalContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        totalParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        totalPlanMarketValue: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLinkSponsorResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock = (overrideResponse = {})=>({
        eligibleParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsWithBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalPlans: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock200 = (overrideResponse = {})=>({
        eligibleParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsWithBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalPlans: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorStatsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock = (overrideResponse = {})=>({
        esaItems: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        items: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock200 = (overrideResponse = {})=>({
        esaItems: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        items: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCarouselResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        csmId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        name: faker.word.sample(),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        csmId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        name: faker.word.sample(),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCsmResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock = (overrideResponse = {})=>({
        document: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock200 = (overrideResponse = {})=>({
        document: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutLoginDisclosureResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock = (overrideResponse = {})=>({
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock200 = (overrideResponse = {})=>({
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoginDisclosureAgreementResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteDocumentByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            groupDetails: faker.helpers.arrayElement([
                {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    groupId: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    uploadHistoryId: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isDraft: faker.datatype.boolean(),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getPortalMiddlewareGetAllDocumentsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            groupDetails: faker.helpers.arrayElement([
                {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    groupId: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    uploadHistoryId: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isDraft: faker.datatype.boolean(),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getPortalMiddlewareGetAllDocumentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllDocumentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock = (overrideResponse = {})=>({
        date: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock200 = (overrideResponse = {})=>({
        date: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAgreementResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDocumentAgreementResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentDownloadByKeyResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock = (overrideResponse = {})=>({
        document: faker.word.sample(),
        documentId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        originalFileName: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock200 = (overrideResponse = {})=>({
        document: faker.word.sample(),
        documentId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        originalFileName: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewarePostPdfResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewarePostPdfResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPdfResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({})),
        headers: {},
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({})),
        headers: {},
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostProcessDocumentResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadDocumentResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEmailPreviewRenderResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmailPreviewByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                cashNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                otherNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                stockNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            assetClass: faker.word.sample(),
            balance: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            shares: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            weightPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                cashNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                otherNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                stockNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            assetClass: faker.word.sample(),
            balance: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            shares: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            weightPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeHoldingsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sdbaBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalAccountBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalVestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        eligibilityStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        hasPendingWithdrawal: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasSdbaTransfersOut: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isAddressFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isBlackout: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isEmailFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isLoansAllowed: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        allowedLoanPurposes: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        allowedPayFrequencies: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                relationships: faker.helpers.arrayElement([
                    {
                        plan: faker.helpers.arrayElement([
                            {
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                max: undefined,
                                                min: undefined
                                            }),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            },
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        loanSummaries: faker.helpers.arrayElement([
            {
                fromAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fromCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fromOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fromStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                pageNumber: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                pageSize: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                'participant-id': faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                'plan-id': faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                sort: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                statuses: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                toCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                toStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        planStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        recordkeeper: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock200 = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sdbaBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalAccountBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalVestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        eligibilityStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        hasPendingWithdrawal: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasSdbaTransfersOut: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isAddressFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isBlackout: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isEmailFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isLoansAllowed: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        allowedLoanPurposes: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        allowedPayFrequencies: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                relationships: faker.helpers.arrayElement([
                    {
                        plan: faker.helpers.arrayElement([
                            {
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                max: undefined,
                                                min: undefined
                                            }),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            },
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        loanSummaries: faker.helpers.arrayElement([
            {
                fromAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fromCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fromOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fromStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                pageNumber: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                pageSize: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                'participant-id': faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                'plan-id': faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                sort: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                statuses: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                toCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                toStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        planStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        recordkeeper: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoansResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePerformanceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeePendingTransactionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                cashNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                otherNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                stockNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            targetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            weightPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                cashNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                otherNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                stockNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            targetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            weightPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelSecuritiesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesWithContributionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock = (overrideResponse = {})=>({
        loan: {
            bankAccountInfo: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            deliveryAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            deliveryMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            interestRate: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isConversion: faker.datatype.boolean(),
            isSignedAgreement: faker.datatype.boolean(),
            loanAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            loanExpectedPayment: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    dueDate: faker.word.sample(),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    interest: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    interestPaid: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    latestPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    loanId: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    paymentSequenceNumber: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    paymentStatus: faker.word.sample(),
                    principal: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    principalPaid: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    total: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    updatedAt: faker.word.sample()
                })),
            loanPurpose: faker.word.sample(),
            loanStatus: faker.word.sample(),
            maintenanceFee: faker.number.int({
                max: undefined,
                min: undefined
            }),
            nextPaymentDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            outstandingPrincipalDue: faker.number.int({
                max: undefined,
                min: undefined
            }),
            overdueInterest: faker.number.int({
                max: undefined,
                min: undefined
            }),
            paymentFrequency: faker.word.sample(),
            promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            purchaseSaleAgreementUploaded: faker.datatype.boolean(),
            remainingPaymentsCount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            repaymentYears: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        loanPreferences: {
            allowLoans: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allowResidencePurchaseExtension: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPriorLoans: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            maintenanceFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            maxOutstandingLoans: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            maxYearsResidencePurchase: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            overnightCheckFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            wireFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        plan: {
            isBlackout: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            recordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        sponsor: {
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dayToDayContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasOtherBusinesses: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPartOfControlGroup: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            primaryContact: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    role: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock200 = (overrideResponse = {})=>({
        loan: {
            bankAccountInfo: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            deliveryAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            deliveryMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            interestRate: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isConversion: faker.datatype.boolean(),
            isSignedAgreement: faker.datatype.boolean(),
            loanAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            loanExpectedPayment: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    dueDate: faker.word.sample(),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    interest: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    interestPaid: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    latestPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    loanId: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    paymentSequenceNumber: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    paymentStatus: faker.word.sample(),
                    principal: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    principalPaid: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    total: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    updatedAt: faker.word.sample()
                })),
            loanPurpose: faker.word.sample(),
            loanStatus: faker.word.sample(),
            maintenanceFee: faker.number.int({
                max: undefined,
                min: undefined
            }),
            nextPaymentDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            outstandingPrincipalDue: faker.number.int({
                max: undefined,
                min: undefined
            }),
            overdueInterest: faker.number.int({
                max: undefined,
                min: undefined
            }),
            paymentFrequency: faker.word.sample(),
            promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            purchaseSaleAgreementUploaded: faker.datatype.boolean(),
            remainingPaymentsCount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            repaymentYears: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        loanPreferences: {
            allowLoans: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allowResidencePurchaseExtension: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPriorLoans: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            maintenanceFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            maxOutstandingLoans: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            maxYearsResidencePurchase: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            overnightCheckFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            wireFee: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        plan: {
            isBlackout: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            recordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        sponsor: {
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dayToDayContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasOtherBusinesses: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPartOfControlGroup: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            primaryContact: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    role: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeLoanDetailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaParticipantGoalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            goalAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            priority: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        }));
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            goalAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            priority: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        }));
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantGoalsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock = (overrideResponse = {})=>({
        employerMatch: {
            dollarCap: faker.number.int({
                max: undefined,
                min: undefined
            }),
            lifetimeCap: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        initialBonusAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        initialBonusMinimum: faker.number.int({
            max: undefined,
            min: undefined
        }),
        milestoneBonus: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                bonusAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bonusThreshold: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock200 = (overrideResponse = {})=>({
        employerMatch: {
            dollarCap: faker.number.int({
                max: undefined,
                min: undefined
            }),
            lifetimeCap: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        initialBonusAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        initialBonusMinimum: faker.number.int({
            max: undefined,
            min: undefined
        }),
        milestoneBonus: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                bonusAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bonusThreshold: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaParticipantIncentivesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            cashInterestProgramId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            effectiveStartDate: faker.word.sample(),
            rate: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            cashInterestProgramId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            effectiveStartDate: faker.word.sample(),
            rate: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock = (overrideResponse = {})=>({
        averageSavingsRateDollars: faker.number.int({
            max: undefined,
            min: undefined
        }),
        averageSavingsRatePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsAccessingSavings: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participatingParticipantsNumber: faker.number.int({
            max: undefined,
            min: undefined
        }),
        savingsRateDollarsParticipantsCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        savingsRatePctParticipantsCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalParticipantsNumber: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock200 = (overrideResponse = {})=>({
        averageSavingsRateDollars: faker.number.int({
            max: undefined,
            min: undefined
        }),
        averageSavingsRatePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsAccessingSavings: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participatingParticipantsNumber: faker.number.int({
            max: undefined,
            min: undefined
        }),
        savingsRateDollarsParticipantsCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        savingsRatePctParticipantsCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalParticipantsNumber: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupStatsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            description: faker.word.sample(),
            groupId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonus: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonusThreshold: faker.number.int({
                max: undefined,
                min: undefined
            }),
            match: {
                dollarAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                lifetimeAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percent: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            milestoneBonus: {
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                threshold: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            name: faker.word.sample(),
            participantCount: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            description: faker.word.sample(),
            groupId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonus: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonusThreshold: faker.number.int({
                max: undefined,
                min: undefined
            }),
            match: {
                dollarAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                lifetimeAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percent: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            milestoneBonus: {
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                threshold: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            name: faker.word.sample(),
            participantCount: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanGroupsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            allowInitialBonus: faker.datatype.boolean(),
            allowMatch: faker.datatype.boolean(),
            allowMilestoneBonus: faker.datatype.boolean(),
            bonusAmount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            bonusThreshold: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            dollarCap: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employeeGroupId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonusAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonusMinimum: faker.number.int({
                max: undefined,
                min: undefined
            }),
            lifetimeCap: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        }));
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            allowInitialBonus: faker.datatype.boolean(),
            allowMatch: faker.datatype.boolean(),
            allowMilestoneBonus: faker.datatype.boolean(),
            bonusAmount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            bonusThreshold: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            dollarCap: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employeeGroupId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonusAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            initialBonusMinimum: faker.number.int({
                max: undefined,
                min: undefined
            }),
            lifetimeCap: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        }));
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaPlanIncentivesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchEsaWithdrawalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFi360DownloadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock = ()=>({
        [faker.string.alphanumeric(5)]: faker.datatype.boolean()
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock200 = ()=>({
        [faker.string.alphanumeric(5)]: faker.datatype.boolean()
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            isExperiment: faker.datatype.boolean(),
            name: faker.word.sample(),
            variation: faker.helpers.arrayElement([
                {
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    name: faker.word.sample()
                },
                undefined
            ])
        }));
export const getPortalMiddlewareGetFeatureTogglesListResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            isExperiment: faker.datatype.boolean(),
            name: faker.word.sample(),
            variation: faker.helpers.arrayElement([
                {
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    name: faker.word.sample()
                },
                undefined
            ])
        }));
export const getPortalMiddlewareGetFeatureTogglesListResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFeatureTogglesListResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firmId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        firmType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        website: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock200 = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firmId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        firmType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        website: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetFirmByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountId: faker.word.sample(),
                correlationId: faker.word.sample(),
                customerId: faker.word.sample(),
                eventTriggerType: faker.word.sample(),
                frequency: faker.helpers.arrayElement([
                    faker.helpers.arrayElement([
                        'monthly',
                        'biMonthly',
                        'yearly'
                    ]),
                    undefined
                ]),
                id: faker.word.sample(),
                isDeactivated: faker.datatype.boolean(),
                isPaused: faker.datatype.boolean(),
                parameters: {
                    from: faker.word.sample(),
                    giftAccountId: faker.word.sample(),
                    giftBankAccountId: faker.word.sample(),
                    giftContributorId: faker.word.sample(),
                    isAnonymous: faker.datatype.boolean(),
                    occasion: faker.helpers.arrayElement([
                        'birthday',
                        'just-because',
                        'holiday',
                        'congratulations',
                        'graduation',
                        'get-well'
                    ])
                },
                planId: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountId: faker.word.sample(),
                correlationId: faker.word.sample(),
                customerId: faker.word.sample(),
                eventTriggerType: faker.word.sample(),
                frequency: faker.helpers.arrayElement([
                    faker.helpers.arrayElement([
                        'monthly',
                        'biMonthly',
                        'yearly'
                    ]),
                    undefined
                ]),
                id: faker.word.sample(),
                isDeactivated: faker.datatype.boolean(),
                isPaused: faker.datatype.boolean(),
                parameters: {
                    from: faker.word.sample(),
                    giftAccountId: faker.word.sample(),
                    giftBankAccountId: faker.word.sample(),
                    giftContributorId: faker.word.sample(),
                    isAnonymous: faker.datatype.boolean(),
                    occasion: faker.helpers.arrayElement([
                        'birthday',
                        'just-because',
                        'holiday',
                        'congratulations',
                        'graduation',
                        'get-well'
                    ])
                },
                planId: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecurringResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteGiftContributorRecurringResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                bankAccountNumber: faker.word.sample(),
                bankAccountType: faker.helpers.arrayElement([
                    'checking',
                    'savings',
                    'prepaid'
                ]),
                bankName: faker.word.sample(),
                createdDate: faker.word.sample(),
                customerId: faker.word.sample(),
                deleted: faker.datatype.boolean(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample(),
                lastUpdated: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                payInstructionId: faker.word.sample(),
                routingNumber: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                bankAccountNumber: faker.word.sample(),
                bankAccountType: faker.helpers.arrayElement([
                    'checking',
                    'savings',
                    'prepaid'
                ]),
                bankName: faker.word.sample(),
                createdDate: faker.word.sample(),
                customerId: faker.word.sample(),
                deleted: faker.datatype.boolean(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample(),
                lastUpdated: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                payInstructionId: faker.word.sample(),
                routingNumber: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorBanksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                active: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                createdDate: faker.word.sample(),
                disbursementId: faker.word.sample(),
                feeAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                from: faker.word.sample(),
                giftAccountId: faker.word.sample(),
                giftBankId: faker.word.sample(),
                giftContributorEmail: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                giftContributorPhone: faker.word.sample(),
                giftTransactionId: faker.word.sample(),
                grossAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.word.sample(),
                isAnonymous: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                lastUpdated: faker.word.sample(),
                netAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                occasion: {
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                postedDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                recurringContributionsId: faker.word.sample(),
                theme: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                active: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                createdDate: faker.word.sample(),
                disbursementId: faker.word.sample(),
                feeAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                from: faker.word.sample(),
                giftAccountId: faker.word.sample(),
                giftBankId: faker.word.sample(),
                giftContributorEmail: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                giftContributorPhone: faker.word.sample(),
                giftTransactionId: faker.word.sample(),
                grossAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.word.sample(),
                isAnonymous: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                lastUpdated: faker.word.sample(),
                netAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                occasion: {
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                postedDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                recurringContributionsId: faker.word.sample(),
                theme: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorPaymentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                deleted: faker.datatype.boolean(),
                encodedAccountId: faker.word.sample(),
                giftAccount: {
                    accountPublic: {
                        contributionHold: faker.datatype.boolean(),
                        firstName: faker.word.sample(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        isActive: faker.datatype.boolean(),
                        planId: faker.word.sample(),
                        title: faker.word.sample()
                    },
                    giftAccount: {
                        accountId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        active: faker.datatype.boolean(),
                        assetId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        canAcceptMoreGifts: faker.datatype.boolean(),
                        contributions: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        deleted: faker.datatype.boolean(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        hideGoal: faker.datatype.boolean(),
                        id: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        modeAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        pendingContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        pendingContributionCount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        planId: faker.word.sample(),
                        remainingBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        shareUrl: faker.word.sample()
                    }
                },
                giftAccountId: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                deleted: faker.datatype.boolean(),
                encodedAccountId: faker.word.sample(),
                giftAccount: {
                    accountPublic: {
                        contributionHold: faker.datatype.boolean(),
                        firstName: faker.word.sample(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        isActive: faker.datatype.boolean(),
                        planId: faker.word.sample(),
                        title: faker.word.sample()
                    },
                    giftAccount: {
                        accountId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        active: faker.datatype.boolean(),
                        assetId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        canAcceptMoreGifts: faker.datatype.boolean(),
                        contributions: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        deleted: faker.datatype.boolean(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        hideGoal: faker.datatype.boolean(),
                        id: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        modeAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        pendingContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        pendingContributionCount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        planId: faker.word.sample(),
                        remainingBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        shareUrl: faker.word.sample()
                    }
                },
                giftAccountId: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftContributorRecipientsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock = (overrideResponse = {})=>({
        data: {
            accountPublic: {
                contributionHold: faker.datatype.boolean(),
                firstName: faker.word.sample(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                isActive: faker.datatype.boolean(),
                planId: faker.word.sample(),
                title: faker.word.sample()
            },
            giftAccount: {
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                active: faker.datatype.boolean(),
                assetId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                canAcceptMoreGifts: faker.datatype.boolean(),
                contributions: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                deleted: faker.datatype.boolean(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                hideGoal: faker.datatype.boolean(),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modeAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                pendingContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                pendingContributionCount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                planId: faker.word.sample(),
                remainingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                shareUrl: faker.word.sample()
            }
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock200 = (overrideResponse = {})=>({
        data: {
            accountPublic: {
                contributionHold: faker.datatype.boolean(),
                firstName: faker.word.sample(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                isActive: faker.datatype.boolean(),
                planId: faker.word.sample(),
                title: faker.word.sample()
            },
            giftAccount: {
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                active: faker.datatype.boolean(),
                assetId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                canAcceptMoreGifts: faker.datatype.boolean(),
                contributions: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                deleted: faker.datatype.boolean(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                hideGoal: faker.datatype.boolean(),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modeAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                pendingContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                pendingContributionCount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                planId: faker.word.sample(),
                remainingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                shareUrl: faker.word.sample()
            }
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock = (overrideResponse = {})=>({
        data: {
            accountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            active: faker.datatype.boolean(),
            assetId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            canAcceptMoreGifts: faker.datatype.boolean(),
            contributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            deleted: faker.datatype.boolean(),
            goalPercentage: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            hideGoal: faker.datatype.boolean(),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modeAmount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            pendingContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            pendingContributionCount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            planId: faker.word.sample(),
            remainingBalance: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            shareUrl: faker.word.sample()
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock200 = (overrideResponse = {})=>({
        data: {
            accountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            active: faker.datatype.boolean(),
            assetId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            canAcceptMoreGifts: faker.datatype.boolean(),
            contributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            deleted: faker.datatype.boolean(),
            goalPercentage: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            hideGoal: faker.datatype.boolean(),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modeAmount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            pendingContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            pendingContributionCount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            planId: faker.word.sample(),
            remainingBalance: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            shareUrl: faker.word.sample()
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGiftingPageByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock200 = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateGiftorProfileResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock200 = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftorProfileResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock200 = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGiftSubmissionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock200 = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutValidateGiftSubmissionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHealthResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetLoanAmortizationPdfResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock200 = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock200 = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock200 = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock200 = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            currentBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.word.sample(),
            plaidAccountId: faker.word.sample(),
            plaidAccountSubtype: faker.word.sample(),
            plaidAccountType: faker.word.sample()
        }));
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            currentBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.word.sample(),
            plaidAccountId: faker.word.sample(),
            plaidAccountSubtype: faker.word.sample(),
            plaidAccountType: faker.word.sample()
        }));
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isGenerated: faker.datatype.boolean(),
            result: faker.word.sample(),
            sponsorPlanId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            updatedAt: faker.word.sample()
        }));
export const getPortalMiddlewareGetMidYearTestingResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isGenerated: faker.datatype.boolean(),
            result: faker.word.sample(),
            sponsorPlanId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            updatedAt: faker.word.sample()
        }));
export const getPortalMiddlewareGetMidYearTestingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                avgDeferralRate: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                dateOfBirth: faker.word.sample(),
                dateOfHire: faker.word.sample(),
                dateOfRehire: faker.word.sample(),
                dateOfTermination: faker.word.sample(),
                firstName: faker.word.sample(),
                grossPay: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isHce: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                priorYearGrossPay: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                rc: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                sd: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                secondDateOfTermination: faker.word.sample(),
                ssn: faker.word.sample()
            })),
        meta: {
            avgDeferralRate: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            count: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                avgDeferralRate: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                dateOfBirth: faker.word.sample(),
                dateOfHire: faker.word.sample(),
                dateOfRehire: faker.word.sample(),
                dateOfTermination: faker.word.sample(),
                firstName: faker.word.sample(),
                grossPay: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isHce: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                priorYearGrossPay: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                rc: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                sd: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                secondDateOfTermination: faker.word.sample(),
                ssn: faker.word.sample()
            })),
        meta: {
            avgDeferralRate: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            count: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                actualDeferralRate: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                createdAt: faker.word.sample(),
                dateOfBirth: faker.word.sample(),
                dateOfHire: faker.word.sample(),
                dateOfRehire: faker.word.sample(),
                dateOfTermination: faker.word.sample(),
                em: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                firstName: faker.word.sample(),
                grossPay: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isHce: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                midYearCensusRecordId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participantId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                planYear: faker.word.sample(),
                priorYearGrossPay: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ps: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                qc: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                rc: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sd: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                secondDateOfTermination: faker.word.sample(),
                sh: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sponsorPlanId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ssn: faker.word.sample(),
                yearToDateHours: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                actualDeferralRate: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                createdAt: faker.word.sample(),
                dateOfBirth: faker.word.sample(),
                dateOfHire: faker.word.sample(),
                dateOfRehire: faker.word.sample(),
                dateOfTermination: faker.word.sample(),
                em: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                firstName: faker.word.sample(),
                grossPay: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isHce: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                midYearCensusRecordId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participantId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                planYear: faker.word.sample(),
                priorYearGrossPay: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ps: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                qc: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                rc: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sd: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                secondDateOfTermination: faker.word.sample(),
                sh: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sponsorPlanId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ssn: faker.word.sample(),
                yearToDateHours: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock = (overrideResponse = {})=>({
        testExecutionId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock200 = (overrideResponse = {})=>({
        testExecutionId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock = (overrideResponse = {})=>({
        riskTolerance: faker.helpers.arrayElement([
            'aggressive',
            'conservative',
            'moderate'
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock200 = (overrideResponse = {})=>({
        riskTolerance: faker.helpers.arrayElement([
            'aggressive',
            'conservative',
            'moderate'
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock = (overrideResponse = {})=>({
        targetAllocations: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percentageAllocation: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock200 = (overrideResponse = {})=>({
        targetAllocations: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percentageAllocation: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsActivateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock = (overrideResponse = {})=>({
        deactivateStatus: faker.word.sample(),
        failureReason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock200 = (overrideResponse = {})=>({
        deactivateStatus: faker.word.sample(),
        failureReason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percentageAllocation: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock200 = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percentageAllocation: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percentageAllocation: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock200 = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                percentageAllocation: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock = (overrideResponse = {})=>({
        census: faker.word.sample(),
        companyQuestionnaire: faker.word.sample(),
        completedAt: faker.word.sample(),
        contract: faker.word.sample(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        payrollAndPayment: faker.word.sample(),
        planDesign: faker.word.sample(),
        planLaunch: faker.word.sample(),
        sponsorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock200 = (overrideResponse = {})=>({
        census: faker.word.sample(),
        companyQuestionnaire: faker.word.sample(),
        completedAt: faker.word.sample(),
        contract: faker.word.sample(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        payrollAndPayment: faker.word.sample(),
        planDesign: faker.word.sample(),
        planLaunch: faker.word.sample(),
        sponsorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDigitalOnboardingStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDigitalOnboardingStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutDigitalOnboardingStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock = (overrideResponse = {})=>({
        accountId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        activationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        addressUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        advisorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        afterTaxContribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        afterTaxContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        autorebalance: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactInformation: {
            address: {
                address1: faker.word.sample(),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.word.sample(),
                country: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.word.sample(),
                zip: faker.word.sample()
            },
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            personalEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalSameAsMailing: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            workEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        contributesToRoth: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contributions: faker.helpers.arrayElement([
            {
                irsLimit: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        createdAt: faker.word.sample(),
        dateOfTermination: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferralChanged: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        deferralElections: {
            afterTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            afterTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            preTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            preTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rothAmt: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        eligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        emailUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeClass: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employmentStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        esaGroupId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        esaGroupName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        externalId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        gender: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inRmdAge: faker.datatype.boolean(),
        isDeceased: faker.datatype.boolean(),
        isDisabled: faker.datatype.boolean(),
        isExcluded: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isVerified: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        maritalStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        matchEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        middleName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        model: faker.helpers.arrayElement([
            {
                modelId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                modelName: faker.word.sample(),
                modelType: faker.word.sample(),
                modelViewName: faker.word.sample()
            },
            undefined
        ]),
        nameUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        onboardingWizardCompletedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        password: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        planId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        psEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        registeredOn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        rehireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        savesForRetirement: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sendEmailUpdate: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ssn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraAccountStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraCipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraPerEmployerStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        updatedBy: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        yearsToRetire: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock200 = (overrideResponse = {})=>({
        accountId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        activationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        addressUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        advisorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        afterTaxContribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        afterTaxContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        autorebalance: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactInformation: {
            address: {
                address1: faker.word.sample(),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.word.sample(),
                country: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.word.sample(),
                zip: faker.word.sample()
            },
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            personalEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalSameAsMailing: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            workEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        contributesToRoth: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contributions: faker.helpers.arrayElement([
            {
                irsLimit: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        createdAt: faker.word.sample(),
        dateOfTermination: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferralChanged: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        deferralElections: {
            afterTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            afterTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            preTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            preTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rothAmt: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        eligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        emailUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeClass: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employmentStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        esaGroupId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        esaGroupName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        externalId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        gender: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inRmdAge: faker.datatype.boolean(),
        isDeceased: faker.datatype.boolean(),
        isDisabled: faker.datatype.boolean(),
        isExcluded: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isVerified: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        maritalStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        matchEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        middleName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        model: faker.helpers.arrayElement([
            {
                modelId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                modelName: faker.word.sample(),
                modelType: faker.word.sample(),
                modelViewName: faker.word.sample()
            },
            undefined
        ]),
        nameUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        onboardingWizardCompletedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        password: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        planId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        psEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        registeredOn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        rehireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        savesForRetirement: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sendEmailUpdate: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ssn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraAccountStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraCipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraPerEmployerStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        updatedBy: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        yearsToRetire: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock = (overrideResponse = {})=>({
        employeeBalance: {
            afterTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        employerBalance: {
            match: faker.number.int({
                max: undefined,
                min: undefined
            }),
            profitSharing: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        loanBalance: {
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        rolloverBalance: {
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        updatedOn: faker.word.sample(),
        vestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock200 = (overrideResponse = {})=>({
        employeeBalance: {
            afterTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        employerBalance: {
            match: faker.number.int({
                max: undefined,
                min: undefined
            }),
            profitSharing: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        loanBalance: {
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        rolloverBalance: {
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        updatedOn: faker.word.sample(),
        vestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: faker.helpers.arrayElement([
                {
                    addressUpdate: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            approvedBy: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            status: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            submittedBy: faker.word.sample(),
                            updatedAt: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    bankAccountInfo: faker.helpers.arrayElement([
                        {
                            accountNumber: faker.word.sample(),
                            financialInstitution: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            plaidMask: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            routingNumber: faker.word.sample()
                        },
                        undefined
                    ]),
                    calloutToParticipant: faker.datatype.boolean(),
                    createdAt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    deliveryAddress: faker.helpers.arrayElement([
                        {
                            address1: faker.word.sample(),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.word.sample(),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.word.sample(),
                            zip: faker.word.sample()
                        },
                        undefined
                    ]),
                    deliveryMethod: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    extraFee: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    forCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    forFurtherCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    fraudNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    interestRate: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    isConversion: faker.datatype.boolean(),
                    isReamortizing: faker.datatype.boolean(),
                    isSignedAgreement: faker.datatype.boolean(),
                    loanAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    loanPayments: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                attributes: faker.helpers.arrayElement([
                                    {
                                        dueDate: faker.word.sample(),
                                        interest: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        interestPaid: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        latestPaymentDate: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        paymentSequenceNumber: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        paymentStatus: faker.word.sample(),
                                        principal: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        principalPaid: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        total: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        updatedAt: faker.word.sample()
                                    },
                                    undefined
                                ]),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                type: faker.word.sample()
                            })),
                        undefined
                    ]),
                    loanPurpose: faker.word.sample(),
                    loanStatus: faker.word.sample(),
                    ltLoanId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    maintenanceFee: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    nextPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    notes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationFee: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    outstandingPrincipalDue: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    overdueInterest: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    participantFirstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantLastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    paymentFrequency: faker.word.sample(),
                    promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    purchaseSaleAgreementUploaded: faker.datatype.boolean(),
                    remainingPaymentsCount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    repaymentYears: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    totalPaymentsCount: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            type: faker.word.sample()
        },
        included: {},
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock200 = (overrideResponse = {})=>({
        data: {
            attributes: faker.helpers.arrayElement([
                {
                    addressUpdate: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            approvedBy: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            status: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            submittedBy: faker.word.sample(),
                            updatedAt: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    bankAccountInfo: faker.helpers.arrayElement([
                        {
                            accountNumber: faker.word.sample(),
                            financialInstitution: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            plaidMask: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            routingNumber: faker.word.sample()
                        },
                        undefined
                    ]),
                    calloutToParticipant: faker.datatype.boolean(),
                    createdAt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    deliveryAddress: faker.helpers.arrayElement([
                        {
                            address1: faker.word.sample(),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.word.sample(),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.word.sample(),
                            zip: faker.word.sample()
                        },
                        undefined
                    ]),
                    deliveryMethod: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    extraFee: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    forCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    forFurtherCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    fraudNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    interestRate: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    isConversion: faker.datatype.boolean(),
                    isReamortizing: faker.datatype.boolean(),
                    isSignedAgreement: faker.datatype.boolean(),
                    loanAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    loanPayments: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                attributes: faker.helpers.arrayElement([
                                    {
                                        dueDate: faker.word.sample(),
                                        interest: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        interestPaid: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        latestPaymentDate: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        paymentSequenceNumber: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        paymentStatus: faker.word.sample(),
                                        principal: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        principalPaid: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        total: faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        updatedAt: faker.word.sample()
                                    },
                                    undefined
                                ]),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                type: faker.word.sample()
                            })),
                        undefined
                    ]),
                    loanPurpose: faker.word.sample(),
                    loanStatus: faker.word.sample(),
                    ltLoanId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    maintenanceFee: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    nextPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    notes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationFee: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    outstandingPrincipalDue: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    overdueInterest: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    participantFirstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantLastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    paymentFrequency: faker.word.sample(),
                    promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    purchaseSaleAgreementUploaded: faker.datatype.boolean(),
                    remainingPaymentsCount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    repaymentYears: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    totalPaymentsCount: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            type: faker.word.sample()
        },
        included: {},
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantLoanResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        verificationStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock200 = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        verificationStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            attributes: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    accountVerificationStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    authValid: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    bankAccountMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    holdReason: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    institutionName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidAccountId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumberMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    wireRoutingMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            attributes: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    accountVerificationStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    authValid: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    bankAccountMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    holdReason: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    institutionName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidAccountId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumberMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    wireRoutingMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock = (overrideResponse = {})=>({
        attributes: faker.helpers.arrayElement([
            {
                accountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                accountVerificationStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                authValid: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                bankAccountMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                holdReason: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                institutionName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidAccountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                routingNumberMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                wireRoutingMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock200 = (overrideResponse = {})=>({
        attributes: faker.helpers.arrayElement([
            {
                accountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                accountVerificationStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                authValid: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                bankAccountMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                holdReason: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                institutionName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidAccountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                routingNumberMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                wireRoutingMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sdbaBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalAccountBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalVestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        interestRate: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        isFraudCheckRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                allowedLoanPurposes: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'General',
                        'Principal Residence Purchase'
                    ]),
                    undefined
                ]),
                allowedPayFrequencies: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'SC',
                        'B',
                        'W',
                        'S',
                        'M',
                        'ME'
                    ]),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        reason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock200 = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                sdbaBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalAccountBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalVestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        interestRate: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        isFraudCheckRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                allowedLoanPurposes: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'General',
                        'Principal Residence Purchase'
                    ]),
                    undefined
                ]),
                allowedPayFrequencies: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'SC',
                        'B',
                        'W',
                        'S',
                        'M',
                        'ME'
                    ]),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        reason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantLoanCreateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantLoanResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLoanManualRepaymentResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        code: faker.word.sample(),
                        source: faker.word.sample(),
                        tax: faker.word.sample()
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                allocations: faker.helpers.arrayElement([
                    {
                        assetClass: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        fundName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        targetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ticker: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                balance: faker.helpers.arrayElement([
                    {
                        afterTax: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        employee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        employer: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        loan: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        preTax: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        profitSharing: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rollover: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        roth: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        total: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                metaAssetAllocations: faker.helpers.arrayElement([
                    {
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vesting: faker.helpers.arrayElement([
                    {
                        EMNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        EMVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        PSNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        PSVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHMNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHMVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHNENotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHNEVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        blendedNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        blendedVariablePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        total: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        vestedTotal: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        code: faker.word.sample(),
                        source: faker.word.sample(),
                        tax: faker.word.sample()
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                allocations: faker.helpers.arrayElement([
                    {
                        assetClass: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        fundName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        targetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ticker: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                balance: faker.helpers.arrayElement([
                    {
                        afterTax: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        employee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        employer: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        loan: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        preTax: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        profitSharing: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rollover: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        roth: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        total: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                metaAssetAllocations: faker.helpers.arrayElement([
                    {
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vesting: faker.helpers.arrayElement([
                    {
                        EMNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        EMVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        PSNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        PSVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHMNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHMVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHNENotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        QSHNEVestedPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        blendedNotVested: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        blendedVariablePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        total: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        vestedTotal: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAccountsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutArchiveBankAccountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accountName: faker.word.sample(),
            accountNumberMasked: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            plaidMask: faker.word.sample(),
            routingNumberMasked: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accountName: faker.word.sample(),
            accountNumberMasked: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            plaidMask: faker.word.sample(),
            routingNumberMasked: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBankAccountsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            bankAccountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            depositType: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantDepositsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            bankAccountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            depositType: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample()
        }));
export const getPortalMiddlewareGetParticipantDepositsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantDepositsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostDepositDataResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            autoPause: faker.datatype.boolean(),
            bankAccountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            frequency: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            nextDate: faker.word.sample(),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample(),
            version: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            autoPause: faker.datatype.boolean(),
            bankAccountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            frequency: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            nextDate: faker.word.sample(),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample(),
            version: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock = (overrideResponse = {})=>({
        amount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        bankAccountId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock200 = (overrideResponse = {})=>({
        amount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        bankAccountId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRecurringScheduleResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock = (overrideResponse = {})=>({
        amount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        bankAccountId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock200 = (overrideResponse = {})=>({
        amount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        bankAccountId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDepositResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRecentParticipantDocumentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantEligibilityResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostEsaGoalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock200 = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantIdentityVerificationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock = (overrideResponse = {})=>({
        data: {
            election: {
                age: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ageToDrawSocialSecurity: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                annualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                currentGoalProbability: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                goalQuestionnaireId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                goalStrategyAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isSystemGenerated: faker.datatype.boolean(),
                outsideAccounts: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        accountBalance: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        accountName: faker.word.sample(),
                        accountType: faker.word.sample()
                    })),
                outsideAccountsAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                participantId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                production: faker.datatype.boolean(),
                retireAtAge: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                retirementDate: faker.word.sample(),
                retirementIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                riskProfile: faker.helpers.arrayElement([
                    'aggressive',
                    'conservative',
                    'moderate'
                ]),
                saveMorePerMonth: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                socialSecurityAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                spendLess: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalProjectedAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                updatedAt: faker.word.sample(),
                updatedBy: {
                    authRole: faker.word.sample(),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    idType: faker.word.sample()
                }
            },
            participant: {
                age: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            portfolio: {
                pieChart: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        label: faker.word.sample(),
                        value: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                table: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        allocation: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        assetClass: faker.word.sample(),
                        id: faker.word.sample(),
                        targetAllocations: Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                allocation: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                assetAllocations: {
                                    bondNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    cashNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    otherNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    stockNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    })
                                },
                                assetClass: faker.word.sample(),
                                broadCategory: faker.word.sample(),
                                category: faker.word.sample(),
                                cusip: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                expenseRatioPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                fiveYearPerformancePct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                fundName: faker.word.sample(),
                                id: faker.word.sample(),
                                inceptionDate: faker.word.sample(),
                                itdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                itdPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                name: faker.word.sample(),
                                oneYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                oneYearPerformancePct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                performanceUpdatedAt: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityId: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityType: faker.word.sample(),
                                securityTypeName: faker.word.sample(),
                                shareClass: faker.word.sample(),
                                tenYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                tenYearPerformancePct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                weightPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                ytdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                ytdPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            }))
                    }))
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock200 = (overrideResponse = {})=>({
        data: {
            election: {
                age: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ageToDrawSocialSecurity: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                annualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                currentGoalProbability: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                goalQuestionnaireId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                goalStrategyAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isSystemGenerated: faker.datatype.boolean(),
                outsideAccounts: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        accountBalance: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        accountName: faker.word.sample(),
                        accountType: faker.word.sample()
                    })),
                outsideAccountsAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                participantId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                production: faker.datatype.boolean(),
                retireAtAge: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                retirementDate: faker.word.sample(),
                retirementIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                riskProfile: faker.helpers.arrayElement([
                    'aggressive',
                    'conservative',
                    'moderate'
                ]),
                saveMorePerMonth: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                socialSecurityAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                spendLess: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                totalProjectedAnnualIncome: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                updatedAt: faker.word.sample(),
                updatedBy: {
                    authRole: faker.word.sample(),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    idType: faker.word.sample()
                }
            },
            participant: {
                age: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            portfolio: {
                pieChart: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        label: faker.word.sample(),
                        value: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                table: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        allocation: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        assetClass: faker.word.sample(),
                        id: faker.word.sample(),
                        targetAllocations: Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                allocation: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                assetAllocations: {
                                    bondNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    cashNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    otherNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    stockNetPct: faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    })
                                },
                                assetClass: faker.word.sample(),
                                broadCategory: faker.word.sample(),
                                category: faker.word.sample(),
                                cusip: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                expenseRatioPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                fiveYearPerformancePct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                fundName: faker.word.sample(),
                                id: faker.word.sample(),
                                inceptionDate: faker.word.sample(),
                                itdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                itdPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                name: faker.word.sample(),
                                oneYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                oneYearPerformancePct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                performanceUpdatedAt: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityId: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityType: faker.word.sample(),
                                securityTypeName: faker.word.sample(),
                                shareClass: faker.word.sample(),
                                tenYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                tenYearPerformancePct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                weightPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                ytdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                ytdPct: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            }))
                    }))
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGoalFeedbackResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionAgeSuggestionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock = (overrideResponse = {})=>({
        data: {
            document: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            election: faker.helpers.arrayElement([
                {
                    age: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    ageToDrawSocialSecurity: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    annualIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    retirementIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            feeDocumentId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            participant: {
                currentAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock200 = (overrideResponse = {})=>({
        data: {
            document: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            election: faker.helpers.arrayElement([
                {
                    age: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    ageToDrawSocialSecurity: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    annualIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    retirementIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            feeDocumentId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            participant: {
                currentAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetElectionsSetupResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostElectionsSetupResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        itdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            cashNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            otherNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            stockNetPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelFundSecurity: faker.helpers.arrayElement([
            {
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        modelSecurities: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        securityAllocations: {
            bondNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            cashNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            otherNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stockNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        tenYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ytdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock200 = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        itdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            cashNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            otherNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            stockNetPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelFundSecurity: faker.helpers.arrayElement([
            {
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            undefined
        ]),
        modelSecurities: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                weightPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        securityAllocations: {
            bondNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            cashNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            otherNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stockNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        tenYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ytdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInvestmentsModelDisplayResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantStatsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            cusip: faker.word.sample(),
            isRestricted: faker.datatype.boolean(),
            name: faker.word.sample(),
            result: {
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                shares: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            ticker: faker.word.sample(),
            trade: {
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                shares: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            }
        }));
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            cusip: faker.word.sample(),
            isRestricted: faker.datatype.boolean(),
            name: faker.word.sample(),
            result: {
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                shares: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            ticker: faker.word.sample(),
            trade: {
                amount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                shares: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            }
        }));
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRebalanceRequestPreviewResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock = (overrideResponse = {})=>({
        autoRebalance: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock200 = (overrideResponse = {})=>({
        autoRebalance: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRebalanceSettingsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRebalanceSettingsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock = (overrideResponse = {})=>({
        currentlyInUse: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        defaultType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelTypes: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock200 = (overrideResponse = {})=>({
        currentlyInUse: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        defaultType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelTypes: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetStrategiesIndexResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock = (overrideResponse = {})=>({
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        models: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        participantAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        retirementAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock200 = (overrideResponse = {})=>({
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        models: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        participantAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        retirementAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAgeBasedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutAgeBasedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutCustomAllocationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock = (overrideResponse = {})=>({
        models: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        programId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock200 = (overrideResponse = {})=>({
        models: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                itdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    cashNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    otherNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    stockNetPct: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            cashNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            otherNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            stockNetPct: faker.number.int({
                                max: undefined,
                                min: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        weightPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                ytdPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        programId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskBasedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutRiskBasedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock = (overrideResponse = {})=>({
        modelId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue1High: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        riskValue1Low: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock200 = (overrideResponse = {})=>({
        modelId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue1High: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        riskValue1Low: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRiskModelQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock = (overrideResponse = {})=>({
        isWiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        paperlessNotices: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock200 = (overrideResponse = {})=>({
        isWiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        paperlessNotices: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetMailPreferencesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutMailPreferencesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock = (overrideResponse = {})=>({
        autoEnrollAmount: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferInDollars: faker.datatype.boolean(),
        esaProgramSponsorPlanFree: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        keepExistingRate: faker.datatype.boolean(),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborStrategy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock200 = (overrideResponse = {})=>({
        autoEnrollAmount: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferInDollars: faker.datatype.boolean(),
        esaProgramSponsorPlanFree: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        keepExistingRate: faker.datatype.boolean(),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborStrategy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOnboardingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock = (overrideResponse = {})=>({
        allowRothDeferrals: faker.datatype.boolean(),
        transfers: {
            isEffectiveDateUpcoming: faker.datatype.boolean(),
            loan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rollover: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rolloverIntoAccountAllowed: faker.datatype.boolean()
        },
        ytdContributions: {
            limit: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            }),
            year: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock200 = (overrideResponse = {})=>({
        allowRothDeferrals: faker.datatype.boolean(),
        transfers: {
            isEffectiveDateUpcoming: faker.datatype.boolean(),
            loan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rollover: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rolloverIntoAccountAllowed: faker.datatype.boolean()
        },
        ytdContributions: {
            limit: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            }),
            year: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOverviewResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            currentBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountSubtype: faker.helpers.arrayElement([
                '401a',
                '401k',
                '403B',
                '457b',
                '529',
                'brokerage',
                'cash isa',
                'crypto exchange',
                'education savings account',
                'ebt',
                'fixed annuity',
                'gic',
                'health reimbursement arrangement',
                'hsa',
                'isa',
                'ira',
                'lif',
                'life insurance',
                'lira',
                'lrif',
                'lrsp',
                'non-custodial wallet',
                'non-taxable brokerage account',
                'other',
                'other insurance',
                'other annuity',
                'prif',
                'rdsp',
                'resp',
                'rlif',
                'rrif',
                'pension',
                'profit sharing plan',
                'retirement',
                'roth',
                'roth 401k',
                'rrsp',
                'sep ira',
                'simple ira',
                'sipp',
                'stock plan',
                'thrift savings plan',
                'tfsa',
                'trust',
                'ugma',
                'variable annuity',
                'credit card',
                'paypal',
                'cd',
                'checking',
                'savings',
                'money market',
                'prepaid',
                'auto',
                'business',
                'commercial',
                'construction',
                'consumer',
                'home equity',
                'loan',
                'mortgage',
                'overdraft',
                'line of credit',
                'student',
                'cash management',
                'keogh',
                'mutual fund',
                'recurring',
                'rewards',
                'safe deposit',
                'sarsep',
                'payroll',
                'null'
            ]),
            plaidAccountType: faker.helpers.arrayElement([
                'investment',
                'credit',
                'depository',
                'loan',
                'brokerage',
                'other'
            ])
        }));
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            currentBalance: faker.number.int({
                max: undefined,
                min: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountSubtype: faker.helpers.arrayElement([
                '401a',
                '401k',
                '403B',
                '457b',
                '529',
                'brokerage',
                'cash isa',
                'crypto exchange',
                'education savings account',
                'ebt',
                'fixed annuity',
                'gic',
                'health reimbursement arrangement',
                'hsa',
                'isa',
                'ira',
                'lif',
                'life insurance',
                'lira',
                'lrif',
                'lrsp',
                'non-custodial wallet',
                'non-taxable brokerage account',
                'other',
                'other insurance',
                'other annuity',
                'prif',
                'rdsp',
                'resp',
                'rlif',
                'rrif',
                'pension',
                'profit sharing plan',
                'retirement',
                'roth',
                'roth 401k',
                'rrsp',
                'sep ira',
                'simple ira',
                'sipp',
                'stock plan',
                'thrift savings plan',
                'tfsa',
                'trust',
                'ugma',
                'variable annuity',
                'credit card',
                'paypal',
                'cd',
                'checking',
                'savings',
                'money market',
                'prepaid',
                'auto',
                'business',
                'commercial',
                'construction',
                'consumer',
                'home equity',
                'loan',
                'mortgage',
                'overdraft',
                'line of credit',
                'student',
                'cash management',
                'keogh',
                'mutual fund',
                'recurring',
                'rewards',
                'safe deposit',
                'sarsep',
                'payroll',
                'null'
            ]),
            plaidAccountType: faker.helpers.arrayElement([
                'investment',
                'credit',
                'depository',
                'loan',
                'brokerage',
                'other'
            ])
        }));
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    attributes: faker.helpers.arrayElement([
                        {
                            assetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            broadAssetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            cusip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            expenseRatioPct: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            fundName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            securityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            shares: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            vestedBalance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            vestedShares: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            weight: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                assetAllocations: faker.helpers.arrayElement([
                    {
                        bondNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        otherNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        stockNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                modelAllocations: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            model: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            percent: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    attributes: faker.helpers.arrayElement([
                        {
                            assetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            broadAssetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            cusip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            expenseRatioPct: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            fundName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            securityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            shares: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            vestedBalance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            vestedShares: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            weight: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                assetAllocations: faker.helpers.arrayElement([
                    {
                        bondNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        otherNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        stockNet: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                modelAllocations: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            model: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            percent: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPositionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            availableAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            birthOrAdoptionDate: faker.word.sample(),
            childFirstName: faker.word.sample(),
            childLastName: faker.word.sample(),
            childSsn: faker.word.sample(),
            disabled: faker.datatype.boolean(),
            disabledReason: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            validUntil: faker.word.sample()
        }));
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            availableAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            birthOrAdoptionDate: faker.word.sample(),
            childFirstName: faker.word.sample(),
            childLastName: faker.word.sample(),
            childSsn: faker.word.sample(),
            disabled: faker.datatype.boolean(),
            disabledReason: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            validUntil: faker.word.sample()
        }));
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQboadWithdrawalsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantRolloverResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverInstructionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverEligibilityResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantRolloverResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock = (overrideResponse = {})=>({
        attributes: {
            accountProvider: faker.word.sample(),
            accountType: {},
            createdAt: faker.word.sample(),
            letterDocumentId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTaxAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothCostBasis: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothStartDate: faker.word.sample(),
            status: {}
        },
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock200 = (overrideResponse = {})=>({
        attributes: {
            accountProvider: faker.word.sample(),
            accountType: {},
            createdAt: faker.word.sample(),
            letterDocumentId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTaxAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothCostBasis: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothStartDate: faker.word.sample(),
            status: {}
        },
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantRolloverResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGenerateRolloverLetterResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock = (overrideResponse = {})=>({
        afterTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        age: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        allowDollarAmounts: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        allowRothDeferrals: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        catchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        employeeLimit: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        preTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        rothAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        safeHarborMatchType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborMatchTypeDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        superCatchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ytdContributions: {
            limit: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            total: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            year: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock200 = (overrideResponse = {})=>({
        afterTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        age: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        allowDollarAmounts: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        allowRothDeferrals: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        catchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        employeeLimit: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        preTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        rothAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        safeHarborMatchType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborMatchTypeDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        superCatchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ytdContributions: {
            limit: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            total: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            year: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSavingsDisplayResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSavingsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock = (overrideResponse = {})=>({
        data: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock200 = (overrideResponse = {})=>({
        data: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSurveyLinkResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        transactions: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    amount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    category: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock200 = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        transactions: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    amount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    category: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock = (overrideResponse = {})=>({
        allowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    afterTaxAvailableAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    afterTaxMaxAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    disabled: faker.datatype.boolean(),
                    distributionMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                        undefined
                    ]),
                    fee: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    maxAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    preTaxAvailableAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    preTaxMaxAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    qboadSupported: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    reason: faker.word.sample(),
                    rothAvailableAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    rothMaxAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                })),
            undefined
        ]),
        disallowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        fullyVestedPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fullyVestedRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        overnightCheckFee: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sdbaPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sdbaRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        vestedPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        vestedRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        wireFee: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock200 = (overrideResponse = {})=>({
        allowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    afterTaxAvailableAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    afterTaxMaxAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    disabled: faker.datatype.boolean(),
                    distributionMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                        undefined
                    ]),
                    fee: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    maxAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    preTaxAvailableAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    preTaxMaxAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    qboadSupported: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    reason: faker.word.sample(),
                    rothAvailableAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    rothMaxAmount: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                })),
            undefined
        ]),
        disallowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        fullyVestedPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fullyVestedRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        overnightCheckFee: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sdbaPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sdbaRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        vestedPreTaxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        vestedRothBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        wireFee: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                autoEnrolledParticipants: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        contribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        contributionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatusId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        email: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        entryDate: faker.word.sample(),
                        firstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        lastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        loginUserId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        personalEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ssnSuffix: faker.word.sample(),
                        workEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    })),
                meta: {
                    total: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                }
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                autoEnrolledParticipants: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        contribution: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        contributionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatusId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        email: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        entryDate: faker.word.sample(),
                        firstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        lastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        loginUserId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        personalEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ssnSuffix: faker.word.sample(),
                        workEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    })),
                meta: {
                    total: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                }
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                meta: {
                    total: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                optedOutParticipants: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        firstName: faker.word.sample(),
                        lastName: faker.word.sample(),
                        optedOutAt: faker.word.sample(),
                        optedOutByUserEmail: faker.word.sample(),
                        optedOutByUserId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        participantId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ssnSuffix: faker.word.sample()
                    }))
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                meta: {
                    total: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                optedOutParticipants: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        firstName: faker.word.sample(),
                        lastName: faker.word.sample(),
                        optedOutAt: faker.word.sample(),
                        optedOutByUserEmail: faker.word.sample(),
                        optedOutByUserId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        participantId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        ssnSuffix: faker.word.sample()
                    }))
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock = (overrideResponse = {})=>({
        participants: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityEntryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    emailInfo: faker.helpers.arrayElement([
                        {
                            messageId: faker.word.sample(),
                            sentOn: faker.word.sample(),
                            sentTo: faker.word.sample()
                        },
                        undefined
                    ]),
                    emailType: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    middleName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    personalEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ssn: faker.word.sample(),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    status: faker.word.sample(),
                    workEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        totalCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock200 = (overrideResponse = {})=>({
        participants: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityEntryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    emailInfo: faker.helpers.arrayElement([
                        {
                            messageId: faker.word.sample(),
                            sentOn: faker.word.sample(),
                            sentTo: faker.word.sample()
                        },
                        undefined
                    ]),
                    emailType: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    middleName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    personalEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ssn: faker.word.sample(),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    status: faker.word.sample(),
                    workEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        totalCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock = (overrideResponse = {})=>({
        count: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock200 = (overrideResponse = {})=>({
        count: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock = (overrideResponse = {})=>({
        successEmails: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalEmails: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock200 = (overrideResponse = {})=>({
        successEmails: faker.number.int({
            max: undefined,
            min: undefined
        }),
        totalEmails: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock = (overrideResponse = {})=>({
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        history: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    eventType: faker.word.sample(),
                    messageId: faker.word.sample(),
                    sentOn: faker.word.sample(),
                    sentTo: faker.word.sample()
                })),
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ssn: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock200 = (overrideResponse = {})=>({
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        history: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    eventType: faker.word.sample(),
                    messageId: faker.word.sample(),
                    sentOn: faker.word.sample(),
                    sentTo: faker.word.sample()
                })),
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ssn: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock = (overrideResponse = {})=>({
        data: {
            atTotal: faker.number.int({
                max: undefined,
                min: undefined
            }),
            employerMatch: faker.number.int({
                max: undefined,
                min: undefined
            }),
            esaGroupId: faker.word.sample(),
            initialBonus: faker.number.int({
                max: undefined,
                min: undefined
            }),
            milestoneBonusAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            milestoneBonusId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        error: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        success: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock200 = (overrideResponse = {})=>({
        data: {
            atTotal: faker.number.int({
                max: undefined,
                min: undefined
            }),
            employerMatch: faker.number.int({
                max: undefined,
                min: undefined
            }),
            esaGroupId: faker.word.sample(),
            initialBonus: faker.number.int({
                max: undefined,
                min: undefined
            }),
            milestoneBonusAmount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            milestoneBonusId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        error: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        success: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock = (overrideResponse = {})=>({
        data: {
            employerMatch: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock200 = (overrideResponse = {})=>({
        data: {
            employerMatch: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock = (overrideResponse = {})=>({
        distributionFeatures: faker.helpers.arrayElement([
            {
                allowHardshipElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipTransfer: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipWithdrawals: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceUponDisability: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPermissibleWithdrawal: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowQbad: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                childFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                correctiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                deathFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                disabilityFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                earlyRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                generalFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                hardshipCriteria: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                hardshipFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                inServiceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                inServiceSpecifiedAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                normalRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                normalRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                permissibleTimeframe: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                permissiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                planTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                qdroFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rmdFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rolloverFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                liquidationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                originalEffectivePlanDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planYearEnd: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                safeHarborEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                vestwellStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        eligibilityFeatures: faker.helpers.arrayElement([
            {
                eligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                excludeLeasedEmployees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasDualEligibility: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                profitSharingEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                specialEntryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                specialParticipationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        employeeContribution: faker.helpers.arrayElement([
            {
                allowAfterTaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPretaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEnrollAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                autoEnrollEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                autoEscalate: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEscalateAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                autoEscalateMaximum: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                deferInDollars: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isSalaryRothDeferral: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        employerContribution: faker.helpers.arrayElement([
            {
                allowEmployerProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowNonSafeHarborMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPrevailingWage: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowRollover: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowSafeHarborNonElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                documentMatchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                earlyRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                formula: faker.helpers.arrayElement([
                    {
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        dollarCapId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        formulaDefined: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        tiers: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    tierCap: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierIndex: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierPercent: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ])
                    },
                    undefined
                ]),
                isSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                nonSafeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                notes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStrategy: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                safeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        forceOutPreferences: faker.helpers.arrayElement([
            {
                excludeRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAllowed: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAutomated: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maxAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rolloverMin: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        forfeiturePreferences: faker.helpers.arrayElement([
            {
                offsetEmployerContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                payPlanFees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        loanFeatures: faker.helpers.arrayElement([
            {
                allowLoans: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowResidencePurchaseExtension: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasPriorLoans: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        offboardingInformation: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        overview: faker.helpers.arrayElement([
            {
                adminStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorFirstName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorLastName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                clientSuccessManagerId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                clientSuccessManagerName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                companyName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                conversionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationLevel: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationTypeId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                investmentProgram: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                investmentProgramId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                payroll: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planDesignTypeName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planTierId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                planTierName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaFiduciary: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                trustee: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        recordkeeperAndCustodian: faker.helpers.arrayElement([
            {
                adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                custodianAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalPlanId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                opportunityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                partnerSystemName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                priorProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                recordkeeperId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        vestingPreferences: faker.helpers.arrayElement([
            {
                excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                fundingSources: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            fundingSourceId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            fundingSourceName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            vestingScheduleId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            vestingScheduleName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                hoursOfServiceRequired: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                vestingMethod: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock200 = (overrideResponse = {})=>({
        distributionFeatures: faker.helpers.arrayElement([
            {
                allowHardshipElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipTransfer: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipWithdrawals: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceUponDisability: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPermissibleWithdrawal: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowQbad: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                childFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                correctiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                deathFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                disabilityFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                earlyRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                generalFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                hardshipCriteria: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                hardshipFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                inServiceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                inServiceSpecifiedAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                normalRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                normalRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                permissibleTimeframe: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                permissiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                planTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                qdroFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rmdFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rolloverFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                liquidationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                originalEffectivePlanDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planYearEnd: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                safeHarborEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                vestwellStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        eligibilityFeatures: faker.helpers.arrayElement([
            {
                eligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                excludeLeasedEmployees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasDualEligibility: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                profitSharingEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                specialEntryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                specialParticipationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        employeeContribution: faker.helpers.arrayElement([
            {
                allowAfterTaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPretaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEnrollAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                autoEnrollEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                autoEscalate: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEscalateAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                autoEscalateMaximum: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                deferInDollars: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isSalaryRothDeferral: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        employerContribution: faker.helpers.arrayElement([
            {
                allowEmployerProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowNonSafeHarborMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPrevailingWage: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowRollover: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowSafeHarborNonElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                documentMatchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                earlyRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                formula: faker.helpers.arrayElement([
                    {
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        dollarCapId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        formulaDefined: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        tiers: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    tierCap: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierIndex: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierPercent: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ])
                    },
                    undefined
                ]),
                isSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                nonSafeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                notes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStrategy: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                safeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        forceOutPreferences: faker.helpers.arrayElement([
            {
                excludeRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAllowed: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAutomated: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maxAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rolloverMin: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        forfeiturePreferences: faker.helpers.arrayElement([
            {
                offsetEmployerContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                payPlanFees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        loanFeatures: faker.helpers.arrayElement([
            {
                allowLoans: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowResidencePurchaseExtension: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasPriorLoans: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        offboardingInformation: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        overview: faker.helpers.arrayElement([
            {
                adminStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorFirstName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorLastName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                clientSuccessManagerId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                clientSuccessManagerName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                companyName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                conversionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationLevel: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationTypeId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                investmentProgram: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                investmentProgramId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                payroll: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planDesignTypeName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planTierId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                planTierName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaFiduciary: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                trustee: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        recordkeeperAndCustodian: faker.helpers.arrayElement([
            {
                adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                custodianAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalPlanId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                opportunityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                partnerSystemName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                priorProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                recordkeeperId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        vestingPreferences: faker.helpers.arrayElement([
            {
                excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                fundingSources: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            fundingSourceId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            fundingSourceName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            vestingScheduleId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            vestingScheduleName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                hoursOfServiceRequired: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                vestingMethod: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchUpdatePlanDesignResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            planDesignTemplate: {
                distributionFeatures: faker.helpers.arrayElement([
                    {
                        allowHardshipElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipTransfer: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipWithdrawals: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceUponDisability: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPermissibleWithdrawal: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowQbad: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        childFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        correctiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        deathFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        disabilityFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        earlyRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        generalFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        hardshipCriteria: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        hardshipFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        inServiceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        inServiceSpecifiedAge: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        permissibleTimeframe: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        permissiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        planTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        qdroFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rmdFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rolloverFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                effectiveDate: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        liquidationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        originalEffectivePlanDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planYearEnd: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        safeHarborEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        vestwellStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                eligibilityFeatures: faker.helpers.arrayElement([
                    {
                        eligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        excludeLeasedEmployees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasDualEligibility: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        profitSharingEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        specialEntryDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        specialParticipationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employeeContribution: faker.helpers.arrayElement([
                    {
                        allowAfterTaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPretaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEnrollAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        autoEnrollEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        autoEscalate: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEscalateAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        autoEscalateMaximum: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        deferInDollars: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isSalaryRothDeferral: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employerContribution: faker.helpers.arrayElement([
                    {
                        allowEmployerProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowNonSafeHarborMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPrevailingWage: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowRollover: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowSafeHarborNonElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        documentMatchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        earlyRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        formula: faker.helpers.arrayElement([
                            {
                                dollarCap: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                dollarCapId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                formulaDefined: faker.helpers.arrayElement([
                                    faker.datatype.boolean(),
                                    undefined
                                ]),
                                tiers: faker.helpers.arrayElement([
                                    Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>({
                                            tierCap: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierIndex: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierPercent: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        })),
                                    undefined
                                ])
                            },
                            undefined
                        ]),
                        isSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        nonSafeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        notes: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStrategy: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        safeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forceOutPreferences: faker.helpers.arrayElement([
                    {
                        excludeRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAllowed: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAutomated: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maxAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rolloverMin: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forfeiturePreferences: faker.helpers.arrayElement([
                    {
                        offsetEmployerContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        payPlanFees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                loanFeatures: faker.helpers.arrayElement([
                    {
                        allowLoans: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowResidencePurchaseExtension: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasPriorLoans: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                offboardingInformation: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                overview: faker.helpers.arrayElement([
                    {
                        adminStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        clientSuccessManagerId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        clientSuccessManagerName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        companyName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        conversionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationLevel: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationTypeId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        investmentProgram: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        investmentProgramId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        payroll: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planDesignTypeName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planTierId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        planTierName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaFiduciary: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        trustee: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                recordkeeperAndCustodian: faker.helpers.arrayElement([
                    {
                        adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        custodianAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalPlanId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        opportunityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        partnerSystemName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        priorProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        recordkeeperId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vestingPreferences: faker.helpers.arrayElement([
                    {
                        excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        fundingSources: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    fundingSourceId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    fundingSourceName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    vestingScheduleId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    vestingScheduleName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        hoursOfServiceRequired: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        vestingMethod: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            },
            planDesignTileName: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanDesignTilesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            planDesignTemplate: {
                distributionFeatures: faker.helpers.arrayElement([
                    {
                        allowHardshipElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipTransfer: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipWithdrawals: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceUponDisability: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPermissibleWithdrawal: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowQbad: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        childFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        correctiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        deathFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        disabilityFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        earlyRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        generalFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        hardshipCriteria: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        hardshipFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        inServiceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        inServiceSpecifiedAge: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        permissibleTimeframe: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        permissiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        planTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        qdroFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rmdFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rolloverFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                effectiveDate: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        liquidationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        originalEffectivePlanDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planYearEnd: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        safeHarborEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        vestwellStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                eligibilityFeatures: faker.helpers.arrayElement([
                    {
                        eligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        excludeLeasedEmployees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasDualEligibility: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        profitSharingEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        specialEntryDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        specialParticipationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employeeContribution: faker.helpers.arrayElement([
                    {
                        allowAfterTaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPretaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEnrollAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        autoEnrollEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        autoEscalate: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEscalateAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        autoEscalateMaximum: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        deferInDollars: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isSalaryRothDeferral: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employerContribution: faker.helpers.arrayElement([
                    {
                        allowEmployerProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowNonSafeHarborMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPrevailingWage: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowRollover: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowSafeHarborNonElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        documentMatchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        earlyRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        formula: faker.helpers.arrayElement([
                            {
                                dollarCap: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                dollarCapId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                formulaDefined: faker.helpers.arrayElement([
                                    faker.datatype.boolean(),
                                    undefined
                                ]),
                                tiers: faker.helpers.arrayElement([
                                    Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>({
                                            tierCap: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierIndex: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierPercent: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    max: undefined,
                                                    min: undefined
                                                }),
                                                undefined
                                            ])
                                        })),
                                    undefined
                                ])
                            },
                            undefined
                        ]),
                        isSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        nonSafeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        notes: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStrategy: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        safeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forceOutPreferences: faker.helpers.arrayElement([
                    {
                        excludeRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAllowed: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAutomated: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maxAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        rolloverMin: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forfeiturePreferences: faker.helpers.arrayElement([
                    {
                        offsetEmployerContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        payPlanFees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                loanFeatures: faker.helpers.arrayElement([
                    {
                        allowLoans: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowResidencePurchaseExtension: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasPriorLoans: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                offboardingInformation: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                overview: faker.helpers.arrayElement([
                    {
                        adminStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        clientSuccessManagerId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        clientSuccessManagerName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        companyName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        conversionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationLevel: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationTypeId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        investmentProgram: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        investmentProgramId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        payroll: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planDesignTypeName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planTierId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        planTierName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaFiduciary: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        trustee: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                recordkeeperAndCustodian: faker.helpers.arrayElement([
                    {
                        adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        custodianAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalPlanId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        opportunityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        partnerSystemName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        priorProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        recordkeeperId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vestingPreferences: faker.helpers.arrayElement([
                    {
                        excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        fundingSources: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    max: 10,
                                    min: 1
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    fundingSourceId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    fundingSourceName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    vestingScheduleId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            max: undefined,
                                            min: undefined
                                        }),
                                        undefined
                                    ]),
                                    vestingScheduleName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        hoursOfServiceRequired: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        vestingMethod: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            },
            planDesignTileName: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanDesignTilesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignTilesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accountDetails: faker.helpers.arrayElement([
                {
                    balance: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    employeeContribution: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    employerContribution: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    loans: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    rolloverAmount: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            annualSalary: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInfo: faker.helpers.arrayElement([
                {
                    address: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    mailingAddress: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    personalEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phoneNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    physicalSameAsMailing: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    userEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    workEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            dateOfHire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfRehire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            YTDHours: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            deferrals: faker.helpers.arrayElement([
                {
                    preTax: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    roth: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.helpers.arrayElement([
                                faker.datatype.boolean(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isOverride: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.helpers.arrayElement([
                                faker.datatype.boolean(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    status: faker.helpers.arrayElement([
                        faker.helpers.arrayElement([
                            'Awaiting Entry Date',
                            'Awaiting entry date',
                            'Eligible',
                            'Ineligible',
                            'Terminated',
                            'Terminated With Balance',
                            'Terminated with balance'
                        ]),
                        undefined
                    ])
                },
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isRegistered: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            priorYearHours: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanParticipantsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accountDetails: faker.helpers.arrayElement([
                {
                    balance: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    employeeContribution: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    employerContribution: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    loans: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    rolloverAmount: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            annualSalary: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInfo: faker.helpers.arrayElement([
                {
                    address: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    mailingAddress: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    personalEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phoneNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    physicalSameAsMailing: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    userEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    workEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            dateOfHire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfRehire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            YTDHours: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            deferrals: faker.helpers.arrayElement([
                {
                    preTax: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    roth: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.helpers.arrayElement([
                                faker.datatype.boolean(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isOverride: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.helpers.arrayElement([
                                faker.datatype.boolean(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    status: faker.helpers.arrayElement([
                        faker.helpers.arrayElement([
                            'Awaiting Entry Date',
                            'Awaiting entry date',
                            'Eligible',
                            'Ineligible',
                            'Terminated',
                            'Terminated With Balance',
                            'Terminated with balance'
                        ]),
                        undefined
                    ])
                },
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isRegistered: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            priorYearHours: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanParticipantsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanParticipantsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        itdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            cashNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            otherNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            stockNetPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        tenYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ytdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock200 = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        itdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            cashNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            otherNetPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            stockNetPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        tenYearBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ytdPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock = (overrideResponse = {})=>({
        directDeposit: faker.datatype.boolean(),
        esaProgramId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        payrollDeduction: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock200 = (overrideResponse = {})=>({
        directDeposit: faker.datatype.boolean(),
        esaProgramId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        payrollDeduction: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEsaProgramResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                inceptionDate: faker.word.sample(),
                isDefault: faker.datatype.boolean(),
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                programId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                viewName: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                inceptionDate: faker.word.sample(),
                isDefault: faker.datatype.boolean(),
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                programId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                viewName: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanInvestmentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                cashNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                otherNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                stockNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            weightPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                cashNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                otherNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                stockNetPct: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            weightPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanModelSecuritiesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            fi360FactsheetPath: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            inceptionDate: faker.word.sample(),
            isDefault: faker.datatype.boolean(),
            modelBoundaries: {
                riskLevel: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                targetRetireYearHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                targetRetireYearLow: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                yearsToRetireHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                yearsToRetireLow: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            modelDescription: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modelType: faker.helpers.arrayElement([
                'target',
                'risk',
                'menu',
                'pmenu',
                'goal',
                'ms_ma',
                'ms_ma_menu',
                'nli'
            ]),
            name: faker.word.sample(),
            programId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            viewName: faker.word.sample()
        }));
export const getPortalMiddlewareGetProgramModelsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            fi360FactsheetPath: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            inceptionDate: faker.word.sample(),
            isDefault: faker.datatype.boolean(),
            modelBoundaries: {
                riskLevel: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                targetRetireYearHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                targetRetireYearLow: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                yearsToRetireHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                yearsToRetireLow: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            modelDescription: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modelType: faker.helpers.arrayElement([
                'target',
                'risk',
                'menu',
                'pmenu',
                'goal',
                'ms_ma',
                'ms_ma_menu',
                'nli'
            ]),
            name: faker.word.sample(),
            programId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            viewName: faker.word.sample()
        }));
export const getPortalMiddlewareGetProgramModelsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramModelsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock = (overrideResponse = {})=>({
        postfix: faker.word.sample(),
        prefix: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock200 = (overrideResponse = {})=>({
        postfix: faker.word.sample(),
        prefix: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetProspectusUrlPartsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAdvisorReportResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeReportResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanReportResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorReportResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsReportResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            nonElectivePercent: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierOneMatchMax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierOneMatchPercent: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierTwoMatchMax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierTwoMatchMin: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierTwoMatchPercent: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            name: faker.word.sample(),
            nonElectivePercent: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierOneMatchMax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierOneMatchPercent: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierTwoMatchMax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierTwoMatchMin: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tierTwoMatchPercent: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock = (overrideResponse = {})=>({
        cashBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        effectiveDate: faker.word.sample(),
        externalAccountNumber: faker.word.sample(),
        totalMarketValue: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock200 = (overrideResponse = {})=>({
        cashBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        effectiveDate: faker.word.sample(),
        externalAccountNumber: faker.word.sample(),
        totalMarketValue: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaExternalMarketValueResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock = (overrideResponse = {})=>({
        allowSdba: faker.datatype.boolean(),
        createdAt: faker.word.sample(),
        createdBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            idType: faker.word.sample()
        },
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        maxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        minVestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantFee: faker.number.int({
            max: undefined,
            min: undefined
        }),
        planAccessCode: faker.word.sample(),
        sdbaPlanId: faker.word.sample(),
        sdbaStatus: faker.word.sample(),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        updatedAt: faker.word.sample(),
        updatedBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            idType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock200 = (overrideResponse = {})=>({
        allowSdba: faker.datatype.boolean(),
        createdAt: faker.word.sample(),
        createdBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            idType: faker.word.sample()
        },
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        maxBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        minVestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantFee: faker.number.int({
            max: undefined,
            min: undefined
        }),
        planAccessCode: faker.word.sample(),
        sdbaPlanId: faker.word.sample(),
        sdbaStatus: faker.word.sample(),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        updatedAt: faker.word.sample(),
        updatedBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            idType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaSetupResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            externalTransferType: faker.word.sample(),
            status: faker.word.sample(),
            submissionTime: faker.word.sample(),
            transferId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            externalTransferType: faker.word.sample(),
            status: faker.word.sample(),
            submissionTime: faker.word.sample(),
            transferId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSdbaTransfersInfoResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock = (overrideResponse = {})=>({
        hasActiveTransfers: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock200 = (overrideResponse = {})=>({
        hasActiveTransfers: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSessionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorAbilitiesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock = (overrideResponse = {})=>({
        autoEnroll: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorPlanId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock200 = (overrideResponse = {})=>({
        autoEnroll: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorPlanId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusParticipantsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetBankAccountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBankAccountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutBankAccountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutFeePaymentMethodResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorTeammatesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeleteTeammateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendUserInviteResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock200 = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecorsdId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                max: undefined,
                min: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecorsdId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                max: undefined,
                min: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                censusRecordsId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                censusRecordsId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFileHeadersUpdateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancelSubmissionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCancellationSubmissionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantsLoansResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock = (overrideResponse = {})=>({
        isNew: faker.datatype.boolean(),
        ucid: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock200 = (overrideResponse = {})=>({
        isNew: faker.datatype.boolean(),
        ucid: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostMatchRemediationContributionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOffCycleContributionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostResumeSubmissionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowValidationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionValidationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionSubmissionDisplayResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock = (overrideResponse = {})=>({
        adjustmentData: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                columnNames: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                contributionAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                correctionType: faker.word.sample(),
                createdAt: faker.word.sample(),
                errorCode: faker.word.sample(),
                firstName: faker.word.sample(),
                lastName: faker.word.sample(),
                ssn: faker.word.sample(),
                unallowedAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        fileTag: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock200 = (overrideResponse = {})=>({
        adjustmentData: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                columnNames: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                contributionAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                correctionType: faker.word.sample(),
                createdAt: faker.word.sample(),
                errorCode: faker.word.sample(),
                firstName: faker.word.sample(),
                lastName: faker.word.sample(),
                ssn: faker.word.sample(),
                unallowedAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        fileTag: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionAdjustmentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock = (overrideResponse = {})=>({
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock200 = (overrideResponse = {})=>({
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionConfirmationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionConfirmationDisplayResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionCorrectionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionCorrectionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDetailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionDisplayResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionUploadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionFileResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeitureResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostForfeitureResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionHeaderValidationsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNormalizedContributionDataResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostIngestionFlowStartResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDownloadContributionTemplateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock = (overrideResponse = {})=>({
        forfeitureAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        suspenseAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock200 = (overrideResponse = {})=>({
        forfeitureAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        suspenseAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUnallocatedFundsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationPageDisplayResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionValidationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetDeferralChangesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            employeeClass: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isExcluded: faker.datatype.boolean()
        }));
export const getPortalMiddlewareGetEmployeeClassesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            employeeClass: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isExcluded: faker.datatype.boolean()
        }));
export const getPortalMiddlewareGetEmployeeClassesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeClassesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusOriginalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock = (overrideResponse = {})=>({
        contributions: {
            contributionLimit: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employerYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stateEmployeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            totalDollars: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        editAccess: {
            isAllowedToUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            message: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        employee: {
            accountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            addressUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            afterTaxContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            afterTaxContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            autorebalance: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            cipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInformation: {
                address: {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                mailingAddress: faker.helpers.arrayElement([
                    {
                        address1: faker.word.sample(),
                        address2: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        city: faker.word.sample(),
                        country: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        state: faker.word.sample(),
                        zip: faker.word.sample()
                    },
                    undefined
                ]),
                personalEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                phoneNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                physicalSameAsMailing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                workEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            contributesToRoth: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            contribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            contributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contributions: faker.helpers.arrayElement([
                {
                    irsLimit: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            createdAt: faker.word.sample(),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            deferralChanged: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            deferralElections: {
                afterTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                afterTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                preTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                preTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                rothAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rothType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            emailUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeClass: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employmentStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            esaGroupId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            esaGroupName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gender: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            inRmdAge: faker.datatype.boolean(),
            isDeceased: faker.datatype.boolean(),
            isDisabled: faker.datatype.boolean(),
            isExcluded: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            maritalStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            matchEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            model: faker.helpers.arrayElement([
                {
                    modelId: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    modelName: faker.word.sample(),
                    modelType: faker.word.sample(),
                    modelViewName: faker.word.sample()
                },
                undefined
            ]),
            nameUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onboardingWizardCompletedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantChangedDeferralAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            password: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            psEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            registeredOn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rehireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            riskValue: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            savesForRetirement: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sendEmailUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraAccountStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraCipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraPerEmployerStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            updatedAt: faker.word.sample(),
            updatedBy: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            yearsToRetire: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock200 = (overrideResponse = {})=>({
        contributions: {
            contributionLimit: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employerYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stateEmployeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            totalDollars: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        editAccess: {
            isAllowedToUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            message: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        employee: {
            accountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            addressUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            afterTaxContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            afterTaxContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            autorebalance: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            cipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInformation: {
                address: {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                mailingAddress: faker.helpers.arrayElement([
                    {
                        address1: faker.word.sample(),
                        address2: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        city: faker.word.sample(),
                        country: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        state: faker.word.sample(),
                        zip: faker.word.sample()
                    },
                    undefined
                ]),
                personalEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                phoneNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                physicalSameAsMailing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                workEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            contributesToRoth: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            contribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            contributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contributions: faker.helpers.arrayElement([
                {
                    irsLimit: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            createdAt: faker.word.sample(),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            deferralChanged: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            deferralElections: {
                afterTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                afterTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                preTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                preTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                rothAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rothType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            emailUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeClass: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employmentStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            esaGroupId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            esaGroupName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gender: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            inRmdAge: faker.datatype.boolean(),
            isDeceased: faker.datatype.boolean(),
            isDisabled: faker.datatype.boolean(),
            isExcluded: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            maritalStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            matchEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            model: faker.helpers.arrayElement([
                {
                    modelId: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    modelName: faker.word.sample(),
                    modelType: faker.word.sample(),
                    modelViewName: faker.word.sample()
                },
                undefined
            ]),
            nameUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onboardingWizardCompletedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantChangedDeferralAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            password: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            psEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            registeredOn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rehireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            riskValue: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            savesForRetirement: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sendEmailUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraAccountStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraCipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraPerEmployerStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            updatedAt: faker.word.sample(),
            updatedBy: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            yearsToRetire: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostValidateEmployeeResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock = (overrideResponse = {})=>({
        contributions: {
            contributionLimit: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employerYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stateEmployeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            totalDollars: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        editAccess: {
            isAllowedToUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            message: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        employee: {
            accountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            addressUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            afterTaxContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            afterTaxContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            autorebalance: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            cipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInformation: {
                address: {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                mailingAddress: faker.helpers.arrayElement([
                    {
                        address1: faker.word.sample(),
                        address2: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        city: faker.word.sample(),
                        country: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        state: faker.word.sample(),
                        zip: faker.word.sample()
                    },
                    undefined
                ]),
                personalEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                phoneNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                physicalSameAsMailing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                workEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            contributesToRoth: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            contribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            contributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contributions: faker.helpers.arrayElement([
                {
                    irsLimit: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            createdAt: faker.word.sample(),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            deferralChanged: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            deferralElections: {
                afterTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                afterTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                preTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                preTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                rothAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rothType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            emailUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeClass: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employmentStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            esaGroupId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            esaGroupName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gender: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            inRmdAge: faker.datatype.boolean(),
            isDeceased: faker.datatype.boolean(),
            isDisabled: faker.datatype.boolean(),
            isExcluded: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            maritalStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            matchEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            model: faker.helpers.arrayElement([
                {
                    modelId: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    modelName: faker.word.sample(),
                    modelType: faker.word.sample(),
                    modelViewName: faker.word.sample()
                },
                undefined
            ]),
            nameUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onboardingWizardCompletedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantChangedDeferralAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            password: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            psEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            registeredOn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rehireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            riskValue: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            savesForRetirement: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sendEmailUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraAccountStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraCipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraPerEmployerStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            updatedAt: faker.word.sample(),
            updatedBy: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            yearsToRetire: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock200 = (overrideResponse = {})=>({
        contributions: {
            contributionLimit: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employerYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stateEmployeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            totalDollars: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        editAccess: {
            isAllowedToUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            message: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        employee: {
            accountId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            addressUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            afterTaxContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            afterTaxContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            autorebalance: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            cipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInformation: {
                address: {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                mailingAddress: faker.helpers.arrayElement([
                    {
                        address1: faker.word.sample(),
                        address2: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        city: faker.word.sample(),
                        country: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        state: faker.word.sample(),
                        zip: faker.word.sample()
                    },
                    undefined
                ]),
                personalEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                phoneNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                physicalSameAsMailing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                workEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            contributesToRoth: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            contribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            contributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contributions: faker.helpers.arrayElement([
                {
                    irsLimit: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            createdAt: faker.word.sample(),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            deferralChanged: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            deferralElections: {
                afterTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                afterTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                preTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                preTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                rothAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                rothType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            emailUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeClass: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employmentStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            esaGroupId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            esaGroupName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gender: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            inRmdAge: faker.datatype.boolean(),
            isDeceased: faker.datatype.boolean(),
            isDisabled: faker.datatype.boolean(),
            isExcluded: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            maritalStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            matchEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            model: faker.helpers.arrayElement([
                {
                    modelId: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    modelName: faker.word.sample(),
                    modelType: faker.word.sample(),
                    modelViewName: faker.word.sample()
                },
                undefined
            ]),
            nameUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onboardingWizardCompletedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantChangedDeferralAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            password: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            psEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            registeredOn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rehireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            riskValue: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            rothContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            savesForRetirement: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sendEmailUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraAccountStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraCipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraPerEmployerStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            updatedAt: faker.word.sample(),
            updatedBy: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            yearsToRetire: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEmployeeDetailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContactInfoResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantContributionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: {
                isConvert: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            relationships: {
                firm: {
                    data: {
                        id: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    }
                }
            }
        },
        included: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    recordKeeperId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                }
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock200 = (overrideResponse = {})=>({
        data: {
            attributes: {
                isConvert: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            relationships: {
                firm: {
                    data: {
                        id: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    }
                }
            }
        },
        included: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    recordKeeperId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                }
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEntityResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        offsetEmployerContribution: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        payPlanFees: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        updatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        offsetEmployerContribution: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        payPlanFees: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        updatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetForfeiturePreferenceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutForfeiturePreferenceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetHeapDataResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock = (overrideResponse = {})=>({
        schemaState: {
            censusInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            companyInfo: faker.helpers.arrayElement([
                {
                    mailingAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    physicalAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                undefined
            ]),
            conversionInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            employeeGroups: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        description: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        incentivesOptOut: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        initialBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        initialBonusMinimum: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        lifetimeCap: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        localId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusThreshold: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        name: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        percent: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    })),
                undefined
            ]),
            paymentSetup: faker.helpers.arrayElement([
                {
                    bankAccounts: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    feePayment: faker.helpers.arrayElement([
                        {
                            bankAccountLocalId: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            isPayingWithCreditCard: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    forfeiturePreferences: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    fundingMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    payrollSchedules: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                fundingMethodId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                scheduleName: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ])
                            })),
                        undefined
                    ]),
                    payrollSystemId: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            payrollSetup: {
                payrollSchedules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({})),
                    undefined
                ]),
                payrollSystem: faker.helpers.arrayElement([
                    {},
                    undefined
                ])
            },
            planAdministration: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            planOptions: faker.helpers.arrayElement([
                {},
                undefined
            ])
        },
        status: faker.helpers.arrayElement([
            'completed_successfully',
            'completed_unsuccessfully',
            'in_progress',
            'needs_attention',
            'new',
            'ongoing'
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock200 = (overrideResponse = {})=>({
        schemaState: {
            censusInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            companyInfo: faker.helpers.arrayElement([
                {
                    mailingAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    physicalAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                undefined
            ]),
            conversionInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            employeeGroups: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({
                        description: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        incentivesOptOut: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        initialBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        initialBonusMinimum: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        lifetimeCap: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        localId: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusThreshold: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ]),
                        name: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        percent: faker.helpers.arrayElement([
                            faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            undefined
                        ])
                    })),
                undefined
            ]),
            paymentSetup: faker.helpers.arrayElement([
                {
                    bankAccounts: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    feePayment: faker.helpers.arrayElement([
                        {
                            bankAccountLocalId: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            isPayingWithCreditCard: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    forfeiturePreferences: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    fundingMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    payrollSchedules: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                fundingMethodId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ]),
                                scheduleName: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ])
                            })),
                        undefined
                    ]),
                    payrollSystemId: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            payrollSetup: {
                payrollSchedules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({})),
                    undefined
                ]),
                payrollSystem: faker.helpers.arrayElement([
                    {},
                    undefined
                ])
            },
            planAdministration: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            planOptions: faker.helpers.arrayElement([
                {},
                undefined
            ])
        },
        status: faker.helpers.arrayElement([
            'completed_successfully',
            'completed_unsuccessfully',
            'in_progress',
            'needs_attention',
            'new',
            'ongoing'
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetOnboardingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostOnboardingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutOnboardingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock = (overrideResponse = {})=>({
        fields: {
            above10M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorsFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisoryServiceId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            articlesOfIncorporationLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            assetBasedFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerCity: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerDateOfBirth: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerResidenceCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerSSN: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authorizedSignerEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerWorkPhone: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerZip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            billingContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            censusLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            chargesOffPlatform: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            citizenshipType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            comment: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            controlGroupBusinesses: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    business: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ein: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            conversionParticipantDetailsLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateSubmittedToRecordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            disablePlanDesign: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerIdentificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanAssets: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanCustodian: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanParticipants: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanProvider: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expectedAnnualContributions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feePaymentMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            first3M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            form5500Link: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasCensus: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasMultiplePayrollGroups: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPdmp: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasUnion: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hqCountry: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            identificationCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationExpirationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationIssueDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            investmentProductId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            isActive: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isAuthorizedSigner: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isConvertedPlan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            leasedEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            newOnboarding: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            next2M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            next5M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            offsetEmployerContribution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerForeignDignitaryCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerIsForeignDignitary: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersFamilyMembersEmployees: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    taxFormType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            ownersOver5Percent: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            paaLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            partTimeEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            participationAgreementLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payPlanFees: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            perParticipantFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planTier: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            planType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planYear: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            standardIndustrialClassification: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            summaryPlanDescriptionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            teamMemberEmails: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            totalEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tpaId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            updatedBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock200 = (overrideResponse = {})=>({
        fields: {
            above10M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorsFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisoryServiceId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            articlesOfIncorporationLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            assetBasedFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerCity: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerDateOfBirth: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerResidenceCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerSSN: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authorizedSignerEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerWorkPhone: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerZip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            billingContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            censusLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            chargesOffPlatform: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            citizenshipType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            comment: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            controlGroupBusinesses: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    business: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ein: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            conversionParticipantDetailsLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateSubmittedToRecordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            disablePlanDesign: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerIdentificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanAssets: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanCustodian: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanParticipants: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanProvider: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expectedAnnualContributions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feePaymentMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            first3M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            form5500Link: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasCensus: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasMultiplePayrollGroups: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPdmp: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasUnion: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hqCountry: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            identificationCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationExpirationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationIssueDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            investmentProductId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            isActive: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isAuthorizedSigner: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isConvertedPlan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            leasedEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            newOnboarding: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            next2M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            next5M: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            offsetEmployerContribution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerForeignDignitaryCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerIsForeignDignitary: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersFamilyMembersEmployees: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    taxFormType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            ownersOver5Percent: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            paaLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            partTimeEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            participationAgreementLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payPlanFees: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            perParticipantFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planTier: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            planType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planYear: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            standardIndustrialClassification: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            summaryPlanDescriptionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            teamMemberEmails: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            totalEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            tpaId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            updatedBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingInformationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSponsorOnboardingInformationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadCensusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetInitialCensusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeleteCensusCacheResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({})),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({})),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusCacheResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCensusCacheResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock = (overrideResponse = {})=>({
        allowInitialBonus: faker.datatype.boolean(),
        allowMatch: faker.datatype.boolean(),
        allowMilestoneBonus: faker.datatype.boolean(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock200 = (overrideResponse = {})=>({
        allowInitialBonus: faker.datatype.boolean(),
        allowMatch: faker.datatype.boolean(),
        allowMilestoneBonus: faker.datatype.boolean(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorEsaProgramResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostFinishOnboardingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSendOnboardingUserInviteResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetNextPayrollDatesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            dateFormat: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            defaultAdapterId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            instructionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            integrationTypeId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            isApproved: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPiIntegrated: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            level: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            subName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            useCatchupFields: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useK1: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useTiredMatch: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPayrollProvidersResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            dateFormat: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            defaultAdapterId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            instructionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            integrationTypeId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            isApproved: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPiIntegrated: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            level: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            subName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            useCatchupFields: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useK1: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useTiredMatch: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPayrollProvidersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollProvidersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock = (overrideResponse = {})=>({
        calendlyUrl: faker.word.sample(),
        isConversion: faker.datatype.boolean(),
        isJpm: faker.datatype.boolean(),
        opportunityId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        planDesignConsultType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'Full Consultation',
                'Sales Consultation',
                'Partner Consultation',
                'Self Service Tiles',
                'Solo(K)',
                'Website Direct'
            ]),
            undefined
        ]),
        tpaId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock200 = (overrideResponse = {})=>({
        calendlyUrl: faker.word.sample(),
        isConversion: faker.datatype.boolean(),
        isJpm: faker.datatype.boolean(),
        opportunityId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        planDesignConsultType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'Full Consultation',
                'Sales Consultation',
                'Partner Consultation',
                'Self Service Tiles',
                'Solo(K)',
                'Website Direct'
            ]),
            undefined
        ]),
        tpaId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanDesignConsultStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock = (overrideResponse = {})=>({
        planDesignConsultType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'Full Consultation',
                'Sales Consultation',
                'Partner Consultation',
                'Self Service Tiles',
                'Solo(K)',
                'Website Direct'
            ]),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock200 = (overrideResponse = {})=>({
        planDesignConsultType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'Full Consultation',
                'Sales Consultation',
                'Partner Consultation',
                'Self Service Tiles',
                'Solo(K)',
                'Website Direct'
            ]),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchPlanDesignConsultStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock = (overrideResponse = {})=>({
        bookingLink: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock200 = (overrideResponse = {})=>({
        bookingLink: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanLaunchCallUrlResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accessRoleIds: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    max: undefined,
                    min: undefined
                })),
            clientId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            entityId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            entityType: faker.word.sample(),
            isTemp: faker.datatype.boolean(),
            userId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetUserRolesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accessRoleIds: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    max: undefined,
                    min: undefined
                })),
            clientId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            entityId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            entityType: faker.word.sample(),
            isTemp: faker.datatype.boolean(),
            userId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetUserRolesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetUserRolesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock = (overrideResponse = {})=>({
        error: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        payrollSetups: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableIntegrationTypes: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({})),
                integratedCompanyId: faker.word.sample(),
                integratedCompanyName: faker.word.sample(),
                is180IntegrationOn: faker.datatype.boolean(),
                is360IntegrationOn: faker.datatype.boolean(),
                isConnectionValid: faker.datatype.boolean(),
                isIntegrationEligible: faker.datatype.boolean(),
                isIntegrationOn: faker.datatype.boolean(),
                payrollProviderId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                payrollProviderName: faker.word.sample(),
                payrollSetupFrequency: faker.word.sample(),
                payrollSetupId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                payrollSetupName: faker.word.sample(),
                reasonsForIneligibility: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample())
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock200 = (overrideResponse = {})=>({
        error: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        payrollSetups: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                availableIntegrationTypes: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>({})),
                integratedCompanyId: faker.word.sample(),
                integratedCompanyName: faker.word.sample(),
                is180IntegrationOn: faker.datatype.boolean(),
                is360IntegrationOn: faker.datatype.boolean(),
                isConnectionValid: faker.datatype.boolean(),
                isIntegrationEligible: faker.datatype.boolean(),
                isIntegrationOn: faker.datatype.boolean(),
                payrollProviderId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                payrollProviderName: faker.word.sample(),
                payrollSetupFrequency: faker.word.sample(),
                payrollSetupId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                payrollSetupName: faker.word.sample(),
                reasonsForIneligibility: Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample())
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollDatesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollInfoResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollSetupsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPayrollFundingSetupsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollProviderResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSkipStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutSkipSubmissionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePayrollSetupResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollDatesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPayrollSetupInfoResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPayrollValidationsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock = (overrideResponse = {})=>({
        allowRollover: faker.word.sample(),
        autoEnrollAmountPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        autoEnrollEffectiveDate: faker.word.sample(),
        autoEscalateAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        blackoutEndDate: faker.word.sample(),
        blackoutStartDate: faker.word.sample(),
        hasDualEligibility: faker.datatype.boolean(),
        hasPriorLoans: faker.datatype.boolean(),
        isAfterTaxContributionAllowed: faker.datatype.boolean(),
        isAutoEnroll: faker.datatype.boolean(),
        isAutoEscalate: faker.datatype.boolean(),
        isCalculateEmployerMatch: faker.datatype.boolean(),
        isDeferInDollars: faker.datatype.boolean(),
        isEarlyRetirementAllowed: faker.datatype.boolean(),
        isEmployerMatching: faker.datatype.boolean(),
        isHardshipDistributionAllowed: faker.datatype.boolean(),
        isHardshipProofRequired: faker.datatype.boolean(),
        isLoansAllowed: faker.datatype.boolean(),
        isPreTaxContributionAllowed: faker.datatype.boolean(),
        isProfitSharing: faker.datatype.boolean(),
        isSafeHarborMatchAllowed: faker.datatype.boolean(),
        isSafeHarborNonElectiveAllowed: faker.datatype.boolean(),
        isSalaryRothDeferral: faker.datatype.boolean(),
        profitSharingType: faker.word.sample(),
        safeHarborContributionType: faker.word.sample(),
        safeHarborMatchType: faker.word.sample(),
        safeHarborMatchTypeDescription: faker.word.sample(),
        vestingPeriod: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock200 = (overrideResponse = {})=>({
        allowRollover: faker.word.sample(),
        autoEnrollAmountPct: faker.number.int({
            max: undefined,
            min: undefined
        }),
        autoEnrollEffectiveDate: faker.word.sample(),
        autoEscalateAmount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        blackoutEndDate: faker.word.sample(),
        blackoutStartDate: faker.word.sample(),
        hasDualEligibility: faker.datatype.boolean(),
        hasPriorLoans: faker.datatype.boolean(),
        isAfterTaxContributionAllowed: faker.datatype.boolean(),
        isAutoEnroll: faker.datatype.boolean(),
        isAutoEscalate: faker.datatype.boolean(),
        isCalculateEmployerMatch: faker.datatype.boolean(),
        isDeferInDollars: faker.datatype.boolean(),
        isEarlyRetirementAllowed: faker.datatype.boolean(),
        isEmployerMatching: faker.datatype.boolean(),
        isHardshipDistributionAllowed: faker.datatype.boolean(),
        isHardshipProofRequired: faker.datatype.boolean(),
        isLoansAllowed: faker.datatype.boolean(),
        isPreTaxContributionAllowed: faker.datatype.boolean(),
        isProfitSharing: faker.datatype.boolean(),
        isSafeHarborMatchAllowed: faker.datatype.boolean(),
        isSafeHarborNonElectiveAllowed: faker.datatype.boolean(),
        isSalaryRothDeferral: faker.datatype.boolean(),
        profitSharingType: faker.word.sample(),
        safeHarborContributionType: faker.word.sample(),
        safeHarborMatchType: faker.word.sample(),
        safeHarborMatchTypeDescription: faker.word.sample(),
        vestingPeriod: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanFeaturesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOnboardingStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: {
                accountBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                cashBalanceInterestRate: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployer: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsLoan: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsRollover: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                eligibleParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                employedParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                modelAgeDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            ageRange: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    '<=25',
                                    '26-35',
                                    '36-45',
                                    '46-55',
                                    '56-65',
                                    '>=66'
                                ]),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    'target',
                                    'risk',
                                    'menu',
                                    'pmenu',
                                    'goal',
                                    'ms_ma',
                                    'ms_ma_menu',
                                    'nli'
                                ]),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                modelDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            factsheet: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            viewName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                mostRecentEmployeeContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                mostRecentEmployerContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                mostRecentLoanContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                nextPayrollDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participantsWithBeneficiary: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participantsWithDeferrals: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participationRate: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                readyToEnrollParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                registeredParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                totalContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                totalParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                totalPlanMarketValue: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock200 = (overrideResponse = {})=>({
        data: {
            attributes: {
                accountBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                cashBalanceInterestRate: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployee: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployer: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsLoan: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                currentPositionsRollover: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                eligibleParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                employedParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                modelAgeDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            ageRange: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    '<=25',
                                    '26-35',
                                    '36-45',
                                    '46-55',
                                    '56-65',
                                    '>=66'
                                ]),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    'target',
                                    'risk',
                                    'menu',
                                    'pmenu',
                                    'goal',
                                    'ms_ma',
                                    'ms_ma_menu',
                                    'nli'
                                ]),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                modelDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            factsheet: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            viewName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                mostRecentEmployeeContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                mostRecentEmployerContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                mostRecentLoanContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                nextPayrollDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participantsWithBeneficiary: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participantsWithDeferrals: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                participationRate: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                readyToEnrollParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                registeredParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                totalContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                totalParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                totalPlanMarketValue: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanStatisticsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock200 = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanConfigurationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanConfigurationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanEmployeesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanEmployeesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanEmployeesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecorsdId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                max: undefined,
                min: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecorsdId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                max: undefined,
                min: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanGrossCompensationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetGrossCompensationTemplateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOfficersResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            censusRecordsId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOfficersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOfficersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOfficerStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanOwnersResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetPlanOwnersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPlanEmployeeOwnerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanEmployeeOwnerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareDeletePlanOwnersFamilyResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                censusRecordsId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                censusRecordsId: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanOwnersFamilyResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutPlanOwnersFamilyResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTrackerDetailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostPriorProviderResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPriorProvidersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock = (overrideResponse = {})=>({
        onboarding: faker.helpers.arrayElement([
            {
                questionnaireSubmittedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock200 = (overrideResponse = {})=>({
        onboarding: faker.helpers.arrayElement([
            {
                questionnaireSubmittedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSponsorQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchSponsorQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock = (overrideResponse = {})=>({
        address: faker.helpers.arrayElement([
            {
                address1: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                zip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        anticipatedHires: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        authSignerFirstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerWorkPhone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authorizedSignerEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyEntityType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyPhoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contributionScenario: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        controlGroupBusinesses: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        currentComplianceIssues: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        dayToDayContactEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        doingBusinessAs: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employerIdentificationNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanProvider: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiscalYearEnd: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasOtherBusinesses: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        highlyCompensatedEmployees: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        industryGroup: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isConvert: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isPartOfControlGroup: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ownerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        payrollProviderId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        payrollProviderOther: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        questionnaireSubmittedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        relativesOfOwnerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        retirementObjectives: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorPlan: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    pooledPlan: faker.helpers.arrayElement([
                        {
                            pooledPlanId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            pooledPlanType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    thirdPartyAdminPlan: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                thirdPartyAdminId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                })),
            undefined
        ]),
        stateOfIncorporation: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        totalEmployeesNumber: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        wiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock200 = (overrideResponse = {})=>({
        address: faker.helpers.arrayElement([
            {
                address1: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                zip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        anticipatedHires: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        authSignerFirstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerWorkPhone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authorizedSignerEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyEntityType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyPhoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contributionScenario: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        controlGroupBusinesses: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        currentComplianceIssues: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        dayToDayContactEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        doingBusinessAs: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employerIdentificationNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanProvider: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiscalYearEnd: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasOtherBusinesses: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        highlyCompensatedEmployees: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        industryGroup: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isConvert: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isPartOfControlGroup: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ownerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        payrollProviderId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        payrollProviderOther: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        questionnaireSubmittedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        relativesOfOwnerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        retirementObjectives: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorPlan: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    pooledPlan: faker.helpers.arrayElement([
                        {
                            pooledPlanId: faker.helpers.arrayElement([
                                faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                undefined
                            ]),
                            pooledPlanType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    thirdPartyAdminPlan: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                thirdPartyAdminId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        max: undefined,
                                        min: undefined
                                    }),
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                })),
            undefined
        ]),
        stateOfIncorporation: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        totalEmployeesNumber: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        wiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetQuestionnaireInformationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetContributionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock = (overrideResponse = {})=>({
        forfeituresBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        migrationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        suspenseBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock200 = (overrideResponse = {})=>({
        forfeituresBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        migrationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        suspenseBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaPlanDetailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                actionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                amount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                createdAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                forfeitedBalance: faker.helpers.arrayElement([
                    {
                        participantFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        participantLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        withdrawalId: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ]),
                fundingContribution: faker.helpers.arrayElement([
                    {
                        expectedPayDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ucid: faker.word.sample()
                    },
                    undefined
                ]),
                payingFees: faker.helpers.arrayElement([
                    {
                        billingPeriodId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        periodEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        periodStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        purpose: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                sourceTransactionId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                status: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tracerId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                transactionTypeCode: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        meta: {
            count: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                actionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                amount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                createdAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                forfeitedBalance: faker.helpers.arrayElement([
                    {
                        participantFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        participantLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        withdrawalId: faker.number.int({
                            max: undefined,
                            min: undefined
                        })
                    },
                    undefined
                ]),
                fundingContribution: faker.helpers.arrayElement([
                    {
                        expectedPayDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ucid: faker.word.sample()
                    },
                    undefined
                ]),
                payingFees: faker.helpers.arrayElement([
                    {
                        billingPeriodId: faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        periodEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        periodStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        purpose: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                sourceTransactionId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                status: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tracerId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                transactionTypeCode: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        meta: {
            count: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetSubaTransactionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusAutosaveResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataDownloadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthDate: faker.word.sample(),
            dateOfHire: faker.word.sample(),
            dateOfRehire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerDiscretionaryMatch: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employerSafeHarborContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            firstName: faker.word.sample(),
            grossComp: faker.number.int({
                max: undefined,
                min: undefined
            }),
            lastName: faker.word.sample(),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTaxContribution: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            secondDateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sponsorPlanId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ssn: faker.word.sample(),
            ytdHours: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            birthDate: faker.word.sample(),
            dateOfHire: faker.word.sample(),
            dateOfRehire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerDiscretionaryMatch: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            employerSafeHarborContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            firstName: faker.word.sample(),
            grossComp: faker.number.int({
                max: undefined,
                min: undefined
            }),
            lastName: faker.word.sample(),
            participantId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTaxContribution: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            secondDateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sponsorPlanId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            ssn: faker.word.sample(),
            ytdHours: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetCensusDataPagedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock = (overrideResponse = {})=>({
        recordsAdded: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock200 = (overrideResponse = {})=>({
        recordsAdded: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRefreshCensusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartCensusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusStartResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock = (overrideResponse = {})=>({
        started: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock200 = (overrideResponse = {})=>({
        started: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetCensusStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusSubmitResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock = (overrideResponse = {})=>({
        failures: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                error: faker.word.sample(),
                row: faker.word.sample()
            })),
        successCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock200 = (overrideResponse = {})=>({
        failures: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                error: faker.word.sample(),
                row: faker.word.sample()
            })),
        successCount: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetCensusUploadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock200 = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetChecklistResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock200 = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchYetChecklistResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock = (overrideResponse = {})=>({
        shouldDisplayYearEndPlanToDo: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock200 = (overrideResponse = {})=>({
        shouldDisplayYearEndPlanToDo: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetConfigResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsFundResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostContributionsRefundResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getPortalMiddlewareGetYetDocumentsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getPortalMiddlewareGetYetDocumentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetDocumentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostStartOfPackagingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock = (overrideResponse = {})=>({
        testExecution: {
            additionalData: {},
            document: faker.helpers.arrayElement([
                {
                    createdAt: faker.word.sample(),
                    documentKey: faker.word.sample(),
                    entity: faker.word.sample(),
                    entityId: faker.word.sample(),
                    etag: faker.word.sample(),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    isEnabled: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    originalFileName: faker.word.sample(),
                    uploadPath: faker.word.sample()
                },
                undefined
            ]),
            documentTestResultId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            originalFileName: faker.word.sample(),
            result: faker.word.sample(),
            testId: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        yearEndContribution: {
            result: faker.word.sample(),
            resultCompliancePackage: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultDiscretionaryMatch: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultProfitSharing: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultSafeHarbor: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultYearEndContribution: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            testId: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock200 = (overrideResponse = {})=>({
        testExecution: {
            additionalData: {},
            document: faker.helpers.arrayElement([
                {
                    createdAt: faker.word.sample(),
                    documentKey: faker.word.sample(),
                    entity: faker.word.sample(),
                    entityId: faker.word.sample(),
                    etag: faker.word.sample(),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    isEnabled: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    originalFileName: faker.word.sample(),
                    uploadPath: faker.word.sample()
                },
                undefined
            ]),
            documentTestResultId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            originalFileName: faker.word.sample(),
            result: faker.word.sample(),
            testId: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        yearEndContribution: {
            result: faker.word.sample(),
            resultCompliancePackage: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultDiscretionaryMatch: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultProfitSharing: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultSafeHarbor: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            resultYearEndContribution: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            max: 10,
                                            min: 1
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                id: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    max: undefined,
                                    min: undefined
                                })
                            },
                            id: faker.number.int({
                                max: undefined,
                                min: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        max: undefined,
                        min: undefined
                    })
                },
                undefined
            ]),
            testId: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanTestResultsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock = (overrideResponse = {})=>({
        answers: {
            ASSETS_NOT_AT_LT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIODS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIOD_NOTICE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BOND_AMOUNT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BUSINESS_CODE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION_AMOUNT_AND_FORMULA: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            FEES_AND_COMMISSIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LATE_BENEFITS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            NONEXEMPT_TRANSACTIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_OWNERSHIP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PLAN_LOSS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAXED_AS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAX_EXTENSION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            }
        },
        questionnaire: faker.word.sample(),
        sponsorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        year: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock200 = (overrideResponse = {})=>({
        answers: {
            ASSETS_NOT_AT_LT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIODS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIOD_NOTICE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BOND_AMOUNT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BUSINESS_CODE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION_AMOUNT_AND_FORMULA: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            FEES_AND_COMMISSIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LATE_BENEFITS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            NONEXEMPT_TRANSACTIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_OWNERSHIP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PLAN_LOSS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAXED_AS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAX_EXTENSION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            }
        },
        questionnaire: faker.word.sample(),
        sponsorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sponsorPlanId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        year: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostRestartTestingProcessResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYtdContributionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock = (overrideResponse = {})=>({
        balanceAtRetirement: faker.number.int({
            max: undefined,
            min: undefined
        }),
        disclosure: faker.word.sample(),
        estimatedAnnualIncome: faker.number.int({
            max: undefined,
            min: undefined
        }),
        maxLoyaltyBonusPercentage: faker.number.int({
            max: undefined,
            min: undefined
        }),
        minLoyaltyBonusPercentage: faker.number.int({
            max: undefined,
            min: undefined
        }),
        retirementAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock200 = (overrideResponse = {})=>({
        balanceAtRetirement: faker.number.int({
            max: undefined,
            min: undefined
        }),
        disclosure: faker.word.sample(),
        estimatedAnnualIncome: faker.number.int({
            max: undefined,
            min: undefined
        }),
        maxLoyaltyBonusPercentage: faker.number.int({
            max: undefined,
            min: undefined
        }),
        minLoyaltyBonusPercentage: faker.number.int({
            max: undefined,
            min: undefined
        }),
        retirementAge: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetTiaaIncomeProjectionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePatchParticipantByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allocationPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            beneficiaryId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            beneficiaryType: faker.helpers.arrayElement([
                'person',
                'trust',
                'organization'
            ]),
            businessName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            email: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            holdingFinancialInstitution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isPrimary: faker.datatype.boolean(),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            relationship: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                    'spouse',
                    'child',
                    'parent',
                    'other'
                ]),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allocationPct: faker.number.int({
                max: undefined,
                min: undefined
            }),
            beneficiaryId: faker.number.int({
                max: undefined,
                min: undefined
            }),
            beneficiaryType: faker.helpers.arrayElement([
                'person',
                'trust',
                'organization'
            ]),
            businessName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            email: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            holdingFinancialInstitution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isPrimary: faker.datatype.boolean(),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            relationship: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                    'spouse',
                    'child',
                    'parent',
                    'other'
                ]),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantBeneficiariesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        custodianAccountNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        eligibleParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        employeeBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        employerBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        firmId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        forfeitureBalance: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        hasPriorLoans: faker.datatype.boolean(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inboundBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        inboundBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isActive: faker.datatype.boolean(),
        isBlackout: faker.datatype.boolean(),
        isOffboardingBlackoutActive: faker.datatype.boolean(),
        loanBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        name: faker.word.sample(),
        notes: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantsWithBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            max: undefined,
            min: undefined
        }),
        programId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        readyToEnrollParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        recordkeeper: faker.word.sample(),
        recordkeeperId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        registeredParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sponsorCompanyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        statefulSchemaTrackingState: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        status: faker.word.sample(),
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        tpaIds: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    max: undefined,
                    min: undefined
                })),
            undefined
        ]),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock200 = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        custodianAccountNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        eligibleParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        employeeBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        employerBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        firmId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        forfeitureBalance: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        hasPriorLoans: faker.datatype.boolean(),
        id: faker.number.int({
            max: undefined,
            min: undefined
        }),
        inboundBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        inboundBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isActive: faker.datatype.boolean(),
        isBlackout: faker.datatype.boolean(),
        isOffboardingBlackoutActive: faker.datatype.boolean(),
        loanBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        name: faker.word.sample(),
        notes: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantsWithBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            max: undefined,
            min: undefined
        }),
        programId: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        readyToEnrollParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        recordkeeper: faker.word.sample(),
        recordkeeperId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        registeredParticipants: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        sponsorCompanyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        statefulSchemaTrackingState: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        status: faker.word.sample(),
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        tpaIds: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    max: undefined,
                    min: undefined
                })),
            undefined
        ]),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetPlanByIdV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            name: faker.word.sample(),
            vestingScheduleId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetVestingScheduleResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            name: faker.word.sample(),
            vestingScheduleId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetVestingScheduleResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVestingScheduleResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock = (overrideResponse = {})=>({
        data: {
            gift: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            icon: faker.word.sample(),
            id: faker.word.sample(),
            legalName: faker.word.sample(),
            linkText: faker.word.sample(),
            logo: faker.word.sample(),
            name: faker.word.sample(),
            shortName: faker.word.sample(),
            siteUrl: faker.word.sample(),
            supportHoursPhone: faker.word.sample(),
            supportHoursTty: faker.word.sample(),
            supportPhone: faker.word.sample(),
            supportTty: faker.word.sample(),
            transactionLimits: {},
            type: faker.helpers.arrayElement([
                'able',
                'collegeSavings',
                'secureChoice'
            ]),
            urls: {}
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock200 = (overrideResponse = {})=>({
        data: {
            gift: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            icon: faker.word.sample(),
            id: faker.word.sample(),
            legalName: faker.word.sample(),
            linkText: faker.word.sample(),
            logo: faker.word.sample(),
            name: faker.word.sample(),
            shortName: faker.word.sample(),
            siteUrl: faker.word.sample(),
            supportHoursPhone: faker.word.sample(),
            supportHoursTty: faker.word.sample(),
            supportPhone: faker.word.sample(),
            supportTty: faker.word.sample(),
            transactionLimits: {},
            type: faker.helpers.arrayElement([
                'able',
                'collegeSavings',
                'secureChoice'
            ]),
            urls: {}
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssPlanByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock = (overrideResponse = {})=>({
        data: {
            status: faker.helpers.arrayElement([
                'unknown',
                'none',
                'readOnly',
                'normal'
            ])
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock200 = (overrideResponse = {})=>({
        data: {
            status: faker.helpers.arrayElement([
                'unknown',
                'none',
                'readOnly',
                'normal'
            ])
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetVssStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostLobLetterEventsWebhookResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            forfeitureAccountsHelpPlanExpenses: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payGroupLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        max: 10,
                                        min: 1
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.word.sample(),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock200 = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            forfeitureAccountsHelpPlanExpenses: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payGroupLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        max: 10,
                                        min: 1
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.word.sample(),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            forfeitureAccountsHelpPlanExpenses: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payGroupLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        max: 10,
                                        min: 1
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.word.sample(),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock200 = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        max: 10,
                        min: 1
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            forfeitureAccountsHelpPlanExpenses: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payGroupLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                max: 10,
                                min: 1
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        max: 10,
                                        min: 1
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            max: 10,
                            min: 1
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.word.sample(),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock = ()=>faker.number.int();
export const getPortalMiddlewarePostCreateWithdrawalResponseMock200 = ()=>faker.number.int();
export const getPortalMiddlewarePostCreateWithdrawalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostCreateWithdrawalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            data: {
                attributes: {
                    costBasis: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    costType: faker.helpers.arrayElement([
                        'aftertax',
                        'roth'
                    ]),
                    detailsType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    establishedDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ssn: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                type: faker.word.sample()
            }
        }));
export const getPortalMiddlewareGetParticipantCostBasisResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            data: {
                attributes: {
                    costBasis: faker.helpers.arrayElement([
                        faker.number.int({
                            max: undefined,
                            min: undefined
                        }),
                        undefined
                    ]),
                    costType: faker.helpers.arrayElement([
                        'aftertax',
                        'roth'
                    ]),
                    detailsType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    establishedDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ssn: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                type: faker.word.sample()
            }
        }));
export const getPortalMiddlewareGetParticipantCostBasisResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetParticipantCostBasisResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock200 = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock = (overrideResponse = {})=>({
        age1: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        age2: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        lifeExpectancy: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        requiredAmount: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        type: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        vestedBalance: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        withdrawalAmount: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        year: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock200 = (overrideResponse = {})=>({
        age1: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        age2: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        lifeExpectancy: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        requiredAmount: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        type: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        vestedBalance: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        withdrawalAmount: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        year: faker.helpers.arrayElement([
            faker.number.int({
                max: undefined,
                min: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdAmountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock = (overrideResponse = {})=>({
        balance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        year: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock200 = (overrideResponse = {})=>({
        balance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        year: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRmdBalanceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    address: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    mailType: faker.helpers.arrayElement([
                        faker.helpers.arrayElement([
                            'Express Mail',
                            'Normal Mail'
                        ]),
                        undefined
                    ]),
                    providerAlias: faker.word.sample(),
                    providerName: faker.word.sample(),
                    providerShort: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    max: 10,
                    min: 1
                })
            }, (_, i)=>i + 1).map(()=>({
                    address: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    mailType: faker.helpers.arrayElement([
                        faker.helpers.arrayElement([
                            'Express Mail',
                            'Normal Mail'
                        ]),
                        undefined
                    ]),
                    providerAlias: faker.word.sample(),
                    providerName: faker.word.sample(),
                    providerShort: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetRolloverProvidersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock = (overrideResponse = {})=>({
        data: {
            code1099: faker.word.sample(),
            federalWithholdingPercent: faker.word.sample(),
            qualifiedRoth: faker.word.sample(),
            rothInitialYear: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stateWithholdingCode: faker.word.sample(),
            stateWithholdingPercent: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            taxType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock200 = (overrideResponse = {})=>({
        data: {
            code1099: faker.word.sample(),
            federalWithholdingPercent: faker.word.sample(),
            qualifiedRoth: faker.word.sample(),
            rothInitialYear: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            stateWithholdingCode: faker.word.sample(),
            stateWithholdingPercent: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            taxType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                code1099: faker.word.sample(),
                federalWithholdingAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                federalWithholdingPercent: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isQualifiedRoth: faker.datatype.boolean(),
                isRollover: faker.datatype.boolean(),
                rothInitialYear: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                stateWithholdingAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                stateWithholdingCode: faker.word.sample(),
                stateWithholdingPercent: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                taxType: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                code1099: faker.word.sample(),
                federalWithholdingAmount: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                federalWithholdingPercent: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                isQualifiedRoth: faker.datatype.boolean(),
                isRollover: faker.datatype.boolean(),
                rothInitialYear: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                stateWithholdingAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                stateWithholdingCode: faker.word.sample(),
                stateWithholdingPercent: faker.helpers.arrayElement([
                    faker.number.int({
                        max: undefined,
                        min: undefined
                    }),
                    undefined
                ]),
                taxType: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetWithholdingDetailResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            description: faker.word.sample(),
            naicsCodeId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetYetNaicsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            description: faker.word.sample(),
            naicsCodeId: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getPortalMiddlewareGetYetNaicsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetYetNaicsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock = (overrideResponse = {})=>({
        conversationFields: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                id: faker.word.sample(),
                value: {}
            })),
        jwt: faker.word.sample(),
        key: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock200 = (overrideResponse = {})=>({
        conversationFields: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                id: faker.word.sample(),
                value: {}
            })),
        jwt: faker.word.sample(),
        key: faker.word.sample(),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetZendeskJwtResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPortalMiddlewareGetEntitySessionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock = (overrideResponse = {})=>({
        nestedProp: {
            ref: faker.datatype.boolean()
        },
        public: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock200 = (overrideResponse = {})=>({
        nestedProp: {
            ref: faker.datatype.boolean()
        },
        public: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getHealthGetPublicRouteResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock = (overrideResponse = {})=>({
        demo: faker.datatype.boolean(),
        name: faker.word.sample(),
        nestedProp: {
            nested: faker.datatype.boolean()
        },
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock200 = (overrideResponse = {})=>({
        demo: faker.datatype.boolean(),
        name: faker.word.sample(),
        nestedProp: {
            nested: faker.datatype.boolean()
        },
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthPostDemoSdkResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthHealthGetHealthResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock = (overrideResponse = {})=>({
        employeeDetails: {
            afterTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        employerDetails: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                fundingSource: faker.word.sample(),
                totalBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        endingBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverDetails: {
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        startingBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        summary: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                groupByCategory: faker.helpers.arrayElement([
                    'Conversions',
                    'Corrective Withdrawals',
                    'Employer Contributions',
                    'Fees',
                    'Forfeitures/Suspense',
                    'Gain/Losses',
                    'Income',
                    'Investment Updates',
                    'Loan Disbursements',
                    'Loan Repayments',
                    'Miscellaneous',
                    'Operational',
                    'Other Contributions',
                    'Other Repayments',
                    'Rollover Contributions',
                    'Saver Contributions',
                    'Withdrawals'
                ]),
                totalValue: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock200 = (overrideResponse = {})=>({
        employeeDetails: {
            afterTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        employerDetails: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                fundingSource: faker.word.sample(),
                totalBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        endingBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rolloverDetails: {
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        startingBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        summary: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                groupByCategory: faker.helpers.arrayElement([
                    'Conversions',
                    'Corrective Withdrawals',
                    'Employer Contributions',
                    'Fees',
                    'Forfeitures/Suspense',
                    'Gain/Losses',
                    'Income',
                    'Investment Updates',
                    'Loan Disbursements',
                    'Loan Repayments',
                    'Miscellaneous',
                    'Operational',
                    'Other Contributions',
                    'Other Repayments',
                    'Rollover Contributions',
                    'Saver Contributions',
                    'Withdrawals'
                ]),
                totalValue: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetActivitySummaryResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock = (overrideResponse = {})=>({
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock200 = (overrideResponse = {})=>({
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetCurrentBalanceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            balanceOverTime: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tradeDate: faker.word.sample()
        }));
export const getWentworthBalanceGetBalanceOverTimeResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            balanceOverTime: faker.number.int({
                max: undefined,
                min: undefined
            }),
            tradeDate: faker.word.sample()
        }));
export const getWentworthBalanceGetBalanceOverTimeResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalanceOverTimeResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock = (overrideResponse = {})=>({
        employeeDetails: {
            afterTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        employerDetails: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                fundingSource: faker.word.sample(),
                totalBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                unvestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                vestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        rolloverDetails: {
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock200 = (overrideResponse = {})=>({
        employeeDetails: {
            afterTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        employerDetails: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                fundingSource: faker.word.sample(),
                totalBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                unvestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                vestedBalance: faker.number.int({
                    max: undefined,
                    min: undefined
                })
            })),
        rolloverDetails: {
            preTax: faker.number.int({
                max: undefined,
                min: undefined
            }),
            roth: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetBalancesGroupedBySourceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock = (overrideResponse = {})=>({
        availableFlowReportingCategories: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        results: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                accountLevel: faker.helpers.arrayElement([
                    'PARENT_ACCOUNT',
                    'SUB_ACCOUNT'
                ]),
                amount: faker.word.sample(),
                byInvestmentReportingCategory: {},
                confirmDate: faker.word.sample(),
                contributionYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                controlDate: faker.word.sample(),
                createdAt: faker.word.sample(),
                dividendEligibleDate: faker.word.sample(),
                fee: faker.word.sample(),
                flowReportingCategory: faker.helpers.arrayElement([
                    'Employer Contributions',
                    'Other Contributions',
                    'Rollover Contributions',
                    'Saver Contributions'
                ]),
                investorId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                orderId: faker.word.sample(),
                reportingAmounts: {
                    byInvestmentReportingAmount: faker.word.sample(),
                    flowReportingAmount: faker.word.sample()
                },
                reversedDate: faker.word.sample(),
                reversedTransactionId: faker.word.sample(),
                reversingTransactionId: faker.word.sample(),
                security: {
                    cusip: faker.word.sample(),
                    description: faker.word.sample(),
                    symbol: faker.word.sample()
                },
                securityOrderType: faker.helpers.arrayElement([
                    'DOLLAR_ORDER',
                    'UNIT_ORDER',
                    'DOLLAR_ALL',
                    'UNIT_ALL'
                ]),
                securityUnitPrice: faker.word.sample(),
                settlementDate: faker.word.sample(),
                sourceTransactionId: faker.word.sample(),
                status: faker.helpers.arrayElement([
                    'CONFIRMED',
                    'REVERSED'
                ]),
                tracerId: faker.word.sample(),
                tradeDate: faker.word.sample(),
                transactionBaseType: {},
                transactionType: {
                    description: faker.word.sample(),
                    label: faker.word.sample()
                },
                transactionTypeCode: faker.word.sample(),
                transferSubAccountId: faker.word.sample(),
                units: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock200 = (overrideResponse = {})=>({
        availableFlowReportingCategories: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        results: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                accountLevel: faker.helpers.arrayElement([
                    'PARENT_ACCOUNT',
                    'SUB_ACCOUNT'
                ]),
                amount: faker.word.sample(),
                byInvestmentReportingCategory: {},
                confirmDate: faker.word.sample(),
                contributionYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                controlDate: faker.word.sample(),
                createdAt: faker.word.sample(),
                dividendEligibleDate: faker.word.sample(),
                fee: faker.word.sample(),
                flowReportingCategory: faker.helpers.arrayElement([
                    'Employer Contributions',
                    'Other Contributions',
                    'Rollover Contributions',
                    'Saver Contributions'
                ]),
                investorId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                orderId: faker.word.sample(),
                reportingAmounts: {
                    byInvestmentReportingAmount: faker.word.sample(),
                    flowReportingAmount: faker.word.sample()
                },
                reversedDate: faker.word.sample(),
                reversedTransactionId: faker.word.sample(),
                reversingTransactionId: faker.word.sample(),
                security: {
                    cusip: faker.word.sample(),
                    description: faker.word.sample(),
                    symbol: faker.word.sample()
                },
                securityOrderType: faker.helpers.arrayElement([
                    'DOLLAR_ORDER',
                    'UNIT_ORDER',
                    'DOLLAR_ALL',
                    'UNIT_ALL'
                ]),
                securityUnitPrice: faker.word.sample(),
                settlementDate: faker.word.sample(),
                sourceTransactionId: faker.word.sample(),
                status: faker.helpers.arrayElement([
                    'CONFIRMED',
                    'REVERSED'
                ]),
                tracerId: faker.word.sample(),
                tradeDate: faker.word.sample(),
                transactionBaseType: {},
                transactionType: {
                    description: faker.word.sample(),
                    label: faker.word.sample()
                },
                transactionTypeCode: faker.word.sample(),
                transferSubAccountId: faker.word.sample(),
                units: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCompletedContributionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock = (overrideResponse = {})=>({
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock200 = (overrideResponse = {})=>({
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetContributionDetailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accountId: faker.word.sample(),
            accountLevel: faker.helpers.arrayElement([
                'PARENT_ACCOUNT',
                'SUB_ACCOUNT'
            ]),
            amount: faker.word.sample(),
            byInvestmentReportingCategory: {},
            contributionYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            controlDate: faker.word.sample(),
            createdAt: faker.word.sample(),
            dividendEligibleDate: faker.word.sample(),
            fee: faker.word.sample(),
            flowReportingCategory: faker.helpers.arrayElement([
                'Employer Contributions',
                'Other Contributions',
                'Saver Contributions'
            ]),
            investorId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            orderId: faker.word.sample(),
            reportingAmounts: {
                byInvestmentReportingAmount: faker.word.sample(),
                flowReportingAmount: faker.word.sample()
            },
            security: {
                cusip: faker.word.sample(),
                description: faker.word.sample(),
                symbol: faker.word.sample()
            },
            securityOrderType: faker.helpers.arrayElement([
                'DOLLAR_ORDER',
                'UNIT_ORDER',
                'DOLLAR_ALL',
                'UNIT_ALL'
            ]),
            securityUnitPrice: faker.word.sample(),
            settlementDate: faker.word.sample(),
            sourceTransactionId: faker.word.sample(),
            status: faker.helpers.arrayElement([
                'pending',
                'cancelled',
                'confirmed',
                'deleted'
            ]),
            tracerId: faker.word.sample(),
            tradeDate: faker.word.sample(),
            transactionBaseType: {},
            transactionType: {
                description: faker.word.sample(),
                label: faker.word.sample()
            },
            transactionTypeCode: faker.word.sample(),
            transferSubAccountId: faker.word.sample(),
            units: faker.word.sample()
        }));
export const getWentworthContributionsGetPendingContributionsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            accountId: faker.word.sample(),
            accountLevel: faker.helpers.arrayElement([
                'PARENT_ACCOUNT',
                'SUB_ACCOUNT'
            ]),
            amount: faker.word.sample(),
            byInvestmentReportingCategory: {},
            contributionYear: faker.number.int({
                max: undefined,
                min: undefined
            }),
            controlDate: faker.word.sample(),
            createdAt: faker.word.sample(),
            dividendEligibleDate: faker.word.sample(),
            fee: faker.word.sample(),
            flowReportingCategory: faker.helpers.arrayElement([
                'Employer Contributions',
                'Other Contributions',
                'Saver Contributions'
            ]),
            investorId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            orderId: faker.word.sample(),
            reportingAmounts: {
                byInvestmentReportingAmount: faker.word.sample(),
                flowReportingAmount: faker.word.sample()
            },
            security: {
                cusip: faker.word.sample(),
                description: faker.word.sample(),
                symbol: faker.word.sample()
            },
            securityOrderType: faker.helpers.arrayElement([
                'DOLLAR_ORDER',
                'UNIT_ORDER',
                'DOLLAR_ALL',
                'UNIT_ALL'
            ]),
            securityUnitPrice: faker.word.sample(),
            settlementDate: faker.word.sample(),
            sourceTransactionId: faker.word.sample(),
            status: faker.helpers.arrayElement([
                'pending',
                'cancelled',
                'confirmed',
                'deleted'
            ]),
            tracerId: faker.word.sample(),
            tradeDate: faker.word.sample(),
            transactionBaseType: {},
            transactionType: {
                description: faker.word.sample(),
                label: faker.word.sample()
            },
            transactionTypeCode: faker.word.sample(),
            transferSubAccountId: faker.word.sample(),
            units: faker.word.sample()
        }));
export const getWentworthContributionsGetPendingContributionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingContributionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock = (overrideResponse = {})=>({
        contributedByFlowReportingCategory: {
            correctiveWithdrawals: faker.number.int({
                max: undefined,
                min: undefined
            }),
            employerContributions: faker.number.int({
                max: undefined,
                min: undefined
            }),
            otherContributions: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rolloverContributions: faker.number.int({
                max: undefined,
                min: undefined
            }),
            saverContributions: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        totalContributed: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock200 = (overrideResponse = {})=>({
        contributedByFlowReportingCategory: {
            correctiveWithdrawals: faker.number.int({
                max: undefined,
                min: undefined
            }),
            employerContributions: faker.number.int({
                max: undefined,
                min: undefined
            }),
            otherContributions: faker.number.int({
                max: undefined,
                min: undefined
            }),
            rolloverContributions: faker.number.int({
                max: undefined,
                min: undefined
            }),
            saverContributions: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        totalContributed: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetTotalContributedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            irsLimit: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            }),
            year: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getWentworthContributionsGetYearlyContributionsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            irsLimit: faker.number.int({
                max: undefined,
                min: undefined
            }),
            total: faker.number.int({
                max: undefined,
                min: undefined
            }),
            year: faker.number.int({
                max: undefined,
                min: undefined
            })
        }));
export const getWentworthContributionsGetYearlyContributionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetYearlyContributionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock = (overrideResponse = {})=>({
        confirmedCashBalance: faker.word.sample(),
        pendingCashBalance: faker.word.sample(),
        positions: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                confirmedUnits: faker.word.sample(),
                confirmedValue: faker.word.sample(),
                cusip: faker.word.sample(),
                description: faker.word.sample(),
                expenseRatio: faker.word.sample(),
                pendingUnits: faker.word.sample(),
                pendingValue: faker.word.sample(),
                price: faker.word.sample(),
                symbol: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock200 = (overrideResponse = {})=>({
        confirmedCashBalance: faker.word.sample(),
        pendingCashBalance: faker.word.sample(),
        positions: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                confirmedUnits: faker.word.sample(),
                confirmedValue: faker.word.sample(),
                cusip: faker.word.sample(),
                description: faker.word.sample(),
                expenseRatio: faker.word.sample(),
                pendingUnits: faker.word.sample(),
                pendingValue: faker.word.sample(),
                price: faker.word.sample(),
                symbol: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthInvestmentsGetInvestmentPositionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock = (overrideResponse = {})=>({
        outstandingLoanBalance: faker.word.sample(),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock200 = (overrideResponse = {})=>({
        outstandingLoanBalance: faker.word.sample(),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetLoanBalanceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock = (overrideResponse = {})=>({
        customDateRangeRateOfReturn: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rateOfReturn: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({})),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock200 = (overrideResponse = {})=>({
        customDateRangeRateOfReturn: faker.number.int({
            max: undefined,
            min: undefined
        }),
        rateOfReturn: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({})),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetRateOfReturnResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            flowReportingCategory: faker.helpers.arrayElement([
                'Pre-Tax Rollover',
                'Roth Rollover',
                'Rollover'
            ]),
            id: faker.word.sample(),
            requestedDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            status: faker.word.sample(),
            updatedDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getWentworthContributionsGetCanceledRolloversResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            flowReportingCategory: faker.helpers.arrayElement([
                'Pre-Tax Rollover',
                'Roth Rollover',
                'Rollover'
            ]),
            id: faker.word.sample(),
            requestedDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            status: faker.word.sample(),
            updatedDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getWentworthContributionsGetCanceledRolloversResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetCanceledRolloversResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            flowReportingCategory: faker.helpers.arrayElement([
                'Pre-Tax Rollover',
                'Roth Rollover',
                'Rollover'
            ]),
            id: faker.word.sample(),
            requestedDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            status: faker.word.sample(),
            updatedDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getWentworthContributionsGetPendingRolloversResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            flowReportingCategory: faker.helpers.arrayElement([
                'Pre-Tax Rollover',
                'Roth Rollover',
                'Rollover'
            ]),
            id: faker.word.sample(),
            requestedDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            status: faker.word.sample(),
            updatedDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getWentworthContributionsGetPendingRolloversResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthContributionsGetPendingRolloversResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock = (overrideResponse = {})=>({
        availableTransactionReportingCategories: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        pagination: {
            nextPage: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            page: faker.number.int({
                max: undefined,
                min: undefined
            }),
            pageSize: faker.number.int({
                max: undefined,
                min: undefined
            }),
            previousPage: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        results: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                accountLevel: faker.helpers.arrayElement([
                    'PARENT_ACCOUNT',
                    'SUB_ACCOUNT'
                ]),
                amount: faker.word.sample(),
                byInvestmentReportingCategory: faker.helpers.arrayElement([
                    'Conversions',
                    'Corrective Withdrawals',
                    'Employer Contributions',
                    'Fees',
                    'Forfeitures/Suspense',
                    'Gain/Losses',
                    'Income',
                    'Investment Updates',
                    'Loan Disbursements',
                    'Loan Repayments',
                    'Miscellaneous',
                    'Operational',
                    'Other Contributions',
                    'Other Repayments',
                    'Rollover Contributions',
                    'Saver Contributions',
                    'Withdrawals',
                    'Contribution',
                    'Interest',
                    'Loans',
                    'Other/Misc',
                    'Rollover'
                ]),
                confirmDate: faker.word.sample(),
                contributionYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                controlDate: faker.word.sample(),
                createdAt: faker.word.sample(),
                dividendEligibleDate: faker.word.sample(),
                fee: faker.word.sample(),
                flowReportingCategory: faker.helpers.arrayElement([
                    'Conversions',
                    'Corrective Withdrawals',
                    'Employer Contributions',
                    'Fees',
                    'Forfeitures/Suspense',
                    'Gain/Losses',
                    'Income',
                    'Investment Updates',
                    'Loan Disbursements',
                    'Loan Repayments',
                    'Miscellaneous',
                    'Operational',
                    'Other Contributions',
                    'Other Repayments',
                    'Rollover Contributions',
                    'Saver Contributions',
                    'Withdrawals',
                    'Contribution',
                    'Interest',
                    'Loans',
                    'Other/Misc',
                    'Rollover'
                ]),
                investorId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                orderId: faker.word.sample(),
                reportingAmounts: {
                    byInvestmentReportingAmount: faker.word.sample(),
                    flowReportingAmount: faker.word.sample()
                },
                reversedDate: faker.word.sample(),
                reversedTransactionId: faker.word.sample(),
                reversingTransactionId: faker.word.sample(),
                security: {
                    cusip: faker.word.sample(),
                    description: faker.word.sample(),
                    symbol: faker.word.sample()
                },
                securityOrderType: faker.helpers.arrayElement([
                    'DOLLAR_ORDER',
                    'UNIT_ORDER',
                    'DOLLAR_ALL',
                    'UNIT_ALL'
                ]),
                securityUnitPrice: faker.word.sample(),
                settlementDate: faker.word.sample(),
                sourceTransactionId: faker.word.sample(),
                status: faker.helpers.arrayElement([
                    'CONFIRMED',
                    'REVERSED'
                ]),
                tracerId: faker.word.sample(),
                tradeDate: faker.word.sample(),
                transactionBaseType: faker.helpers.arrayElement([
                    'BUY',
                    'SELL',
                    'DEPOSIT',
                    'WITHDRAWAL',
                    'INCOMEIN',
                    'INCOMEOUT',
                    'TRANSFERIN',
                    'TRANSFEROUT',
                    'FEE',
                    'FEEREVERSAL'
                ]),
                transactionType: {
                    description: faker.word.sample(),
                    label: faker.word.sample()
                },
                transactionTypeCode: faker.word.sample(),
                transferSubAccountId: faker.word.sample(),
                units: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock200 = (overrideResponse = {})=>({
        availableTransactionReportingCategories: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        pagination: {
            nextPage: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            page: faker.number.int({
                max: undefined,
                min: undefined
            }),
            pageSize: faker.number.int({
                max: undefined,
                min: undefined
            }),
            previousPage: faker.helpers.arrayElement([
                faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                undefined
            ]),
            total: faker.number.int({
                max: undefined,
                min: undefined
            })
        },
        results: Array.from({
            length: faker.number.int({
                max: 10,
                min: 1
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                accountLevel: faker.helpers.arrayElement([
                    'PARENT_ACCOUNT',
                    'SUB_ACCOUNT'
                ]),
                amount: faker.word.sample(),
                byInvestmentReportingCategory: faker.helpers.arrayElement([
                    'Conversions',
                    'Corrective Withdrawals',
                    'Employer Contributions',
                    'Fees',
                    'Forfeitures/Suspense',
                    'Gain/Losses',
                    'Income',
                    'Investment Updates',
                    'Loan Disbursements',
                    'Loan Repayments',
                    'Miscellaneous',
                    'Operational',
                    'Other Contributions',
                    'Other Repayments',
                    'Rollover Contributions',
                    'Saver Contributions',
                    'Withdrawals',
                    'Contribution',
                    'Interest',
                    'Loans',
                    'Other/Misc',
                    'Rollover'
                ]),
                confirmDate: faker.word.sample(),
                contributionYear: faker.number.int({
                    max: undefined,
                    min: undefined
                }),
                controlDate: faker.word.sample(),
                createdAt: faker.word.sample(),
                dividendEligibleDate: faker.word.sample(),
                fee: faker.word.sample(),
                flowReportingCategory: faker.helpers.arrayElement([
                    'Conversions',
                    'Corrective Withdrawals',
                    'Employer Contributions',
                    'Fees',
                    'Forfeitures/Suspense',
                    'Gain/Losses',
                    'Income',
                    'Investment Updates',
                    'Loan Disbursements',
                    'Loan Repayments',
                    'Miscellaneous',
                    'Operational',
                    'Other Contributions',
                    'Other Repayments',
                    'Rollover Contributions',
                    'Saver Contributions',
                    'Withdrawals',
                    'Contribution',
                    'Interest',
                    'Loans',
                    'Other/Misc',
                    'Rollover'
                ]),
                investorId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                orderId: faker.word.sample(),
                reportingAmounts: {
                    byInvestmentReportingAmount: faker.word.sample(),
                    flowReportingAmount: faker.word.sample()
                },
                reversedDate: faker.word.sample(),
                reversedTransactionId: faker.word.sample(),
                reversingTransactionId: faker.word.sample(),
                security: {
                    cusip: faker.word.sample(),
                    description: faker.word.sample(),
                    symbol: faker.word.sample()
                },
                securityOrderType: faker.helpers.arrayElement([
                    'DOLLAR_ORDER',
                    'UNIT_ORDER',
                    'DOLLAR_ALL',
                    'UNIT_ALL'
                ]),
                securityUnitPrice: faker.word.sample(),
                settlementDate: faker.word.sample(),
                sourceTransactionId: faker.word.sample(),
                status: faker.helpers.arrayElement([
                    'CONFIRMED',
                    'REVERSED'
                ]),
                tracerId: faker.word.sample(),
                tradeDate: faker.word.sample(),
                transactionBaseType: faker.helpers.arrayElement([
                    'BUY',
                    'SELL',
                    'DEPOSIT',
                    'WITHDRAWAL',
                    'INCOMEIN',
                    'INCOMEOUT',
                    'TRANSFERIN',
                    'TRANSFEROUT',
                    'FEE',
                    'FEEREVERSAL'
                ]),
                transactionType: {
                    description: faker.word.sample(),
                    label: faker.word.sample()
                },
                transactionTypeCode: faker.word.sample(),
                transferSubAccountId: faker.word.sample(),
                units: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetAllTransactionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthTransactionsGetTransactionsReportResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock = (overrideResponse = {})=>({
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        unvestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        vestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock200 = (overrideResponse = {})=>({
        totalBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        unvestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        vestedBalance: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthBalanceGetVestedBalanceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            distributionMethod: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            requestedDate: faker.word.sample(),
            status: faker.helpers.arrayElement([
                'IRA Established',
                'Processing',
                'Canceled',
                'Disbursed',
                'Reversed',
                'Rejected',
                'Pending',
                'Fraud Check Complete'
            ]),
            transactionType: faker.word.sample(),
            updatedDate: faker.word.sample()
        }));
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            max: 10,
            min: 1
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                max: undefined,
                min: undefined
            }),
            distributionMethod: faker.word.sample(),
            id: faker.number.int({
                max: undefined,
                min: undefined
            }),
            requestedDate: faker.word.sample(),
            status: faker.helpers.arrayElement([
                'IRA Established',
                'Processing',
                'Canceled',
                'Disbursed',
                'Reversed',
                'Rejected',
                'Pending',
                'Fraud Check Complete'
            ]),
            transactionType: faker.word.sample(),
            updatedDate: faker.word.sample()
        }));
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getWentworthWithdrawalGetPendingWithdrawalsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            max: undefined,
            min: undefined
        }),
        ...overrideResponse
    });
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/grant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/v2/gusto/oauth/revoke', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getHealthGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetConnectivityResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getHealthGetConnectivityMockHandler200 = (overrideResponse)=>{
    return http.get('*/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetConnectivityResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getHealthGetConnectivityMockHandler503 = (overrideResponse)=>{
    return http.get('*/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetConnectivityResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getHealthPostDemoSDKMockHandler = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getHealthPostDemoSDKMockHandler200 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getHealthPostDemoSDKMockHandler400 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getHealthPostDemoSDKMockHandler401 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getHealthPostDemoSDKMockHandler403 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getHealthPostDemoSDKMockHandler404 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getHealthPostDemoSDKMockHandler405 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getHealthPostDemoSDKMockHandler406 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getHealthPostDemoSDKMockHandler408 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getHealthPostDemoSDKMockHandler409 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getHealthPostDemoSDKMockHandler410 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getHealthPostDemoSDKMockHandler412 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getHealthPostDemoSDKMockHandler413 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getHealthPostDemoSDKMockHandler415 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getHealthPostDemoSDKMockHandler422 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getHealthPostDemoSDKMockHandler500 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getHealthPostDemoSDKMockHandler501 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getHealthPostDemoSDKMockHandler502 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getHealthPostDemoSDKMockHandler503 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getHealthPostDemoSDKMockHandler504 = (overrideResponse)=>{
    return http.post('*/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthPostDemoSDKResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getHealthGetHealthMockHandler = (overrideResponse)=>{
    return http.get('*/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getHealthGetHealthMockHandler200 = (overrideResponse)=>{
    return http.get('*/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler200 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler400 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler401 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler403 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler404 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler405 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler406 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler408 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler409 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler410 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler412 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler413 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler415 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler422 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler500 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler501 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler502 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler503 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingCensusPostValidationMockHandler504 = (overrideResponse)=>{
    return http.post('*/ob/census/validation/:schemaType', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingCensusPostValidationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingHealthGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/ob/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingHealthGetConnectivityMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler200 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler400 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler401 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler403 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler404 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler405 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler406 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler408 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler409 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler410 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler412 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler413 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler415 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler422 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler500 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler501 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler502 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler503 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingContributionPostContributionMockHandler504 = (overrideResponse)=>{
    return http.post('*/ob/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostContributionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler200 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler400 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler401 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler403 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler404 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler405 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler406 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler408 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler409 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler410 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler412 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler413 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler415 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler422 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler500 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler501 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler502 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler503 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingContributionPostIngestionFlowStartMockHandler504 = (overrideResponse)=>{
    return http.post('*/ob/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingContributionPostIngestionFlowStartResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler200 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler400 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler401 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler403 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler404 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler405 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler406 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler408 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler409 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler410 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler412 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler413 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler415 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler422 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler500 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler501 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler502 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler503 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingHealthPostDemoSdkMockHandler504 = (overrideResponse)=>{
    return http.post('*/ob/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthPostDemoSdkResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocumentGetSigningMappingsMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/document/signing-mappings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocumentGetSigningMappingsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignGetAuthenticateMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/docusign/auth', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAuthenticateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignGetDocusignConnectivityMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/docusign/connectivity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignConnectivityResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelope-ingestion-wsdl', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetDocusignEnvelopeWsdlResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignGetEnvelopesMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignGetEnvelopeMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignGetEnvelopeRecipientsMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/docusign/envelopes/:envelopeId/signers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetEnvelopeRecipientsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler200 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler400 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler401 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler403 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler404 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler405 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler406 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler408 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler409 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler410 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler412 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler413 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler415 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler422 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler500 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler501 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler502 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler503 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignPostEnvelopeRecipientMockHandler504 = (overrideResponse)=>{
    return http.post('*/ob/docusign/envelopes/:envelopeId/views/recipient', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostEnvelopeRecipientResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignGetRedirectMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/docusign/redirect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetRedirectResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignGetAccessTokenMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/docusign/token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetAccessTokenResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler200 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler400 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler401 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler403 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler404 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler405 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler406 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler408 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler409 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler410 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler412 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler413 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler415 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler422 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler500 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler501 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler502 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler503 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler504 = (overrideResponse)=>{
    return http.post('*/ob/docusign/trigger-envelope-ingestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignPostTriggerDocusignEnvelopeResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingDocusignGetUserInfoMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/docusign/user-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingDocusignGetUserInfoResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingHealthGetHealthMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingHealthGetHealthResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/multiple', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetMultiplePizzaTrackersResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingPizzaTrackerGetPizzaTrackerMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/pizza-tracker/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingPizzaTrackerGetPizzaTrackerResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler200 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler400 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler401 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler403 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler404 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler405 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler406 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler408 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler409 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler410 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler412 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler413 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler415 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler422 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler500 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler501 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler502 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler503 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingRecordkeepingPostToCustodianMockHandler504 = (overrideResponse)=>{
    return http.post('*/ob/recordkeeping/ship-to-custodian', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingRecordkeepingPostToCustodianResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler201 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler400 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler401 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler403 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler404 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler405 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler406 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler408 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler409 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler410 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler412 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler413 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler415 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler422 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler500 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler501 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler502 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler503 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingSalesforcePostLaunchDocusignFlowMockHandler504 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/flow/launch', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLaunchDocusignFlowResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler201 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler400 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler401 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler403 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler404 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler405 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler406 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler408 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler409 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler410 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler412 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler413 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler415 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler422 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler500 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler501 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler502 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler503 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingSalesforcePostLogoutMockHandler504 = (overrideResponse)=>{
    return http.post('*/ob/salesforce/logout', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforcePostLogoutResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler200 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler400 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler401 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler403 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler404 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler405 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler406 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler408 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler409 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler410 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler412 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler413 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler415 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler422 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler500 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler501 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler502 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler503 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getOnboardingSalesforceGetRecordMockHandler504 = (overrideResponse)=>{
    return http.get('*/ob/salesforce/record/:objectName/:id', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getOnboardingSalesforceGetRecordResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 202
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler202 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 202
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler400 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler401 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler403 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler404 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler405 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler406 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler408 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler409 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler410 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler412 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler413 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler415 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler422 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler500 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler501 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler502 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler503 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPayrollIntegrationsPostGustoWebhookEventMockHandler504 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/gusto/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostGustoWebhookEventResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 202
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler202 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 202
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler400 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler401 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler403 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler404 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler405 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler406 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler408 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler409 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler410 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler412 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler413 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler415 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler422 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler500 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler501 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler502 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler503 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPayrollIntegrationsPostVestwellWebhookEventMockHandler504 = (overrideResponse)=>{
    return http.post('*/payrollIntegrations/vestwell/events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPayrollIntegrationsPostVestwellWebhookEventResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAdvisorByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/commercial-platforms', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorCommercialPlatformsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAdvisorContactCardMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorContactCardResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutAdvisorContactCardMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/advisor/contact-card', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAdvisorContactCardResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlansMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/annual-testing/:year', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlansTrackerMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlansTrackerResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanEmployeesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeeMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeeResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorPlanStatisticsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostLinkSponsorMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/advisor/sponsors/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLinkSponsorResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAdvisorStatsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/advisor/statistics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorStatsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetCarouselMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/carousel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCarouselResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetConnectivityMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetCsmMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/csm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCsmResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutLoginDisclosureMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/disclosure/login', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutLoginDisclosureResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetLoginDisclosureAgreementMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/disclosure/login/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoginDisclosureAgreementResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDocumentByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchDeleteDocumentByIdMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/document', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteDocumentByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAllDocumentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllDocumentsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDocumentAgreementMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAgreementResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostDocumentAgreementMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/agreement', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDocumentAgreementResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDocumentDownloadByKeyMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/download-by-key', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentDownloadByKeyResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/documents/html/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDocumentAsHtmlAndDownloadResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPdfMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPdfResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostProcessDocumentMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/process', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostProcessDocumentResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostUploadDocumentMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/documents/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadDocumentResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostEmailMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/email', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostEmailPreviewRenderMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/email/preview/render', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEmailPreviewRenderResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmailPreviewByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/email/previews', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmailPreviewByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeeHoldingsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/holdings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeHoldingsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoansMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoansResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeePerformanceMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/performance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePerformanceResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeePendingTransactionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeePendingTransactionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeTransactionsYearsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetProgramModelSecuritiesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employee/:employeeId/model-securities/:type', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelSecuritiesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeesWithContributionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesWithContributionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeeLoanDetailsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/loans/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeLoanDetailsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/employees/transactions/years', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesTransactionsYearsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchEsaParticipantGoalMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/participant/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaParticipantGoalResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantGoalsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/goals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantGoalsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEsaParticipantIncentivesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/participant/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaParticipantIncentivesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/cash-interest-rate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanCashInterestRateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupStatsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/group-stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupStatsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEsaPlanGroupsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/groups', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanGroupsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEsaPlanIncentivesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/esa/plan/incentives', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaPlanIncentivesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchEsaWithdrawalMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/esa/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchEsaWithdrawalResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetFi360DownloadMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/fact-sheets', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFi360DownloadResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetFeatureTogglesListMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/feature-toggle/list', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFeatureTogglesListResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetFirmByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/firm/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetFirmByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecurringMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecurringResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler200 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler400 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler401 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler403 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler404 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler405 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler406 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler408 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler409 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler410 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler412 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler413 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler415 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler422 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler500 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler501 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler502 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler503 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareDeleteGiftContributorRecurringMockHandler504 = (overrideResponse)=>{
    return http.delete('*/pm/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteGiftContributorRecurringResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGiftContributorBanksMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-banks', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorBanksResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGiftContributorPaymentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/gift-payments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorPaymentsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGiftContributorRecipientsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/contributor/:giftContributorId/recipients', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftContributorRecipientsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift-account/:giftingId/:giftContributorId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageAndAccountByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGiftingPageByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/gifting/gift/:planId/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGiftingPageByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostCreateGiftorProfileMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateGiftorProfileResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutValidateGiftorProfileMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/profile', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftorProfileResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostGiftSubmissionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGiftSubmissionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutValidateGiftSubmissionMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/gifting/:giftingId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutValidateGiftSubmissionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetHealthMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHealthResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetLoanAmortizationPdfMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/loans/amortization/pdf', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetLoanAmortizationPdfResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidTokenResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.delete('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteManagedAccountsPlaidLinksResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetManagedAccountsPlaidLinksResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidLinksResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostManagedAccountsPlaidBalancesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/midYearTesting/censusRecord/grid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMidYearTestingCensusRecordGridResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/midYearTesting/censusRecord/test', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMidYearTestingCensusRecordRunTestResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/401k-manager-questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsActivateMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/activate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsActivateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/deactivate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsDeactivateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMsManagedAccountsPreviewAllocationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/ms-managed-accounts/preview-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMsManagedAccountsPreviewAllocationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDigitalOnboardingStateMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDigitalOnboardingStateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchDigitalOnboardingStateMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDigitalOnboardingStateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutDigitalOnboardingStateMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/onboarding/digital', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutDigitalOnboardingStateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/onboarding/stateful-schema-tracking/:schemaType/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchStatefulSchemaTrackingStatusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountBalanceByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostParticipantLoanMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantLoanResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinkTokenResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantPlaidLinksResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantLoanCreateMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/account/loans/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantLoanCreateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchParticipantLoanMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/account/loans/:loanId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantLoanResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostLoanManualRepaymentMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/account/loans/:loanId/payment', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLoanManualRepaymentResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantAccountsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAccountsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBalanceOverTimeResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutArchiveBankAccountMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/bank-account/:bankAccountId/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutArchiveBankAccountResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantBankAccountsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/bank-accounts', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBankAccountsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantDepositsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantDepositsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostDepositDataMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/deposit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostDepositDataResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRecurringSchedulesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutRecurringScheduleMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/deposit/schedule/:recurringScheduleId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRecurringScheduleResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDepositMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/deposit/:depositId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDepositResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetRecentParticipantDocumentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/documents/recent', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRecentParticipantDocumentsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostParticipantEligibilityMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantEligibilityResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostEsaGoalMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/esa/goal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostEsaGoalResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantIdentityVerificationMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantIdentityVerificationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantInfoWithEmailsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGoalFeedbackMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGoalFeedbackResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostElectionAgeSuggestionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/age-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionAgeSuggestionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/retirement-income-suggestion', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionRetirementIncomeSuggestionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetElectionsSetupMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetElectionsSetupResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostElectionsSetupMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investment-election/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostElectionsSetupResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetInvestmentsModelDisplayMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/model', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInvestmentsModelDisplayResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantStatsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/options/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantStatsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostRebalanceRequestPreviewMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/investments/rebalance-request/preview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRebalanceRequestPreviewResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetRebalanceSettingsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRebalanceSettingsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutRebalanceSettingsMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/rebalance-settings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRebalanceSettingsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetStrategiesIndexMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetStrategiesIndexResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAgeBasedMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAgeBasedResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutAgeBasedMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/age-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutAgeBasedResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutCustomAllocationMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/custom-allocation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutCustomAllocationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetRiskBasedMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskBasedResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutRiskBasedMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/investments/strategies/risk-based', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutRiskBasedResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetRiskModelQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRiskModelQuestionnaireResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetMailPreferencesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetMailPreferencesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutMailPreferencesMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/mail-preferences', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutMailPreferencesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantOnboardingMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOnboardingResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantOverviewMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/overview', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOverviewResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBalanceResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantPlaidLinksBankAccountResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/plaid-links/discard-pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPositionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPositionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetQboadWithdrawalsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/qboad/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQboadWithdrawalsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchParticipantRolloverMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/rollovers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantRolloverResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetRolloverInstructionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/instructions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverInstructionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetRolloverEligibilityMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverEligibilityResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostParticipantRolloverMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/rollovers/request', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantRolloverResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantRolloverMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantRolloverResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGenerateRolloverLetterMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/rollovers/:rolloverId/letter', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGenerateRolloverLetterResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSavingsDisplayMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSavingsDisplayResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutSavingsMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/participant/savings', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSavingsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSurveyLinkMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/survey/link', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSurveyLinkResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/transactions/aggregated-by-category', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllowedWithdrawalReasonsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostWithdrawalMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participant/withdrawals', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/participant/:participantId/override-eligibility', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchOverrideParticipantEligibilityResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEligibleAutoEnrolledParticipantsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out-confirmation/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantOptOutEmailDownloadResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/opt-out/enrolled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/unregistered/count', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsCountResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/welcome-emails/bulk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsWelcomeEmailsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailDownloadResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/welcome-emails/history', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantWelcomeEmailsHistoryResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEsaEmployerContributionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/participants/:participantId/calculate-employer-match', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCalculatedEmployerMatchContributionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/participants/:planId/opt-out', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostParticipantsAutoEnrollOptOutResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanDesignMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchUpdatePlanDesignMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/plan-design', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchUpdatePlanDesignResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanDesignTilesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/plan-design/tiles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignTilesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanParticipantsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/plan/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanParticipantsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanModelMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchPlanMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEsaProgramMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEsaProgramResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanInvestmentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/investments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanInvestmentsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanModelSecuritiesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/plans/:planId/models/:modelId/securities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanModelSecuritiesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetProgramModelsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/program/models', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramModelsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/program/:programId/investment-options/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProgramInvestmentOptionsExportResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetProspectusUrlPartsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/prospectus/url', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetProspectusUrlPartsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAdvisorReportMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/advisors/:advisorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAdvisorReportResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeeReportMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/employees/:employeeId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeReportResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/participants/unregistered', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnregisteredParticipantsReportResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanReportMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/plans/:planId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanReportResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSponsorReportMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/sponsors/:sponsorId/:reportType/:fileName', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorReportResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsReportMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/reports/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsReportResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/safe-harbor-contribution-types', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAllSafeHarborContributionTypesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSubaExternalMarketValueMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/external-market-value', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaExternalMarketValueResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sdba/initiate-external-transfer', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSubaInitiateExternalTransferResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSdbaSetupMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaSetupResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSdbaTransfersInfoMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSdbaTransfersInfoResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sdba/transfers-in-progress', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCheckActiveSdbaTransfersResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSessionMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSessionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSponsorAbilitiesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/abilities', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorAbilitiesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/auto-enroll', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetAutoEnrollSponsorPlanResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetCensusParticipantsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/census/participants', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusParticipantsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetBankAccountMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetBankAccountResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostBankAccountMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBankAccountResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutBankAccountMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutBankAccountResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/archive', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorArchiveBankAccountResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutFeePaymentMethodMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/company/bank-account/fee-payment-method', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutFeePaymentMethodResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchSponsorMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/company-info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSponsorTeammatesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorTeammatesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchDeleteTeammateMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeleteTeammateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostSendUserInviteMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/company/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendUserInviteResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler200 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler400 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler401 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler403 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler404 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler405 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler406 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler408 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler409 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler410 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler412 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler413 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler415 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler422 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler500 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler501 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler502 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler503 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerV2MockHandler504 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler200 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler400 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler401 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler403 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler404 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler405 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler406 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler408 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler409 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler410 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler412 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler413 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler415 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler422 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler500 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler501 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler502 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler503 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler504 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/compliance/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostFileHeadersUpdateMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contribution/headers/mapping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFileHeadersUpdateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsLandingPageDisplayResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostContributionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostCancelSubmissionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancelSubmissionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostCancellationSubmissionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/cancellation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCancellationSubmissionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantsLoansMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/loans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantsLoansResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostMatchRemediationContributionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/match-remediation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostMatchRemediationContributionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostOffCycleContributionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/offcycle', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOffCycleContributionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostResumeSubmissionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/resume', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostResumeSubmissionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowValidationMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowValidationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostContributionValidationMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionValidationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionSubmissionDisplayMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionSubmissionDisplayResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionAdjustmentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/adjustments', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionAdjustmentsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostContributionConfirmationMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/confirm', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionConfirmationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionConfirmationDisplayMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/confirmation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionConfirmationDisplayResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostContributionCorrectionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/correction', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionCorrectionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionCorrectionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/corrections', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionCorrectionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionDetailsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDetailsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionDisplayMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/display', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionDisplayResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostContributionUploadMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionUploadResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionFileMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/file', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionFileResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetForfeitureMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeitureResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostForfeitureMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/forfeiture', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostForfeitureResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionHeaderValidationsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/headers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionHeaderValidationsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetNormalizedContributionDataMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/normalized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNormalizedContributionDataResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostIngestionFlowStartMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/contributions/:ucid/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostIngestionFlowStartResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDownloadContributionTemplateMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/template.xlsx', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDownloadContributionTemplateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetUnallocatedFundsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/unallocated-funds', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUnallocatedFundsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionValidationPageDisplayMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationPageDisplayResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionValidationMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/contributions/:ucid/validation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionValidationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetDeferralChangesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetDeferralChangesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/deferral/changes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchDeferralChangesActivitiesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutParticipantMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employee', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeeClassesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employee-classes', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeClassesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutParticipantsMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostUploadCensusOriginalMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusOriginalResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/v2/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostValidateEmployeeMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostValidateEmployeeResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEmployeeDetailsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/employees/:employeeId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEmployeeDetailsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostContactInfoMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/employees/:employeeId/address', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContactInfoResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutParticipantContributionsMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/employees/:employeeId/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantContributionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSponsorEntityMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/entity', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEntityResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetForfeiturePreferenceMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetForfeiturePreferenceResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutForfeiturePreferenceMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/forfeiture-preference', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutForfeiturePreferenceResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetHeapDataMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/heap', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetHeapDataResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetOnboardingMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetOnboardingResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostOnboardingMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostOnboardingResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutOnboardingMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutOnboardingResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingInformationMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingInformationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutSponsorOnboardingInformationMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/onboarding-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSponsorOnboardingInformationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostUploadCensusMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadCensusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/add-employees/original', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostUploadOnboardingCensusOriginalResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetInitialCensusMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetInitialCensusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler200 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler400 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler401 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler403 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler404 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler405 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler406 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler408 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler409 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler410 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler412 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler413 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler415 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler422 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler500 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler501 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler502 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler503 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareDeleteCensusCacheMockHandler504 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeleteCensusCacheResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetCensusCacheMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusCacheResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostCensusCacheMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/census-cache', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCensusCacheResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSponsorEsaProgramMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/esa-program', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorEsaProgramResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostFinishOnboardingMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/finish', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostFinishOnboardingResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorOnboardingTeammatesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostSendOnboardingUserInviteMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/manage-teammate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSendOnboardingUserInviteResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetNextPayrollDatesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetNextPayrollDatesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPayrollProvidersMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/payroll-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollProvidersResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plaid-link-token', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorPlaidLinkTokenResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/onboarding/plaid-links', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostGetSponsorPlaidLinksResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanDesignConsultStateMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanDesignConsultStateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchPlanDesignConsultStateMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/onboarding/plan-design-consult-state', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchPlanDesignConsultStateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanLaunchCallUrlMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/plan-launch-call', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanLaunchCallUrlResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetUserRolesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/onboarding/user-roles', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetUserRolesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/connection-status/v2', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollConnectionStatusV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPayrollDatesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollDatesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPayrollInfoMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollInfoResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPayrollSetupsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollSetupsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostBulkPayrollSetupDisconnectionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPayrollFundingSetupsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/payroll/setup/funding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPayrollFundingSetupsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPayrollProviderMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollProviderResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPayrollSkipStatusMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skip', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSkipStatusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutSkipSubmissionMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/skipping', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutSkipSubmissionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler200 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler400 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler401 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler403 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler404 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler405 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler406 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler408 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler409 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler410 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler412 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler413 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler415 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler422 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler500 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler501 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler502 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler503 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareDeletePayrollSetupMockHandler504 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/payroll/setup/:payrollSetupId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePayrollSetupResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPayrollDatesMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/dates', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollDatesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollSetupDisconnectionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPayrollSetupInfoMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/payroll/setup/:payrollSetupId/info', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPayrollSetupInfoResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPayrollValidationsMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/payroll/validate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPayrollValidationsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanFeaturesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan-features', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanFeaturesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanOnboardingStatusMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plan/onboarding/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOnboardingStatusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/plan/:planId/disconnect', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostSponsorPlanDisconnectionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanStatisticsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/plans/:planId/stats', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanStatisticsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanConfigurationMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanConfigurationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanConfigurationMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/configuration', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanConfigurationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanEmployeesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/employees', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanEmployeesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanGrossCompensationMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanGrossCompensationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/gross-compensation', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeGrossCompensationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetGrossCompensationTemplateMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/gross-compensation/download/template', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetGrossCompensationTemplateResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/gross-compensation/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/non-employee-owner', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanNonEmployeeOwnerResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanOfficersMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOfficersResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanOfficerStatusMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/officers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOfficerStatusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler200 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler400 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler401 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler403 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler404 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler405 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler406 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler408 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler409 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler410 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler412 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler413 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler415 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler422 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler500 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler501 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler502 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler503 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnerMockHandler504 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnerResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPlanEmployeeOwnerMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPlanEmployeeOwnerResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanEmployeeOwnerMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanEmployeeOwnerResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler200 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler400 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler401 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler403 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler404 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler405 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler406 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler408 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler409 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler410 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler412 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler413 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler415 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler422 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler500 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler501 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler502 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler503 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareDeletePlanOwnersFamilyMockHandler504 = (overrideResponse)=>{
    return http.delete('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareDeletePlanOwnersFamilyResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanOwnersFamilyMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanOwnersFamilyResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutPlanOwnersFamilyMockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/sponsor/pocet/owners-family', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutPlanOwnersFamilyResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetTrackerDetailsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/pocet/tracker', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTrackerDetailsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler201 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 201
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostPriorProviderMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/prior-provider', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostPriorProviderResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPriorProvidersMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/prior-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPriorProvidersResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSponsorQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSponsorQuestionnaireResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchSponsorQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchSponsorQuestionnaireResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetQuestionnaireInformationMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/questionnaire-information', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetQuestionnaireInformationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetContributionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/sponsor-plan/contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetContributionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSubaPlanDetailsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-plan-details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaPlanDetailsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetSubaTransactionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/suba-transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetSubaTransactionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostYetCensusAutosaveMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/autosave', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusAutosaveResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataDownloadMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/download', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataDownloadResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetYetCensusDataPagedMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/paged', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetCensusDataPagedResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostRefreshCensusMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/refresh', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRefreshCensusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostRestartCensusMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartCensusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostYetCensusStartMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusStartResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetCensusStatusMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/census/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetCensusStatusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostYetCensusSubmitMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/submit', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusSubmitResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostYetCensusUploadMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/census/upload', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetCensusUploadResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetYetChecklistMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetChecklistResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchYetChecklistMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/sponsor/yet/checklist', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchYetChecklistResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetYetConfigMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/config', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetConfigResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostContributionsFundMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/fund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsFundResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostContributionsRefundMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/contributions/refund', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostContributionsRefundResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetYetDocumentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/documents', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetDocumentsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostStartOfPackagingMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/packaging/start', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostStartOfPackagingResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanTestResultsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/plan-test-results', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanTestResultsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetSponsorQuestionnaireResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/questionnaire', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostYetSponsorQuestionnaireResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostRestartTestingProcessMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/sponsor/yet/restart', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostRestartTestingProcessResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetYetStatusMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/yet/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetStatusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetYtdContributionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/sponsor/ytd-contributions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYtdContributionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetTiaaIncomeProjectionMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/tiaa/income-projection', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetTiaaIncomeProjectionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler200 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler400 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler401 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler403 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler404 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler405 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler406 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler408 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler409 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler410 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler412 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler413 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler415 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler422 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler500 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler501 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler502 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler503 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePatchParticipantByIdMockHandler504 = (overrideResponse)=>{
    return http.patch('*/pm/api/v2/participant', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePatchParticipantByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantBeneficiariesMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantBeneficiariesResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler200 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/pm/api/v2/participant/beneficiaries', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePutParticipantBeneficiariesV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetPlanByIdV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/v2/plans', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetPlanByIdV2ResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetVestingScheduleMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/vesting/schedule', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVestingScheduleResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetVssPlanByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/plans/:planId', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssPlanByIdResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetVssStatusMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/vss/status', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetVssStatusResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostLobLetterEventsWebhookMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/webhooks/lob/letter-events', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostLobLetterEventsWebhookResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/whitelabel/unauthorized', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWhiteLabelUnauthorizedResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostCreateWithdrawalMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostCreateWithdrawalResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetParticipantCostBasisMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/cost-basis', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetParticipantCostBasisResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler200 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler400 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler401 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler403 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler404 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler405 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler406 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler408 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler409 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler410 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler412 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler413 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler415 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler422 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler500 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler501 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler502 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler503 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler504 = (overrideResponse)=>{
    return http.post('*/pm/api/withdrawal/identity-verification', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewarePostWithdrawalIdentityVerificationResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetRmdAmountMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-amount', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdAmountResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetRmdBalanceMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rmd-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRmdBalanceResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetRolloverProvidersMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/rollover-providers', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetRolloverProvidersResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetWithholdingMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetWithholdingDetailMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/withdrawal/withholding/total-estimate', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetWithholdingDetailResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetYetNaicsMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/yet/naics', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetYetNaicsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetZendeskJwtMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/zendesk/jwt', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetZendeskJwtResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler200 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler400 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler401 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler403 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler404 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler405 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler406 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler408 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler409 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler410 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler412 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler413 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler415 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler422 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler500 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler501 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler502 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler503 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getPortalMiddlewareGetEntitySessionMockHandler504 = (overrideResponse)=>{
    return http.get('*/pm/api/:entity/session', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getPortalMiddlewareGetEntitySessionResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getHealthGetPublicRouteMockHandler = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getHealthGetPublicRouteMockHandler200 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getHealthGetPublicRouteMockHandler400 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getHealthGetPublicRouteMockHandler401 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getHealthGetPublicRouteMockHandler403 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getHealthGetPublicRouteMockHandler404 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getHealthGetPublicRouteMockHandler405 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getHealthGetPublicRouteMockHandler406 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getHealthGetPublicRouteMockHandler408 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getHealthGetPublicRouteMockHandler409 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getHealthGetPublicRouteMockHandler410 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getHealthGetPublicRouteMockHandler412 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getHealthGetPublicRouteMockHandler413 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getHealthGetPublicRouteMockHandler415 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getHealthGetPublicRouteMockHandler422 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getHealthGetPublicRouteMockHandler500 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getHealthGetPublicRouteMockHandler501 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getHealthGetPublicRouteMockHandler502 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getHealthGetPublicRouteMockHandler503 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getHealthGetPublicRouteMockHandler504 = (overrideResponse)=>{
    return http.get('*/public', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getHealthGetPublicRouteResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthHealthGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/wt/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getWentworthHealthGetConnectivityMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/connectivity', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler200 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler400 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler401 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler403 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler404 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler405 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler406 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler408 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler409 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler410 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler412 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler413 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler415 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler422 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler500 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler501 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler502 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler503 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthHealthPostDemoSdkMockHandler504 = (overrideResponse)=>{
    return http.post('*/wt/demo-sdk', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthPostDemoSdkResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthHealthGetHealthMockHandler = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getWentworthHealthGetHealthMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getWentworthHealthGetHealthMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthHealthGetHealthMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthHealthGetHealthMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthHealthGetHealthMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthHealthGetHealthMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthHealthGetHealthMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthHealthGetHealthMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthHealthGetHealthMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthHealthGetHealthMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthHealthGetHealthMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthHealthGetHealthMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthHealthGetHealthMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthHealthGetHealthMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthHealthGetHealthMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthHealthGetHealthMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthHealthGetHealthMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthHealthGetHealthMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthHealthGetHealthMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/health', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthHealthGetHealthResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthBalanceGetActivitySummaryMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/activity-summary', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetActivitySummaryResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthBalanceGetCurrentBalanceMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetCurrentBalanceResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthBalanceGetBalanceOverTimeMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/balance-over-time', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalanceOverTimeResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthBalanceGetBalancesGroupedBySourceMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/balances/by-source', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetBalancesGroupedBySourceResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthContributionsGetCompletedContributionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/completed', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCompletedContributionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthContributionsGetContributionDetailsMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/details', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetContributionDetailsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthContributionsGetPendingContributionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingContributionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthContributionsGetTotalContributedMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/total', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetTotalContributedResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthContributionsGetYearlyContributionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/contributions/yearly', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetYearlyContributionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthInvestmentsGetInvestmentPositionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/investments/positions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthInvestmentsGetInvestmentPositionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthBalanceGetLoanBalanceMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/loan-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetLoanBalanceResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthBalanceGetRateOfReturnMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/rate-of-return', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetRateOfReturnResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthContributionsGetCanceledRolloversMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/canceled', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetCanceledRolloversResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthContributionsGetPendingRolloversMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/rollovers/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthContributionsGetPendingRolloversResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthTransactionsGetAllTransactionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetAllTransactionsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        if (typeof overrideResponse === 'function') {
            await overrideResponse(info);
        }
        return new HttpResponse(null, {
            status: 200
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthTransactionsGetTransactionsReportMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/transactions/report', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthTransactionsGetTransactionsReportResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthBalanceGetVestedBalanceMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/vested-balance', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthBalanceGetVestedBalanceResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler200 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock200()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 200
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler400 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock400()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 400
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler401 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock401()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 401
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler403 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock403()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 403
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler404 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock404()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 404
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler405 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock405()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 405
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler406 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock406()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 406
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler408 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock408()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 408
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler409 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock409()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 409
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler410 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock410()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 410
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler412 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock412()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 412
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler413 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock413()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 413
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler415 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock415()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 415
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler422 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock422()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 422
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler500 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock500()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 500
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler501 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock501()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 501
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler502 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock502()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 502
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler503 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock503()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 503
        });
    });
};
export const getWentworthWithdrawalGetPendingWithdrawalsMockHandler504 = (overrideResponse)=>{
    return http.get('*/wt/participant/withdrawals/pending', async (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === 'function' ? await overrideResponse(info) : overrideResponse : getWentworthWithdrawalGetPendingWithdrawalsResponseMock504()), {
            headers: {
                'Content-Type': 'application/json'
            },
            status: 504
        });
    });
};
export const getVestwellUnifiedApiHooksMock = ()=>[
        getPayrollIntegrationsPostProviderAuthorizationFromCompanyIdMockHandler(),
        getPayrollIntegrationsDeleteProviderAuthorizationFromCompanyIdMockHandler(),
        getHealthGetConnectivityMockHandler(),
        getHealthPostDemoSDKMockHandler(),
        getHealthGetHealthMockHandler(),
        getOnboardingCensusPostValidationMockHandler(),
        getOnboardingHealthGetConnectivityMockHandler(),
        getOnboardingContributionPostContributionMockHandler(),
        getOnboardingContributionPostIngestionFlowStartMockHandler(),
        getOnboardingHealthPostDemoSdkMockHandler(),
        getOnboardingDocumentGetSigningMappingsMockHandler(),
        getOnboardingDocusignGetAuthenticateMockHandler(),
        getOnboardingDocusignGetDocusignConnectivityMockHandler(),
        getOnboardingDocusignGetDocusignEnvelopeWsdlMockHandler(),
        getOnboardingDocusignGetEnvelopesMockHandler(),
        getOnboardingDocusignGetEnvelopeMockHandler(),
        getOnboardingDocusignGetEnvelopeRecipientsMockHandler(),
        getOnboardingDocusignPostEnvelopeRecipientMockHandler(),
        getOnboardingDocusignGetRedirectMockHandler(),
        getOnboardingDocusignGetAccessTokenMockHandler(),
        getOnboardingDocusignPostTriggerDocusignEnvelopeMockHandler(),
        getOnboardingDocusignGetUserInfoMockHandler(),
        getOnboardingHealthGetHealthMockHandler(),
        getOnboardingPizzaTrackerGetMultiplePizzaTrackersMockHandler(),
        getOnboardingPizzaTrackerGetPizzaTrackerMockHandler(),
        getOnboardingRecordkeepingPostToCustodianMockHandler(),
        getOnboardingSalesforcePostLaunchDocusignFlowMockHandler(),
        getOnboardingSalesforcePostLogoutMockHandler(),
        getOnboardingSalesforceGetRecordMockHandler(),
        getPayrollIntegrationsPostGustoWebhookEventMockHandler(),
        getPayrollIntegrationsPostVestwellWebhookEventMockHandler(),
        getPortalMiddlewareGetAdvisorByIdMockHandler(),
        getPortalMiddlewareGetAdvisorCommercialPlatformsMockHandler(),
        getPortalMiddlewareGetAdvisorContactCardMockHandler(),
        getPortalMiddlewarePutAdvisorContactCardMockHandler(),
        getPortalMiddlewareGetPlansMockHandler(),
        getPortalMiddlewareGetAdvisorAnnualTestingPlansPerYearMockHandler(),
        getPortalMiddlewareGetPlansTrackerMockHandler(),
        getPortalMiddlewareGetAdvisorPlanEmployeesMockHandler(),
        getPortalMiddlewareGetPlanEmployeeMockHandler(),
        getPortalMiddlewareGetAdvisorPlanStatisticsMockHandler(),
        getPortalMiddlewarePostLinkSponsorMockHandler(),
        getPortalMiddlewareGetAdvisorStatsMockHandler(),
        getPortalMiddlewareGetCarouselMockHandler(),
        getPortalMiddlewareGetConnectivityMockHandler(),
        getPortalMiddlewareGetCsmMockHandler(),
        getPortalMiddlewareGetLoginDisclosureMockHandler(),
        getPortalMiddlewarePutLoginDisclosureMockHandler(),
        getPortalMiddlewareGetLoginDisclosureAgreementMockHandler(),
        getPortalMiddlewareGetDocumentByIdMockHandler(),
        getPortalMiddlewarePatchDeleteDocumentByIdMockHandler(),
        getPortalMiddlewareGetAllDocumentsMockHandler(),
        getPortalMiddlewareGetDocumentAgreementMockHandler(),
        getPortalMiddlewarePostDocumentAgreementMockHandler(),
        getPortalMiddlewareGetDocumentDownloadByIdMockHandler(),
        getPortalMiddlewareGetDocumentDownloadByKeyMockHandler(),
        getPortalMiddlewareGetDocumentAsHtmlMockHandler(),
        getPortalMiddlewareGetDocumentAsHtmlAndDownloadMockHandler(),
        getPortalMiddlewarePostPdfMockHandler(),
        getPortalMiddlewarePostProcessDocumentMockHandler(),
        getPortalMiddlewarePostUploadDocumentMockHandler(),
        getPortalMiddlewarePostEmailMockHandler(),
        getPortalMiddlewarePostEmailPreviewRenderMockHandler(),
        getPortalMiddlewareGetEmailPreviewByIdMockHandler(),
        getPortalMiddlewareGetEmployeeHoldingsMockHandler(),
        getPortalMiddlewareGetEmployeeLoansMockHandler(),
        getPortalMiddlewareGetEmployeePerformanceMockHandler(),
        getPortalMiddlewareGetEmployeeTransactionsMockHandler(),
        getPortalMiddlewareGetEmployeePendingTransactionsMockHandler(),
        getPortalMiddlewareGetEmployeeTransactionsYearsMockHandler(),
        getPortalMiddlewareGetProgramModelSecuritiesMockHandler(),
        getPortalMiddlewareGetEmployeesWithContributionsMockHandler(),
        getPortalMiddlewareGetEmployeeLoanDetailsMockHandler(),
        getPortalMiddlewareGetEmployeesTransactionsYearsMockHandler(),
        getPortalMiddlewarePatchEsaParticipantGoalMockHandler(),
        getPortalMiddlewareGetEsaParticipantGoalsMockHandler(),
        getPortalMiddlewareGetEsaParticipantIncentivesMockHandler(),
        getPortalMiddlewareGetEsaPlanCashInterestRateMockHandler(),
        getPortalMiddlewareGetEsaPlanGroupBalanceOverTimeMockHandler(),
        getPortalMiddlewareGetEsaPlanGroupStatsMockHandler(),
        getPortalMiddlewareGetEsaPlanGroupsMockHandler(),
        getPortalMiddlewareGetEsaPlanIncentivesMockHandler(),
        getPortalMiddlewarePatchEsaWithdrawalMockHandler(),
        getPortalMiddlewareGetFi360DownloadMockHandler(),
        getPortalMiddlewareGetFeatureTogglesMockHandler(),
        getPortalMiddlewareGetFeatureTogglesListMockHandler(),
        getPortalMiddlewareGetFirmByIdMockHandler(),
        getPortalMiddlewareGetGiftContributorRecurringMockHandler(),
        getPortalMiddlewareDeleteGiftContributorRecurringMockHandler(),
        getPortalMiddlewareGetGiftContributorBanksMockHandler(),
        getPortalMiddlewareGetGiftContributorPaymentsMockHandler(),
        getPortalMiddlewareGetGiftContributorRecipientsMockHandler(),
        getPortalMiddlewareGetGiftingPageAndAccountByIdMockHandler(),
        getPortalMiddlewareGetGiftingPageByIdMockHandler(),
        getPortalMiddlewarePostCreateGiftorProfileMockHandler(),
        getPortalMiddlewarePutValidateGiftorProfileMockHandler(),
        getPortalMiddlewarePostGiftSubmissionMockHandler(),
        getPortalMiddlewarePutValidateGiftSubmissionMockHandler(),
        getPortalMiddlewareGetHealthMockHandler(),
        getPortalMiddlewareGetLoanAmortizationPdfMockHandler(),
        getPortalMiddlewareGetManagedAccountsPlaidTokenMockHandler(),
        getPortalMiddlewareDeleteManagedAccountsPlaidLinksMockHandler(),
        getPortalMiddlewareGetManagedAccountsPlaidLinksMockHandler(),
        getPortalMiddlewarePostManagedAccountsPlaidLinksMockHandler(),
        getPortalMiddlewarePostManagedAccountsPlaidBalancesMockHandler(),
        getPortalMiddlewareGetMidYearTestingMockHandler(),
        getPortalMiddlewareGetMidYearTestingCensusRecordMockHandler(),
        getPortalMiddlewareGetMidYearTestingCensusRecordGridMockHandler(),
        getPortalMiddlewarePostMidYearTestingCensusRecordRunTestMockHandler(),
        getPortalMiddlewarePostMsManagedAccounts401KManagerQuestionnaireMockHandler(),
        getPortalMiddlewarePostMsManagedAccountsActivateMockHandler(),
        getPortalMiddlewarePostMsManagedAccountsDeactivateMockHandler(),
        getPortalMiddlewareGetMsManagedAccountsPreviewAllocationMockHandler(),
        getPortalMiddlewarePostMsManagedAccountsPreviewAllocationMockHandler(),
        getPortalMiddlewareGetDigitalOnboardingStateMockHandler(),
        getPortalMiddlewarePatchDigitalOnboardingStateMockHandler(),
        getPortalMiddlewarePutDigitalOnboardingStateMockHandler(),
        getPortalMiddlewarePatchStatefulSchemaTrackingStatusMockHandler(),
        getPortalMiddlewareGetParticipantByIdMockHandler(),
        getPortalMiddlewareGetParticipantAccountBalanceByIdMockHandler(),
        getPortalMiddlewarePostParticipantLoanMockHandler(),
        getPortalMiddlewareGetParticipantPlaidLinkTokenMockHandler(),
        getPortalMiddlewareGetParticipantPlaidLinksMockHandler(),
        getPortalMiddlewarePostParticipantPlaidLinksMockHandler(),
        getPortalMiddlewareGetParticipantLoanCreateMockHandler(),
        getPortalMiddlewarePatchParticipantLoanMockHandler(),
        getPortalMiddlewarePostLoanManualRepaymentMockHandler(),
        getPortalMiddlewareGetParticipantAccountsMockHandler(),
        getPortalMiddlewareGetParticipantBalanceOverTimeMockHandler(),
        getPortalMiddlewarePutArchiveBankAccountMockHandler(),
        getPortalMiddlewareGetParticipantBankAccountsMockHandler(),
        getPortalMiddlewareGetParticipantDepositsMockHandler(),
        getPortalMiddlewarePostDepositDataMockHandler(),
        getPortalMiddlewareGetParticipantRecurringSchedulesMockHandler(),
        getPortalMiddlewarePutRecurringScheduleMockHandler(),
        getPortalMiddlewareGetDepositMockHandler(),
        getPortalMiddlewareGetRecentParticipantDocumentsMockHandler(),
        getPortalMiddlewarePostParticipantEligibilityMockHandler(),
        getPortalMiddlewarePostEsaGoalMockHandler(),
        getPortalMiddlewareGetParticipantIdentityVerificationMockHandler(),
        getPortalMiddlewarePatchParticipantInfoWithEmailsMockHandler(),
        getPortalMiddlewareGetGoalFeedbackMockHandler(),
        getPortalMiddlewarePostElectionAgeSuggestionMockHandler(),
        getPortalMiddlewarePostElectionRetirementIncomeSuggestionMockHandler(),
        getPortalMiddlewareGetElectionsSetupMockHandler(),
        getPortalMiddlewarePostElectionsSetupMockHandler(),
        getPortalMiddlewareGetInvestmentsModelDisplayMockHandler(),
        getPortalMiddlewareGetPlanParticipantStatsMockHandler(),
        getPortalMiddlewarePostRebalanceRequestMockHandler(),
        getPortalMiddlewarePostRebalanceRequestPreviewMockHandler(),
        getPortalMiddlewareGetRebalanceSettingsMockHandler(),
        getPortalMiddlewarePutRebalanceSettingsMockHandler(),
        getPortalMiddlewareGetStrategiesIndexMockHandler(),
        getPortalMiddlewareGetAgeBasedMockHandler(),
        getPortalMiddlewarePutAgeBasedMockHandler(),
        getPortalMiddlewarePutCustomAllocationMockHandler(),
        getPortalMiddlewareGetRiskBasedMockHandler(),
        getPortalMiddlewarePutRiskBasedMockHandler(),
        getPortalMiddlewareGetRiskModelQuestionnaireMockHandler(),
        getPortalMiddlewareGetMailPreferencesMockHandler(),
        getPortalMiddlewarePutMailPreferencesMockHandler(),
        getPortalMiddlewareGetParticipantOnboardingMockHandler(),
        getPortalMiddlewareGetParticipantOverviewMockHandler(),
        getPortalMiddlewarePostParticipantPlaidLinksBalanceMockHandler(),
        getPortalMiddlewarePostParticipantPlaidLinksBankAccountMockHandler(),
        getPortalMiddlewarePostParticipantDiscardPendingPlaidLinksMockHandler(),
        getPortalMiddlewareGetPositionsMockHandler(),
        getPortalMiddlewareGetQboadWithdrawalsMockHandler(),
        getPortalMiddlewarePatchParticipantRolloverMockHandler(),
        getPortalMiddlewareGetRolloverInstructionsMockHandler(),
        getPortalMiddlewareGetRolloverEligibilityMockHandler(),
        getPortalMiddlewarePostParticipantRolloverMockHandler(),
        getPortalMiddlewareGetParticipantRolloverMockHandler(),
        getPortalMiddlewareGetGenerateRolloverLetterMockHandler(),
        getPortalMiddlewareGetSavingsDisplayMockHandler(),
        getPortalMiddlewarePutSavingsMockHandler(),
        getPortalMiddlewareGetSurveyLinkMockHandler(),
        getPortalMiddlewareGetParticipantAggregatedByCategoryTransactionsMockHandler(),
        getPortalMiddlewareGetAllowedWithdrawalReasonsMockHandler(),
        getPortalMiddlewarePostWithdrawalMockHandler(),
        getPortalMiddlewarePatchOverrideParticipantEligibilityMockHandler(),
        getPortalMiddlewareGetEligibleAutoEnrolledParticipantsMockHandler(),
        getPortalMiddlewareGetParticipantOptOutEmailDownloadMockHandler(),
        getPortalMiddlewareGetOptedOutAutoEnrolledParticipantsMockHandler(),
        getPortalMiddlewareGetUnregisteredParticipantsMockHandler(),
        getPortalMiddlewareGetUnregisteredParticipantsCountMockHandler(),
        getPortalMiddlewarePostParticipantsWelcomeEmailsMockHandler(),
        getPortalMiddlewareGetParticipantWelcomeEmailDownloadMockHandler(),
        getPortalMiddlewareGetParticipantWelcomeEmailsHistoryMockHandler(),
        getPortalMiddlewareGetCalculatedEsaEmployerContributionsMockHandler(),
        getPortalMiddlewareGetCalculatedEmployerMatchContributionMockHandler(),
        getPortalMiddlewarePostParticipantsAutoEnrollOptOutMockHandler(),
        getPortalMiddlewareGetPlanDesignMockHandler(),
        getPortalMiddlewarePatchUpdatePlanDesignMockHandler(),
        getPortalMiddlewareGetPlanDesignTilesMockHandler(),
        getPortalMiddlewareGetPlanParticipantsMockHandler(),
        getPortalMiddlewareGetPlanModelMockHandler(),
        getPortalMiddlewarePatchPlanMockHandler(),
        getPortalMiddlewareGetEsaProgramMockHandler(),
        getPortalMiddlewareGetPlanInvestmentsMockHandler(),
        getPortalMiddlewareGetPlanModelSecuritiesMockHandler(),
        getPortalMiddlewareGetProgramModelsMockHandler(),
        getPortalMiddlewareGetProgramInvestmentOptionsExportMockHandler(),
        getPortalMiddlewareGetProspectusUrlPartsMockHandler(),
        getPortalMiddlewareGetAdvisorReportMockHandler(),
        getPortalMiddlewareGetEmployeeReportMockHandler(),
        getPortalMiddlewareGetUnregisteredParticipantsReportMockHandler(),
        getPortalMiddlewareGetPlanReportMockHandler(),
        getPortalMiddlewareGetSponsorReportMockHandler(),
        getPortalMiddlewareGetSubaTransactionsReportMockHandler(),
        getPortalMiddlewareGetAllSafeHarborContributionTypesMockHandler(),
        getPortalMiddlewareGetSubaExternalMarketValueMockHandler(),
        getPortalMiddlewarePostSubaInitiateExternalTransferMockHandler(),
        getPortalMiddlewareGetSdbaSetupMockHandler(),
        getPortalMiddlewareGetSdbaTransfersInfoMockHandler(),
        getPortalMiddlewareGetCheckActiveSdbaTransfersMockHandler(),
        getPortalMiddlewareGetSessionMockHandler(),
        getPortalMiddlewareGetSponsorAbilitiesMockHandler(),
        getPortalMiddlewareGetAutoEnrollSponsorPlanMockHandler(),
        getPortalMiddlewareGetCensusParticipantsMockHandler(),
        getPortalMiddlewareGetBankAccountMockHandler(),
        getPortalMiddlewarePostBankAccountMockHandler(),
        getPortalMiddlewarePutBankAccountMockHandler(),
        getPortalMiddlewarePutSponsorArchiveBankAccountMockHandler(),
        getPortalMiddlewarePutFeePaymentMethodMockHandler(),
        getPortalMiddlewarePatchSponsorMockHandler(),
        getPortalMiddlewareGetSponsorTeammatesMockHandler(),
        getPortalMiddlewarePatchDeleteTeammateMockHandler(),
        getPortalMiddlewarePostSendUserInviteMockHandler(),
        getPortalMiddlewareGetPlanConfigurationV2MockHandler(),
        getPortalMiddlewarePutPlanConfigurationV2MockHandler(),
        getPortalMiddlewareGetPlanEmployeesV2MockHandler(),
        getPortalMiddlewareGetPlanGrossCompensationV2MockHandler(),
        getPortalMiddlewarePutPlanEmployeeGrossCompensationV2MockHandler(),
        getPortalMiddlewareGetGrossCompensationTemplateV2MockHandler(),
        getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadV2MockHandler(),
        getPortalMiddlewarePostPlanNonEmployeeOwnerV2MockHandler(),
        getPortalMiddlewareGetPlanOfficersV2MockHandler(),
        getPortalMiddlewarePutPlanOfficerStatusV2MockHandler(),
        getPortalMiddlewareDeletePlanOwnerV2MockHandler(),
        getPortalMiddlewareGetPlanOwnersV2MockHandler(),
        getPortalMiddlewarePostPlanEmployeeOwnerV2MockHandler(),
        getPortalMiddlewarePutPlanEmployeeOwnerV2MockHandler(),
        getPortalMiddlewareDeletePlanOwnersFamilyV2MockHandler(),
        getPortalMiddlewareGetPlanOwnersFamilyV2MockHandler(),
        getPortalMiddlewarePutPlanOwnersFamilyV2MockHandler(),
        getPortalMiddlewarePostFileHeadersUpdateMockHandler(),
        getPortalMiddlewareGetContributionsLandingPageDisplayMockHandler(),
        getPortalMiddlewarePostContributionMockHandler(),
        getPortalMiddlewarePostCancelSubmissionMockHandler(),
        getPortalMiddlewarePostCancellationSubmissionMockHandler(),
        getPortalMiddlewareGetParticipantsLoansMockHandler(),
        getPortalMiddlewarePostMatchRemediationContributionMockHandler(),
        getPortalMiddlewarePostOffCycleContributionMockHandler(),
        getPortalMiddlewarePostResumeSubmissionMockHandler(),
        getPortalMiddlewarePostIngestionFlowValidationMockHandler(),
        getPortalMiddlewarePostContributionValidationMockHandler(),
        getPortalMiddlewareGetContributionSubmissionDisplayMockHandler(),
        getPortalMiddlewareGetContributionAdjustmentsMockHandler(),
        getPortalMiddlewarePostContributionConfirmationMockHandler(),
        getPortalMiddlewareGetContributionConfirmationDisplayMockHandler(),
        getPortalMiddlewarePostContributionCorrectionMockHandler(),
        getPortalMiddlewareGetContributionCorrectionsMockHandler(),
        getPortalMiddlewareGetContributionDetailsMockHandler(),
        getPortalMiddlewareGetContributionDisplayMockHandler(),
        getPortalMiddlewarePostContributionUploadMockHandler(),
        getPortalMiddlewareGetDownloadContributionFileMockHandler(),
        getPortalMiddlewareGetForfeitureMockHandler(),
        getPortalMiddlewarePostForfeitureMockHandler(),
        getPortalMiddlewareGetContributionHeaderValidationsMockHandler(),
        getPortalMiddlewareGetNormalizedContributionDataMockHandler(),
        getPortalMiddlewarePostIngestionFlowStartMockHandler(),
        getPortalMiddlewareGetDownloadContributionTemplateMockHandler(),
        getPortalMiddlewareGetUnallocatedFundsMockHandler(),
        getPortalMiddlewareGetContributionValidationPageDisplayMockHandler(),
        getPortalMiddlewareGetContributionValidationMockHandler(),
        getPortalMiddlewareGetDeferralChangesMockHandler(),
        getPortalMiddlewarePatchDeferralChangesActivitiesMockHandler(),
        getPortalMiddlewarePutParticipantMockHandler(),
        getPortalMiddlewareGetEmployeeClassesMockHandler(),
        getPortalMiddlewareGetEmployeesMockHandler(),
        getPortalMiddlewarePutParticipantsMockHandler(),
        getPortalMiddlewarePostUploadCensusOriginalMockHandler(),
        getPortalMiddlewareGetEmployeeDetailsV2MockHandler(),
        getPortalMiddlewarePostValidateEmployeeMockHandler(),
        getPortalMiddlewareGetEmployeeDetailsMockHandler(),
        getPortalMiddlewarePostContactInfoMockHandler(),
        getPortalMiddlewarePutParticipantContributionsMockHandler(),
        getPortalMiddlewareGetSponsorEntityMockHandler(),
        getPortalMiddlewareGetForfeiturePreferenceMockHandler(),
        getPortalMiddlewarePutForfeiturePreferenceMockHandler(),
        getPortalMiddlewareGetHeapDataMockHandler(),
        getPortalMiddlewareGetOnboardingMockHandler(),
        getPortalMiddlewarePostOnboardingMockHandler(),
        getPortalMiddlewarePutOnboardingMockHandler(),
        getPortalMiddlewareGetSponsorOnboardingInformationMockHandler(),
        getPortalMiddlewarePutSponsorOnboardingInformationMockHandler(),
        getPortalMiddlewarePostUploadCensusMockHandler(),
        getPortalMiddlewarePostUploadOnboardingCensusOriginalMockHandler(),
        getPortalMiddlewareGetInitialCensusMockHandler(),
        getPortalMiddlewareDeleteCensusCacheMockHandler(),
        getPortalMiddlewareGetCensusCacheMockHandler(),
        getPortalMiddlewarePostCensusCacheMockHandler(),
        getPortalMiddlewareGetSponsorEsaProgramMockHandler(),
        getPortalMiddlewarePostFinishOnboardingMockHandler(),
        getPortalMiddlewareGetSponsorOnboardingTeammatesMockHandler(),
        getPortalMiddlewarePostSendOnboardingUserInviteMockHandler(),
        getPortalMiddlewareGetNextPayrollDatesMockHandler(),
        getPortalMiddlewareGetPayrollProvidersMockHandler(),
        getPortalMiddlewareGetSponsorPlaidLinkTokenMockHandler(),
        getPortalMiddlewarePostGetSponsorPlaidLinksMockHandler(),
        getPortalMiddlewareGetPlanDesignConsultStateMockHandler(),
        getPortalMiddlewarePatchPlanDesignConsultStateMockHandler(),
        getPortalMiddlewareGetPlanLaunchCallUrlMockHandler(),
        getPortalMiddlewareGetUserRolesMockHandler(),
        getPortalMiddlewareGetPayrollConnectionStatusMockHandler(),
        getPortalMiddlewareGetPayrollConnectionStatusV2MockHandler(),
        getPortalMiddlewareGetPayrollDatesMockHandler(),
        getPortalMiddlewareGetPayrollInfoMockHandler(),
        getPortalMiddlewareGetPayrollSetupsMockHandler(),
        getPortalMiddlewarePostPayrollSetupMockHandler(),
        getPortalMiddlewarePostBulkPayrollSetupDisconnectionMockHandler(),
        getPortalMiddlewareGetPayrollFundingSetupsMockHandler(),
        getPortalMiddlewarePutPayrollProviderMockHandler(),
        getPortalMiddlewarePutPayrollSkipStatusMockHandler(),
        getPortalMiddlewarePutSkipSubmissionMockHandler(),
        getPortalMiddlewareDeletePayrollSetupMockHandler(),
        getPortalMiddlewarePutPayrollDatesMockHandler(),
        getPortalMiddlewarePostPayrollSetupDisconnectionMockHandler(),
        getPortalMiddlewarePutPayrollSetupInfoMockHandler(),
        getPortalMiddlewarePostPayrollValidationsMockHandler(),
        getPortalMiddlewareGetPlanFeaturesMockHandler(),
        getPortalMiddlewareGetPlanOnboardingStatusMockHandler(),
        getPortalMiddlewarePostSponsorPlanDisconnectionMockHandler(),
        getPortalMiddlewareGetPlanStatisticsMockHandler(),
        getPortalMiddlewareGetPlanConfigurationMockHandler(),
        getPortalMiddlewarePutPlanConfigurationMockHandler(),
        getPortalMiddlewareGetPlanEmployeesMockHandler(),
        getPortalMiddlewareGetPlanGrossCompensationMockHandler(),
        getPortalMiddlewarePutPlanEmployeeGrossCompensationMockHandler(),
        getPortalMiddlewareGetGrossCompensationTemplateMockHandler(),
        getPortalMiddlewarePostPlanEmployeeGrossCompensationUploadMockHandler(),
        getPortalMiddlewarePostPlanNonEmployeeOwnerMockHandler(),
        getPortalMiddlewareGetPlanOfficersMockHandler(),
        getPortalMiddlewarePutPlanOfficerStatusMockHandler(),
        getPortalMiddlewareDeletePlanOwnerMockHandler(),
        getPortalMiddlewareGetPlanOwnersMockHandler(),
        getPortalMiddlewarePostPlanEmployeeOwnerMockHandler(),
        getPortalMiddlewarePutPlanEmployeeOwnerMockHandler(),
        getPortalMiddlewareDeletePlanOwnersFamilyMockHandler(),
        getPortalMiddlewareGetPlanOwnersFamilyMockHandler(),
        getPortalMiddlewarePutPlanOwnersFamilyMockHandler(),
        getPortalMiddlewareGetTrackerDetailsMockHandler(),
        getPortalMiddlewarePostPriorProviderMockHandler(),
        getPortalMiddlewareGetPriorProvidersMockHandler(),
        getPortalMiddlewareGetSponsorQuestionnaireMockHandler(),
        getPortalMiddlewarePatchSponsorQuestionnaireMockHandler(),
        getPortalMiddlewareGetQuestionnaireInformationMockHandler(),
        getPortalMiddlewareGetContributionsMockHandler(),
        getPortalMiddlewareGetSubaPlanDetailsMockHandler(),
        getPortalMiddlewareGetSubaTransactionsMockHandler(),
        getPortalMiddlewarePostYetCensusAutosaveMockHandler(),
        getPortalMiddlewareGetYetCensusDataDownloadMockHandler(),
        getPortalMiddlewareGetYetCensusDataPagedMockHandler(),
        getPortalMiddlewarePostRefreshCensusMockHandler(),
        getPortalMiddlewarePostRestartCensusMockHandler(),
        getPortalMiddlewarePostYetCensusStartMockHandler(),
        getPortalMiddlewareGetCensusStatusMockHandler(),
        getPortalMiddlewarePostYetCensusSubmitMockHandler(),
        getPortalMiddlewarePostYetCensusUploadMockHandler(),
        getPortalMiddlewareGetYetChecklistMockHandler(),
        getPortalMiddlewarePatchYetChecklistMockHandler(),
        getPortalMiddlewareGetYetConfigMockHandler(),
        getPortalMiddlewarePostContributionsFundMockHandler(),
        getPortalMiddlewarePostContributionsRefundMockHandler(),
        getPortalMiddlewareGetYetDocumentsMockHandler(),
        getPortalMiddlewarePostStartOfPackagingMockHandler(),
        getPortalMiddlewareGetPlanTestResultsMockHandler(),
        getPortalMiddlewareGetYetSponsorQuestionnaireMockHandler(),
        getPortalMiddlewarePostYetSponsorQuestionnaireMockHandler(),
        getPortalMiddlewarePostRestartTestingProcessMockHandler(),
        getPortalMiddlewareGetYetStatusMockHandler(),
        getPortalMiddlewareGetYtdContributionsMockHandler(),
        getPortalMiddlewareGetTiaaIncomeProjectionMockHandler(),
        getPortalMiddlewarePatchParticipantByIdMockHandler(),
        getPortalMiddlewareGetParticipantBeneficiariesMockHandler(),
        getPortalMiddlewarePutParticipantBeneficiariesV2MockHandler(),
        getPortalMiddlewareGetPlanByIdV2MockHandler(),
        getPortalMiddlewareGetVestingScheduleMockHandler(),
        getPortalMiddlewareGetVssPlanByIdMockHandler(),
        getPortalMiddlewareGetVssStatusMockHandler(),
        getPortalMiddlewarePostLobLetterEventsWebhookMockHandler(),
        getPortalMiddlewareGetWhiteLabelMockHandler(),
        getPortalMiddlewareGetWhiteLabelUnauthorizedMockHandler(),
        getPortalMiddlewarePostCreateWithdrawalMockHandler(),
        getPortalMiddlewareGetParticipantCostBasisMockHandler(),
        getPortalMiddlewarePostWithdrawalIdentityVerificationMockHandler(),
        getPortalMiddlewareGetRmdAmountMockHandler(),
        getPortalMiddlewareGetRmdBalanceMockHandler(),
        getPortalMiddlewareGetRolloverProvidersMockHandler(),
        getPortalMiddlewareGetWithholdingMockHandler(),
        getPortalMiddlewareGetWithholdingDetailMockHandler(),
        getPortalMiddlewareGetYetNaicsMockHandler(),
        getPortalMiddlewareGetZendeskJwtMockHandler(),
        getPortalMiddlewareGetEntitySessionMockHandler(),
        getHealthGetPublicRouteMockHandler(),
        getWentworthHealthGetConnectivityMockHandler(),
        getWentworthHealthPostDemoSdkMockHandler(),
        getWentworthHealthGetHealthMockHandler(),
        getWentworthBalanceGetActivitySummaryMockHandler(),
        getWentworthBalanceGetCurrentBalanceMockHandler(),
        getWentworthBalanceGetBalanceOverTimeMockHandler(),
        getWentworthBalanceGetBalancesGroupedBySourceMockHandler(),
        getWentworthContributionsGetCompletedContributionsMockHandler(),
        getWentworthContributionsGetContributionDetailsMockHandler(),
        getWentworthContributionsGetPendingContributionsMockHandler(),
        getWentworthContributionsGetTotalContributedMockHandler(),
        getWentworthContributionsGetYearlyContributionsMockHandler(),
        getWentworthInvestmentsGetInvestmentPositionsMockHandler(),
        getWentworthBalanceGetLoanBalanceMockHandler(),
        getWentworthBalanceGetRateOfReturnMockHandler(),
        getWentworthContributionsGetCanceledRolloversMockHandler(),
        getWentworthContributionsGetPendingRolloversMockHandler(),
        getWentworthTransactionsGetAllTransactionsMockHandler(),
        getWentworthTransactionsGetTransactionsReportMockHandler(),
        getWentworthBalanceGetVestedBalanceMockHandler(),
        getWentworthWithdrawalGetPendingWithdrawalsMockHandler()
    ];

//# sourceMappingURL=index.js.map